;
(function () {
  var customizeryConfig = {
    "enabled": true,
    "optionSets": [],
    "css": "",
    "validate": "bound",
    "dynamicBundlePriceBlock": true,
    "autoInject": true,
    "initializedTheme": "Willygoat-Warehouse - V2.6.1 - Quote",
    "currentTheme": "willygoat-theme\/willygoat-snize"
  };
  var UUID = "willygoat";
  var DEV_MODE = false;
  var loadConfig = true;
  var autoInject = true;
  var cdnPath = "\/\/d1liekpayvooaz.cloudfront.net\/apps\/customizery";
  ! function (e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function (e) {
      if (!e.document) throw new Error("jQuery requires a window with a document");
      return t(e)
    } : t(e)
  }("undefined" != typeof window ? window : this, function (e, t) {
    var n = [],
      i = n.slice,
      o = n.concat,
      r = n.push,
      a = n.indexOf,
      s = {},
      p = s.toString,
      c = s.hasOwnProperty,
      d = {},
      l = "1.11.3",
      u = function (e, t) {
        return new u.fn.init(e, t)
      },
      f = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      h = /^-ms-/,
      m = /-([\da-z])/gi,
      g = function (e, t) {
        return t.toUpperCase()
      };
    u.fn = u.prototype = {
      jquery: l,
      constructor: u,
      selector: "",
      length: 0,
      toArray: function () {
        return i.call(this)
      },
      get: function (e) {
        return null != e ? 0 > e ? this[e + this.length] : this[e] : i.call(this)
      },
      pushStack: function (e) {
        var t = u.merge(this.constructor(), e);
        return t.prevObject = this, t.context = this.context, t
      },
      each: function (e, t) {
        return u.each(this, e, t)
      },
      map: function (e) {
        return this.pushStack(u.map(this, function (t, n) {
          return e.call(t, n, t)
        }))
      },
      slice: function () {
        return this.pushStack(i.apply(this, arguments))
      },
      first: function () {
        return this.eq(0)
      },
      last: function () {
        return this.eq(-1)
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (0 > e ? t : 0);
        return this.pushStack(n >= 0 && t > n ? [this[n]] : [])
      },
      end: function () {
        return this.prevObject || this.constructor(null)
      },
      push: r,
      sort: n.sort,
      splice: n.splice
    }, u.extend = u.fn.extend = function () {
      var e, t, n, i, o, r, a = arguments[0] || {},
        s = 1,
        p = arguments.length,
        c = !1;
      for ("boolean" == typeof a && (c = a, a = arguments[s] || {}, s++), "object" == typeof a || u.isFunction(a) || (a = {}), s === p && (a = this, s--); p > s; s++)
        if (null != (o = arguments[s]))
          for (i in o) e = a[i], n = o[i], a !== n && (c && n && (u.isPlainObject(n) || (t = u.isArray(n))) ? (t ? (t = !1, r = e && u.isArray(e) ? e : []) : r = e && u.isPlainObject(e) ? e : {}, a[i] = u.extend(c, r, n)) : void 0 !== n && (a[i] = n));
      return a
    }, u.extend({
      expando: "jQuery" + (l + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e)
      },
      noop: function () {},
      isFunction: function (e) {
        return "function" === u.type(e)
      },
      isArray: Array.isArray || function (e) {
        return "array" === u.type(e)
      },
      isWindow: function (e) {
        return null != e && e == e.window
      },
      isNumeric: function (e) {
        return !u.isArray(e) && e - parseFloat(e) + 1 >= 0
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0
      },
      isPlainObject: function (e) {
        var t;
        if (!e || "object" !== u.type(e) || e.nodeType || u.isWindow(e)) return !1;
        try {
          if (e.constructor && !c.call(e, "constructor") && !c.call(e.constructor.prototype, "isPrototypeOf")) return !1
        } catch (n) {
          return !1
        }
        if (d.ownLast)
          for (t in e) return c.call(e, t);
        for (t in e);
        return void 0 === t || c.call(e, t)
      },
      type: function (e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? s[p.call(e)] || "object" : typeof e
      },
      globalEval: function (t) {
        t && u.trim(t) && (e.execScript || function (t) {
          e.eval.call(e, t)
        })(t)
      },
      camelCase: function (e) {
        return e.replace(h, "ms-").replace(m, g)
      },
      nodeName: function (e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
      },
      each: function (e, t, n) {
        var i, o = 0,
          r = e.length,
          a = v(e);
        if (n) {
          if (a)
            for (; r > o && (i = t.apply(e[o], n), i !== !1); o++);
          else
            for (o in e)
              if (i = t.apply(e[o], n), i === !1) break
        } else if (a)
          for (; r > o && (i = t.call(e[o], o, e[o]), i !== !1); o++);
        else
          for (o in e)
            if (i = t.call(e[o], o, e[o]), i === !1) break;
        return e
      },
      trim: function (e) {
        return null == e ? "" : (e + "").replace(f, "")
      },
      makeArray: function (e, t) {
        var n = t || [];
        return null != e && (v(Object(e)) ? u.merge(n, "string" == typeof e ? [e] : e) : r.call(n, e)), n
      },
      inArray: function (e, t, n) {
        var i;
        if (t) {
          if (a) return a.call(t, e, n);
          for (i = t.length, n = n ? 0 > n ? Math.max(0, i + n) : n : 0; i > n; n++)
            if (n in t && t[n] === e) return n
        }
        return -1
      },
      merge: function (e, t) {
        for (var n = +t.length, i = 0, o = e.length; n > i;) e[o++] = t[i++];
        if (n !== n)
          for (; void 0 !== t[i];) e[o++] = t[i++];
        return e.length = o, e
      },
      grep: function (e, t, n) {
        for (var i, o = [], r = 0, a = e.length, s = !n; a > r; r++) i = !t(e[r], r), i !== s && o.push(e[r]);
        return o
      },
      map: function (e, t, n) {
        var i, r = 0,
          a = e.length,
          s = v(e),
          p = [];
        if (s)
          for (; a > r; r++) i = t(e[r], r, n), null != i && p.push(i);
        else
          for (r in e) i = t(e[r], r, n), null != i && p.push(i);
        return o.apply([], p)
      },
      guid: 1,
      proxy: function (e, t) {
        var n, o, r;
        return "string" == typeof t && (r = e[t], t = e, e = r), u.isFunction(e) ? (n = i.call(arguments, 2), o = function () {
          return e.apply(t || this, n.concat(i.call(arguments)))
        }, o.guid = e.guid = e.guid || u.guid++, o) : void 0
      },
      now: function () {
        return +new Date
      },
      support: d
    }), u.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (e, t) {
      s["[object " + t + "]"] = t.toLowerCase()
    });

    function v(e) {
      var t = "length" in e && e.length,
        n = u.type(e);
      return "function" !== n && !u.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e))
    }
    var y = function (e) {
      var t, n, i, o, r, a, s, p, c, d, l, u, f, h, m, g, v, y, w, b = "sizzle" + 1 * new Date,
        x = e.document,
        C = 0,
        S = 0,
        k = se(),
        T = se(),
        E = se(),
        $ = function (e, t) {
          return e === t && (l = !0), 0
        },
        M = 1 << 31,
        _ = {}.hasOwnProperty,
        N = [],
        A = N.pop,
        L = N.push,
        I = N.push,
        j = N.slice,
        P = function (e, t) {
          for (var n = 0, i = e.length; i > n; n++)
            if (e[n] === t) return n;
          return -1
        },
        D = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        O = "[\\x20\\t\\r\\n\\f]",
        H = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        q = H.replace("w", "w#"),
        F = "\\[" + O + "*(" + H + ")(?:" + O + "*([*^$|!~]?=)" + O + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + q + "))|)" + O + "*\\]",
        R = ":(" + H + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + F + ")*)|.*)\\)|)",
        V = new RegExp(O + "+", "g"),
        B = new RegExp("^" + O + "+|((?:^|[^\\\\])(?:\\\\.)*)" + O + "+$", "g"),
        z = new RegExp("^" + O + "*," + O + "*"),
        W = new RegExp("^" + O + "*([>+~]|" + O + ")" + O + "*"),
        U = new RegExp("=" + O + "*([^\\]'\"]*?)" + O + "*\\]", "g"),
        X = new RegExp(R),
        J = new RegExp("^" + q + "$"),
        Q = {
          ID: new RegExp("^#(" + H + ")"),
          CLASS: new RegExp("^\\.(" + H + ")"),
          TAG: new RegExp("^(" + H.replace("w", "w*") + ")"),
          ATTR: new RegExp("^" + F),
          PSEUDO: new RegExp("^" + R),
          CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + O + "*(even|odd|(([+-]|)(\\d*)n|)" + O + "*(?:([+-]|)" + O + "*(\\d+)|))" + O + "*\\)|)", "i"),
          bool: new RegExp("^(?:" + D + ")$", "i"),
          needsContext: new RegExp("^" + O + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + O + "*((?:-\\d)?\\d*)" + O + "*\\)|)(?=[^-]|$)", "i")
        },
        G = /^(?:input|select|textarea|button)$/i,
        Y = /^h\d$/i,
        K = /^[^{]+\{\s*\[native \w/,
        Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ee = /[+~]/,
        te = /'|\\/g,
        ne = new RegExp("\\\\([\\da-f]{1,6}" + O + "?|(" + O + ")|.)", "ig"),
        ie = function (e, t, n) {
          var i = "0x" + t - 65536;
          return i !== i || n ? t : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
        },
        oe = function () {
          u()
        };
      try {
        I.apply(N = j.call(x.childNodes), x.childNodes), N[x.childNodes.length].nodeType
      } catch (re) {
        I = {
          apply: N.length ? function (e, t) {
            L.apply(e, j.call(t))
          } : function (e, t) {
            for (var n = e.length, i = 0; e[n++] = t[i++];);
            e.length = n - 1
          }
        }
      }

      function ae(e, t, i, o) {
        var r, s, c, d, l, h, v, y, C, S;
        if ((t ? t.ownerDocument || t : x) !== f && u(t), t = t || f, i = i || [], d = t.nodeType, "string" != typeof e || !e || 1 !== d && 9 !== d && 11 !== d) return i;
        if (!o && m) {
          if (11 !== d && (r = Z.exec(e)))
            if (c = r[1]) {
              if (9 === d) {
                if (s = t.getElementById(c), !s || !s.parentNode) return i;
                if (s.id === c) return i.push(s), i
              } else if (t.ownerDocument && (s = t.ownerDocument.getElementById(c)) && w(t, s) && s.id === c) return i.push(s), i
            } else {
              if (r[2]) return I.apply(i, t.getElementsByTagName(e)), i;
              if ((c = r[3]) && n.getElementsByClassName) return I.apply(i, t.getElementsByClassName(c)), i
            } if (n.qsa && (!g || !g.test(e))) {
            if (y = v = b, C = t, S = 1 !== d && e, 1 === d && "object" !== t.nodeName.toLowerCase()) {
              for (h = a(e), (v = t.getAttribute("id")) ? y = v.replace(te, "\\$&") : t.setAttribute("id", y), y = "[id='" + y + "'] ", l = h.length; l--;) h[l] = y + ve(h[l]);
              C = ee.test(e) && me(t.parentNode) || t, S = h.join(",")
            }
            if (S) try {
              return I.apply(i, C.querySelectorAll(S)), i
            } catch (k) {} finally {
              v || t.removeAttribute("id")
            }
          }
        }
        return p(e.replace(B, "$1"), t, i, o)
      }

      function se() {
        var e = [];

        function t(n, o) {
          return e.push(n + " ") > i.cacheLength && delete t[e.shift()], t[n + " "] = o
        }
        return t
      }

      function pe(e) {
        return e[b] = !0, e
      }

      function ce(e) {
        var t = f.createElement("div");
        try {
          return !!e(t)
        } catch (n) {
          return !1
        } finally {
          t.parentNode && t.parentNode.removeChild(t), t = null
        }
      }

      function de(e, t) {
        for (var n = e.split("|"), o = e.length; o--;) i.attrHandle[n[o]] = t
      }

      function le(e, t) {
        var n = t && e,
          i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || M) - (~e.sourceIndex || M);
        if (i) return i;
        if (n)
          for (; n = n.nextSibling;)
            if (n === t) return -1;
        return e ? 1 : -1
      }

      function ue(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return "input" === n && t.type === e
        }
      }

      function fe(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return ("input" === n || "button" === n) && t.type === e
        }
      }

      function he(e) {
        return pe(function (t) {
          return t = +t, pe(function (n, i) {
            for (var o, r = e([], n.length, t), a = r.length; a--;) n[o = r[a]] && (n[o] = !(i[o] = n[o]))
          })
        })
      }

      function me(e) {
        return e && "undefined" != typeof e.getElementsByTagName && e
      }
      n = ae.support = {}, r = ae.isXML = function (e) {
        var t = e && (e.ownerDocument || e).documentElement;
        return !!t && "HTML" !== t.nodeName
      }, u = ae.setDocument = function (e) {
        var t, o, a = e ? e.ownerDocument || e : x;
        return a !== f && 9 === a.nodeType && a.documentElement ? (f = a, h = a.documentElement, o = a.defaultView, o && o !== o.top && (o.addEventListener ? o.addEventListener("unload", oe, !1) : o.attachEvent && o.attachEvent("onunload", oe)), m = !r(a), n.attributes = ce(function (e) {
          return e.className = "i", !e.getAttribute("className")
        }), n.getElementsByTagName = ce(function (e) {
          return e.appendChild(a.createComment("")), !e.getElementsByTagName("*").length
        }), n.getElementsByClassName = K.test(a.getElementsByClassName), n.getById = ce(function (e) {
          return h.appendChild(e).id = b, !a.getElementsByName || !a.getElementsByName(b).length
        }), n.getById ? (i.find.ID = function (e, t) {
          if ("undefined" != typeof t.getElementById && m) {
            var n = t.getElementById(e);
            return n && n.parentNode ? [n] : []
          }
        }, i.filter.ID = function (e) {
          var t = e.replace(ne, ie);
          return function (e) {
            return e.getAttribute("id") === t
          }
        }) : (delete i.find.ID, i.filter.ID = function (e) {
          var t = e.replace(ne, ie);
          return function (e) {
            var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
            return n && n.value === t
          }
        }), i.find.TAG = n.getElementsByTagName ? function (e, t) {
          return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0
        } : function (e, t) {
          var n, i = [],
            o = 0,
            r = t.getElementsByTagName(e);
          if ("*" === e) {
            for (; n = r[o++];) 1 === n.nodeType && i.push(n);
            return i
          }
          return r
        }, i.find.CLASS = n.getElementsByClassName && function (e, t) {
          return m ? t.getElementsByClassName(e) : void 0
        }, v = [], g = [], (n.qsa = K.test(a.querySelectorAll)) && (ce(function (e) {
          h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\f]' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + O + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + O + "*(?:value|" + D + ")"), e.querySelectorAll("[id~=" + b + "-]").length || g.push("~="), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + b + "+*").length || g.push(".#.+[+~]")
        }), ce(function (e) {
          var t = a.createElement("input");
          t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + O + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:")
        })), (n.matchesSelector = K.test(y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && ce(function (e) {
          n.disconnectedMatch = y.call(e, "div"), y.call(e, "[s!='']:x"), v.push("!=", R)
        }), g = g.length && new RegExp(g.join("|")), v = v.length && new RegExp(v.join("|")), t = K.test(h.compareDocumentPosition), w = t || K.test(h.contains) ? function (e, t) {
          var n = 9 === e.nodeType ? e.documentElement : e,
            i = t && t.parentNode;
          return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
        } : function (e, t) {
          if (t)
            for (; t = t.parentNode;)
              if (t === e) return !0;
          return !1
        }, $ = t ? function (e, t) {
          if (e === t) return l = !0, 0;
          var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
          return i ? i : (i = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & i || !n.sortDetached && t.compareDocumentPosition(e) === i ? e === a || e.ownerDocument === x && w(x, e) ? -1 : t === a || t.ownerDocument === x && w(x, t) ? 1 : d ? P(d, e) - P(d, t) : 0 : 4 & i ? -1 : 1)
        } : function (e, t) {
          if (e === t) return l = !0, 0;
          var n, i = 0,
            o = e.parentNode,
            r = t.parentNode,
            s = [e],
            p = [t];
          if (!o || !r) return e === a ? -1 : t === a ? 1 : o ? -1 : r ? 1 : d ? P(d, e) - P(d, t) : 0;
          if (o === r) return le(e, t);
          for (n = e; n = n.parentNode;) s.unshift(n);
          for (n = t; n = n.parentNode;) p.unshift(n);
          for (; s[i] === p[i];) i++;
          return i ? le(s[i], p[i]) : s[i] === x ? -1 : p[i] === x ? 1 : 0
        }, a) : f
      }, ae.matches = function (e, t) {
        return ae(e, null, null, t)
      }, ae.matchesSelector = function (e, t) {
        if ((e.ownerDocument || e) !== f && u(e), t = t.replace(U, "='$1']"), !(!n.matchesSelector || !m || v && v.test(t) || g && g.test(t))) try {
          var i = y.call(e, t);
          if (i || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
        } catch (o) {}
        return ae(t, f, null, [e]).length > 0
      }, ae.contains = function (e, t) {
        return (e.ownerDocument || e) !== f && u(e), w(e, t)
      }, ae.attr = function (e, t) {
        (e.ownerDocument || e) !== f && u(e);
        var o = i.attrHandle[t.toLowerCase()],
          r = o && _.call(i.attrHandle, t.toLowerCase()) ? o(e, t, !m) : void 0;
        return void 0 !== r ? r : n.attributes || !m ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
      }, ae.error = function (e) {
        throw new Error("Syntax error, unrecognized expression: " + e)
      }, ae.uniqueSort = function (e) {
        var t, i = [],
          o = 0,
          r = 0;
        if (l = !n.detectDuplicates, d = !n.sortStable && e.slice(0), e.sort($), l) {
          for (; t = e[r++];) t === e[r] && (o = i.push(r));
          for (; o--;) e.splice(i[o], 1)
        }
        return d = null, e
      }, o = ae.getText = function (e) {
        var t, n = "",
          i = 0,
          r = e.nodeType;
        if (r) {
          if (1 === r || 9 === r || 11 === r) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) n += o(e)
          } else if (3 === r || 4 === r) return e.nodeValue
        } else
          for (; t = e[i++];) n += o(t);
        return n
      }, i = ae.selectors = {
        cacheLength: 50,
        createPseudo: pe,
        match: Q,
        attrHandle: {},
        find: {},
        relative: {
          ">": {
            dir: "parentNode",
            first: !0
          },
          " ": {
            dir: "parentNode"
          },
          "+": {
            dir: "previousSibling",
            first: !0
          },
          "~": {
            dir: "previousSibling"
          }
        },
        preFilter: {
          ATTR: function (e) {
            return e[1] = e[1].replace(ne, ie), e[3] = (e[3] || e[4] || e[5] || "").replace(ne, ie), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
          },
          CHILD: function (e) {
            return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && ae.error(e[0]), e
          },
          PSEUDO: function (e) {
            var t, n = !e[6] && e[2];
            return Q.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
          }
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(ne, ie).toLowerCase();
            return "*" === e ? function () {
              return !0
            } : function (e) {
              return e.nodeName && e.nodeName.toLowerCase() === t
            }
          },
          CLASS: function (e) {
            var t = k[e + " "];
            return t || (t = new RegExp("(^|" + O + ")" + e + "(" + O + "|$)")) && k(e, function (e) {
              return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "")
            })
          },
          ATTR: function (e, t, n) {
            return function (i) {
              var o = ae.attr(i, e);
              return null == o ? "!=" === t : !t || (o += "", "=" === t ? o === n : "!=" === t ? o !== n : "^=" === t ? n && 0 === o.indexOf(n) : "*=" === t ? n && o.indexOf(n) > -1 : "$=" === t ? n && o.slice(-n.length) === n : "~=" === t ? (" " + o.replace(V, " ") + " ").indexOf(n) > -1 : "|=" === t && (o === n || o.slice(0, n.length + 1) === n + "-"))
            }
          },
          CHILD: function (e, t, n, i, o) {
            var r = "nth" !== e.slice(0, 3),
              a = "last" !== e.slice(-4),
              s = "of-type" === t;
            return 1 === i && 0 === o ? function (e) {
              return !!e.parentNode
            } : function (t, n, p) {
              var c, d, l, u, f, h, m = r !== a ? "nextSibling" : "previousSibling",
                g = t.parentNode,
                v = s && t.nodeName.toLowerCase(),
                y = !p && !s;
              if (g) {
                if (r) {
                  for (; m;) {
                    for (l = t; l = l[m];)
                      if (s ? l.nodeName.toLowerCase() === v : 1 === l.nodeType) return !1;
                    h = m = "only" === e && !h && "nextSibling"
                  }
                  return !0
                }
                if (h = [a ? g.firstChild : g.lastChild], a && y) {
                  for (d = g[b] || (g[b] = {}), c = d[e] || [], f = c[0] === C && c[1], u = c[0] === C && c[2], l = f && g.childNodes[f]; l = ++f && l && l[m] || (u = f = 0) || h.pop();)
                    if (1 === l.nodeType && ++u && l === t) {
                      d[e] = [C, f, u];
                      break
                    }
                } else if (y && (c = (t[b] || (t[b] = {}))[e]) && c[0] === C) u = c[1];
                else
                  for (;
                    (l = ++f && l && l[m] || (u = f = 0) || h.pop()) && ((s ? l.nodeName.toLowerCase() !== v : 1 !== l.nodeType) || !++u || (y && ((l[b] || (l[b] = {}))[e] = [C, u]), l !== t)););
                return u -= o, u === i || u % i === 0 && u / i >= 0
              }
            }
          },
          PSEUDO: function (e, t) {
            var n, o = i.pseudos[e] || i.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
            return o[b] ? o(t) : o.length > 1 ? (n = [e, e, "", t], i.setFilters.hasOwnProperty(e.toLowerCase()) ? pe(function (e, n) {
              for (var i, r = o(e, t), a = r.length; a--;) i = P(e, r[a]), e[i] = !(n[i] = r[a])
            }) : function (e) {
              return o(e, 0, n)
            }) : o
          }
        },
        pseudos: {
          not: pe(function (e) {
            var t = [],
              n = [],
              i = s(e.replace(B, "$1"));
            return i[b] ? pe(function (e, t, n, o) {
              for (var r, a = i(e, null, o, []), s = e.length; s--;)(r = a[s]) && (e[s] = !(t[s] = r))
            }) : function (e, o, r) {
              return t[0] = e, i(t, null, r, n), t[0] = null, !n.pop()
            }
          }),
          has: pe(function (e) {
            return function (t) {
              return ae(e, t).length > 0
            }
          }),
          contains: pe(function (e) {
            return e = e.replace(ne, ie),
              function (t) {
                return (t.textContent || t.innerText || o(t)).indexOf(e) > -1
              }
          }),
          lang: pe(function (e) {
            return J.test(e || "") || ae.error("unsupported lang: " + e), e = e.replace(ne, ie).toLowerCase(),
              function (t) {
                var n;
                do
                  if (n = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return n = n.toLowerCase(), n === e || 0 === n.indexOf(e + "-"); while ((t = t.parentNode) && 1 === t.nodeType);
                return !1
              }
          }),
          target: function (t) {
            var n = e.location && e.location.hash;
            return n && n.slice(1) === t.id
          },
          root: function (e) {
            return e === h
          },
          focus: function (e) {
            return e === f.activeElement && (!f.hasFocus || f.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
          },
          enabled: function (e) {
            return e.disabled === !1
          },
          disabled: function (e) {
            return e.disabled === !0
          },
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return "input" === t && !!e.checked || "option" === t && !!e.selected
          },
          selected: function (e) {
            return e.parentNode && e.parentNode.selectedIndex, e.selected === !0
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0
          },
          parent: function (e) {
            return !i.pseudos.empty(e)
          },
          header: function (e) {
            return Y.test(e.nodeName)
          },
          input: function (e) {
            return G.test(e.nodeName)
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return "input" === t && "button" === e.type || "button" === t
          },
          text: function (e) {
            var t;
            return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
          },
          first: he(function () {
            return [0]
          }),
          last: he(function (e, t) {
            return [t - 1]
          }),
          eq: he(function (e, t, n) {
            return [0 > n ? n + t : n]
          }),
          even: he(function (e, t) {
            for (var n = 0; t > n; n += 2) e.push(n);
            return e
          }),
          odd: he(function (e, t) {
            for (var n = 1; t > n; n += 2) e.push(n);
            return e
          }),
          lt: he(function (e, t, n) {
            for (var i = 0 > n ? n + t : n; --i >= 0;) e.push(i);
            return e
          }),
          gt: he(function (e, t, n) {
            for (var i = 0 > n ? n + t : n; ++i < t;) e.push(i);
            return e
          })
        }
      }, i.pseudos.nth = i.pseudos.eq;
      for (t in {
          radio: !0,
          checkbox: !0,
          file: !0,
          password: !0,
          image: !0
        }) i.pseudos[t] = ue(t);
      for (t in {
          submit: !0,
          reset: !0
        }) i.pseudos[t] = fe(t);

      function ge() {}
      ge.prototype = i.filters = i.pseudos, i.setFilters = new ge, a = ae.tokenize = function (e, t) {
        var n, o, r, a, s, p, c, d = T[e + " "];
        if (d) return t ? 0 : d.slice(0);
        for (s = e, p = [], c = i.preFilter; s;) {
          (!n || (o = z.exec(s))) && (o && (s = s.slice(o[0].length) || s), p.push(r = [])), n = !1, (o = W.exec(s)) && (n = o.shift(), r.push({
            value: n,
            type: o[0].replace(B, " ")
          }), s = s.slice(n.length));
          for (a in i.filter) !(o = Q[a].exec(s)) || c[a] && !(o = c[a](o)) || (n = o.shift(), r.push({
            value: n,
            type: a,
            matches: o
          }), s = s.slice(n.length));
          if (!n) break
        }
        return t ? s.length : s ? ae.error(e) : T(e, p).slice(0)
      };

      function ve(e) {
        for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
        return i
      }

      function ye(e, t, n) {
        var i = t.dir,
          o = n && "parentNode" === i,
          r = S++;
        return t.first ? function (t, n, r) {
          for (; t = t[i];)
            if (1 === t.nodeType || o) return e(t, n, r)
        } : function (t, n, a) {
          var s, p, c = [C, r];
          if (a) {
            for (; t = t[i];)
              if ((1 === t.nodeType || o) && e(t, n, a)) return !0
          } else
            for (; t = t[i];)
              if (1 === t.nodeType || o) {
                if (p = t[b] || (t[b] = {}), (s = p[i]) && s[0] === C && s[1] === r) return c[2] = s[2];
                if (p[i] = c, c[2] = e(t, n, a)) return !0
              }
        }
      }

      function we(e) {
        return e.length > 1 ? function (t, n, i) {
          for (var o = e.length; o--;)
            if (!e[o](t, n, i)) return !1;
          return !0
        } : e[0]
      }

      function be(e, t, n) {
        for (var i = 0, o = t.length; o > i; i++) ae(e, t[i], n);
        return n
      }

      function xe(e, t, n, i, o) {
        for (var r, a = [], s = 0, p = e.length, c = null != t; p > s; s++)(r = e[s]) && (!n || n(r, i, o)) && (a.push(r), c && t.push(s));
        return a
      }

      function Ce(e, t, n, i, o, r) {
        return i && !i[b] && (i = Ce(i)), o && !o[b] && (o = Ce(o, r)), pe(function (r, a, s, p) {
          var c, d, l, u = [],
            f = [],
            h = a.length,
            m = r || be(t || "*", s.nodeType ? [s] : s, []),
            g = !e || !r && t ? m : xe(m, u, e, s, p),
            v = n ? o || (r ? e : h || i) ? [] : a : g;
          if (n && n(g, v, s, p), i)
            for (c = xe(v, f), i(c, [], s, p), d = c.length; d--;)(l = c[d]) && (v[f[d]] = !(g[f[d]] = l));
          if (r) {
            if (o || e) {
              if (o) {
                for (c = [], d = v.length; d--;)(l = v[d]) && c.push(g[d] = l);
                o(null, v = [], c, p)
              }
              for (d = v.length; d--;)(l = v[d]) && (c = o ? P(r, l) : u[d]) > -1 && (r[c] = !(a[c] = l))
            }
          } else v = xe(v === a ? v.splice(h, v.length) : v), o ? o(null, a, v, p) : I.apply(a, v)
        })
      }

      function Se(e) {
        for (var t, n, o, r = e.length, a = i.relative[e[0].type], s = a || i.relative[" "], p = a ? 1 : 0, d = ye(function (e) {
            return e === t
          }, s, !0), l = ye(function (e) {
            return P(t, e) > -1
          }, s, !0), u = [function (e, n, i) {
            var o = !a && (i || n !== c) || ((t = n).nodeType ? d(e, n, i) : l(e, n, i));
            return t = null, o
          }]; r > p; p++)
          if (n = i.relative[e[p].type]) u = [ye(we(u), n)];
          else {
            if (n = i.filter[e[p].type].apply(null, e[p].matches), n[b]) {
              for (o = ++p; r > o && !i.relative[e[o].type]; o++);
              return Ce(p > 1 && we(u), p > 1 && ve(e.slice(0, p - 1).concat({
                value: " " === e[p - 2].type ? "*" : ""
              })).replace(B, "$1"), n, o > p && Se(e.slice(p, o)), r > o && Se(e = e.slice(o)), r > o && ve(e))
            }
            u.push(n)
          } return we(u)
      }

      function ke(e, t) {
        var n = t.length > 0,
          o = e.length > 0,
          r = function (r, a, s, p, d) {
            var l, u, h, m = 0,
              g = "0",
              v = r && [],
              y = [],
              w = c,
              b = r || o && i.find.TAG("*", d),
              x = C += null == w ? 1 : Math.random() || .1,
              S = b.length;
            for (d && (c = a !== f && a); g !== S && null != (l = b[g]); g++) {
              if (o && l) {
                for (u = 0; h = e[u++];)
                  if (h(l, a, s)) {
                    p.push(l);
                    break
                  } d && (C = x)
              }
              n && ((l = !h && l) && m--, r && v.push(l))
            }
            if (m += g, n && g !== m) {
              for (u = 0; h = t[u++];) h(v, y, a, s);
              if (r) {
                if (m > 0)
                  for (; g--;) v[g] || y[g] || (y[g] = A.call(p));
                y = xe(y)
              }
              I.apply(p, y), d && !r && y.length > 0 && m + t.length > 1 && ae.uniqueSort(p)
            }
            return d && (C = x, c = w), v
          };
        return n ? pe(r) : r
      }
      return s = ae.compile = function (e, t) {
        var n, i = [],
          o = [],
          r = E[e + " "];
        if (!r) {
          for (t || (t = a(e)), n = t.length; n--;) r = Se(t[n]), r[b] ? i.push(r) : o.push(r);
          r = E(e, ke(o, i)), r.selector = e
        }
        return r
      }, p = ae.select = function (e, t, o, r) {
        var p, c, d, l, u, f = "function" == typeof e && e,
          h = !r && a(e = f.selector || e);
        if (o = o || [], 1 === h.length) {
          if (c = h[0] = h[0].slice(0), c.length > 2 && "ID" === (d = c[0]).type && n.getById && 9 === t.nodeType && m && i.relative[c[1].type]) {
            if (t = (i.find.ID(d.matches[0].replace(ne, ie), t) || [])[0], !t) return o;
            f && (t = t.parentNode), e = e.slice(c.shift().value.length)
          }
          for (p = Q.needsContext.test(e) ? 0 : c.length; p-- && (d = c[p], !i.relative[l = d.type]);)
            if ((u = i.find[l]) && (r = u(d.matches[0].replace(ne, ie), ee.test(c[0].type) && me(t.parentNode) || t))) {
              if (c.splice(p, 1), e = r.length && ve(c), !e) return I.apply(o, r), o;
              break
            }
        }
        return (f || s(e, h))(r, t, !m, o, ee.test(e) && me(t.parentNode) || t), o
      }, n.sortStable = b.split("").sort($).join("") === b, n.detectDuplicates = !!l, u(), n.sortDetached = ce(function (e) {
        return 1 & e.compareDocumentPosition(f.createElement("div"))
      }), ce(function (e) {
        return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
      }) || de("type|href|height|width", function (e, t, n) {
        return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
      }), n.attributes && ce(function (e) {
        return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
      }) || de("value", function (e, t, n) {
        return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
      }), ce(function (e) {
        return null == e.getAttribute("disabled")
      }) || de(D, function (e, t, n) {
        var i;
        return n ? void 0 : e[t] === !0 ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
      }), ae
    }(e);
    u.find = y, u.expr = y.selectors, u.expr[":"] = u.expr.pseudos, u.unique = y.uniqueSort, u.text = y.getText, u.isXMLDoc = y.isXML, u.contains = y.contains;
    var w = u.expr.match.needsContext,
      b = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      x = /^.[^:#\[\.,]*$/;

    function C(e, t, n) {
      if (u.isFunction(t)) return u.grep(e, function (e, i) {
        return !!t.call(e, i, e) !== n
      });
      if (t.nodeType) return u.grep(e, function (e) {
        return e === t !== n
      });
      if ("string" == typeof t) {
        if (x.test(t)) return u.filter(t, e, n);
        t = u.filter(t, e)
      }
      return u.grep(e, function (e) {
        return u.inArray(e, t) >= 0 !== n
      })
    }
    u.filter = function (e, t, n) {
      var i = t[0];
      return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? u.find.matchesSelector(i, e) ? [i] : [] : u.find.matches(e, u.grep(t, function (e) {
        return 1 === e.nodeType
      }))
    }, u.fn.extend({
      find: function (e) {
        var t, n = [],
          i = this,
          o = i.length;
        if ("string" != typeof e) return this.pushStack(u(e).filter(function () {
          for (t = 0; o > t; t++)
            if (u.contains(i[t], this)) return !0
        }));
        for (t = 0; o > t; t++) u.find(e, i[t], n);
        return n = this.pushStack(o > 1 ? u.unique(n) : n), n.selector = this.selector ? this.selector + " " + e : e, n
      },
      filter: function (e) {
        return this.pushStack(C(this, e || [], !1))
      },
      not: function (e) {
        return this.pushStack(C(this, e || [], !0))
      },
      is: function (e) {
        return !!C(this, "string" == typeof e && w.test(e) ? u(e) : e || [], !1).length
      }
    });
    var S, k = e.document,
      T = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      E = u.fn.init = function (e, t) {
        var n, i;
        if (!e) return this;
        if ("string" == typeof e) {
          if (n = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : T.exec(e), !n || !n[1] && t) return !t || t.jquery ? (t || S).find(e) : this.constructor(t).find(e);
          if (n[1]) {
            if (t = t instanceof u ? t[0] : t, u.merge(this, u.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : k, !0)), b.test(n[1]) && u.isPlainObject(t))
              for (n in t) u.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
            return this
          }
          if (i = k.getElementById(n[2]), i && i.parentNode) {
            if (i.id !== n[2]) return S.find(e);
            this.length = 1, this[0] = i
          }
          return this.context = k, this.selector = e, this
        }
        return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : u.isFunction(e) ? "undefined" != typeof S.ready ? S.ready(e) : e(u) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), u.makeArray(e, this))
      };
    E.prototype = u.fn, S = u(k);
    var $ = /^(?:parents|prev(?:Until|All))/,
      M = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
      };
    u.extend({
      dir: function (e, t, n) {
        for (var i = [], o = e[t]; o && 9 !== o.nodeType && (void 0 === n || 1 !== o.nodeType || !u(o).is(n));) 1 === o.nodeType && i.push(o), o = o[t];
        return i
      },
      sibling: function (e, t) {
        for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
        return n
      }
    }), u.fn.extend({
      has: function (e) {
        var t, n = u(e, this),
          i = n.length;
        return this.filter(function () {
          for (t = 0; i > t; t++)
            if (u.contains(this, n[t])) return !0
        })
      },
      closest: function (e, t) {
        for (var n, i = 0, o = this.length, r = [], a = w.test(e) || "string" != typeof e ? u(e, t || this.context) : 0; o > i; i++)
          for (n = this[i]; n && n !== t; n = n.parentNode)
            if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && u.find.matchesSelector(n, e))) {
              r.push(n);
              break
            } return this.pushStack(r.length > 1 ? u.unique(r) : r)
      },
      index: function (e) {
        return e ? "string" == typeof e ? u.inArray(this[0], u(e)) : u.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
      },
      add: function (e, t) {
        return this.pushStack(u.unique(u.merge(this.get(), u(e, t))))
      },
      addBack: function (e) {
        return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
      }
    });

    function _(e, t) {
      do e = e[t]; while (e && 1 !== e.nodeType);
      return e
    }
    u.each({
      parent: function (e) {
        var t = e.parentNode;
        return t && 11 !== t.nodeType ? t : null
      },
      parents: function (e) {
        return u.dir(e, "parentNode")
      },
      parentsUntil: function (e, t, n) {
        return u.dir(e, "parentNode", n)
      },
      next: function (e) {
        return _(e, "nextSibling")
      },
      prev: function (e) {
        return _(e, "previousSibling")
      },
      nextAll: function (e) {
        return u.dir(e, "nextSibling")
      },
      prevAll: function (e) {
        return u.dir(e, "previousSibling")
      },
      nextUntil: function (e, t, n) {
        return u.dir(e, "nextSibling", n)
      },
      prevUntil: function (e, t, n) {
        return u.dir(e, "previousSibling", n)
      },
      siblings: function (e) {
        return u.sibling((e.parentNode || {}).firstChild, e)
      },
      children: function (e) {
        return u.sibling(e.firstChild)
      },
      contents: function (e) {
        return u.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : u.merge([], e.childNodes)
      }
    }, function (e, t) {
      u.fn[e] = function (n, i) {
        var o = u.map(this, t, n);
        return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = u.filter(i, o)), this.length > 1 && (M[e] || (o = u.unique(o)), $.test(e) && (o = o.reverse())), this.pushStack(o)
      }
    });
    var N = /\S+/g,
      A = {};

    function L(e) {
      var t = A[e] = {};
      return u.each(e.match(N) || [], function (e, n) {
        t[n] = !0
      }), t
    }
    u.Callbacks = function (e) {
      e = "string" == typeof e ? A[e] || L(e) : u.extend({}, e);
      var t, n, i, o, r, a, s = [],
        p = !e.once && [],
        c = function (l) {
          for (n = e.memory && l, i = !0, r = a || 0, a = 0, o = s.length, t = !0; s && o > r; r++)
            if (s[r].apply(l[0], l[1]) === !1 && e.stopOnFalse) {
              n = !1;
              break
            } t = !1, s && (p ? p.length && c(p.shift()) : n ? s = [] : d.disable())
        },
        d = {
          add: function () {
            if (s) {
              var i = s.length;
              ! function r(t) {
                u.each(t, function (t, n) {
                  var i = u.type(n);
                  "function" === i ? e.unique && d.has(n) || s.push(n) : n && n.length && "string" !== i && r(n)
                })
              }(arguments), t ? o = s.length : n && (a = i, c(n))
            }
            return this
          },
          remove: function () {
            return s && u.each(arguments, function (e, n) {
              for (var i;
                (i = u.inArray(n, s, i)) > -1;) s.splice(i, 1), t && (o >= i && o--, r >= i && r--)
            }), this
          },
          has: function (e) {
            return e ? u.inArray(e, s) > -1 : !(!s || !s.length)
          },
          empty: function () {
            return s = [], o = 0, this
          },
          disable: function () {
            return s = p = n = void 0, this
          },
          disabled: function () {
            return !s
          },
          lock: function () {
            return p = void 0, n || d.disable(), this
          },
          locked: function () {
            return !p
          },
          fireWith: function (e, n) {
            return !s || i && !p || (n = n || [], n = [e, n.slice ? n.slice() : n], t ? p.push(n) : c(n)), this
          },
          fire: function () {
            return d.fireWith(this, arguments), this
          },
          fired: function () {
            return !!i
          }
        };
      return d
    }, u.extend({
      Deferred: function (e) {
        var t = [
            ["resolve", "done", u.Callbacks("once memory"), "resolved"],
            ["reject", "fail", u.Callbacks("once memory"), "rejected"],
            ["notify", "progress", u.Callbacks("memory")]
          ],
          n = "pending",
          i = {
            state: function () {
              return n
            },
            always: function () {
              return o.done(arguments).fail(arguments), this
            },
            then: function () {
              var e = arguments;
              return u.Deferred(function (n) {
                u.each(t, function (t, r) {
                  var a = u.isFunction(e[t]) && e[t];
                  o[r[1]](function () {
                    var e = a && a.apply(this, arguments);
                    e && u.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[r[0] + "With"](this === i ? n.promise() : this, a ? [e] : arguments)
                  })
                }), e = null
              }).promise()
            },
            promise: function (e) {
              return null != e ? u.extend(e, i) : i
            }
          },
          o = {};
        return i.pipe = i.then, u.each(t, function (e, r) {
          var a = r[2],
            s = r[3];
          i[r[1]] = a.add, s && a.add(function () {
            n = s
          }, t[1 ^ e][2].disable, t[2][2].lock), o[r[0]] = function () {
            return o[r[0] + "With"](this === o ? i : this, arguments), this
          }, o[r[0] + "With"] = a.fireWith
        }), i.promise(o), e && e.call(o, o), o
      },
      when: function (e) {
        var t, n, o, r = 0,
          a = i.call(arguments),
          s = a.length,
          p = 1 !== s || e && u.isFunction(e.promise) ? s : 0,
          c = 1 === p ? e : u.Deferred(),
          d = function (e, n, o) {
            return function (r) {
              n[e] = this, o[e] = arguments.length > 1 ? i.call(arguments) : r, o === t ? c.notifyWith(n, o) : --p || c.resolveWith(n, o)
            }
          };
        if (s > 1)
          for (t = new Array(s), n = new Array(s), o = new Array(s); s > r; r++) a[r] && u.isFunction(a[r].promise) ? a[r].promise().done(d(r, o, a)).fail(c.reject).progress(d(r, n, t)) : --p;
        return p || c.resolveWith(o, a), c.promise()
      }
    });
    var I;
    u.fn.ready = function (e) {
      return u.ready.promise().done(e), this
    }, u.extend({
      isReady: !1,
      readyWait: 1,
      holdReady: function (e) {
        e ? u.readyWait++ : u.ready(!0)
      },
      ready: function (e) {
        if (e === !0 ? !--u.readyWait : !u.isReady) {
          if (!k.body) return setTimeout(u.ready);
          u.isReady = !0, e !== !0 && --u.readyWait > 0 || (I.resolveWith(k, [u]), u.fn.triggerHandler && (u(k).triggerHandler("ready"), u(k).off("ready")))
        }
      }
    });

    function j() {
      k.addEventListener ? (k.removeEventListener("DOMContentLoaded", P, !1), e.removeEventListener("load", P, !1)) : (k.detachEvent("onreadystatechange", P), e.detachEvent("onload", P))
    }

    function P() {
      (k.addEventListener || "load" === event.type || "complete" === k.readyState) && (j(), u.ready())
    }
    u.ready.promise = function (t) {
      if (!I)
        if (I = u.Deferred(), "complete" === k.readyState) setTimeout(u.ready);
        else if (k.addEventListener) k.addEventListener("DOMContentLoaded", P, !1), e.addEventListener("load", P, !1);
      else {
        k.attachEvent("onreadystatechange", P), e.attachEvent("onload", P);
        var n = !1;
        try {
          n = null == e.frameElement && k.documentElement
        } catch (i) {}
        n && n.doScroll && ! function o() {
          if (!u.isReady) {
            try {
              n.doScroll("left")
            } catch (e) {
              return setTimeout(o, 50)
            }
            j(), u.ready()
          }
        }()
      }
      return I.promise(t)
    };
    var D, O = "undefined";
    for (D in u(d)) break;
    d.ownLast = "0" !== D, d.inlineBlockNeedsLayout = !1, u(function () {
        var e, t, n, i;
        n = k.getElementsByTagName("body")[0], n && n.style && (t = k.createElement("div"), i = k.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(i).appendChild(t), typeof t.style.zoom !== O && (t.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", d.inlineBlockNeedsLayout = e = 3 === t.offsetWidth, e && (n.style.zoom = 1)), n.removeChild(i))
      }),
      function () {
        var e = k.createElement("div");
        if (null == d.deleteExpando) {
          d.deleteExpando = !0;
          try {
            delete e.test
          } catch (t) {
            d.deleteExpando = !1
          }
        }
        e = null
      }(), u.acceptData = function (e) {
        var t = u.noData[(e.nodeName + " ").toLowerCase()],
          n = +e.nodeType || 1;
        return (1 === n || 9 === n) && (!t || t !== !0 && e.getAttribute("classid") === t)
      };
    var H = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      q = /([A-Z])/g;

    function F(e, t, n) {
      if (void 0 === n && 1 === e.nodeType) {
        var i = "data-" + t.replace(q, "-$1").toLowerCase();
        if (n = e.getAttribute(i), "string" == typeof n) {
          try {
            n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : H.test(n) ? u.parseJSON(n) : n)
          } catch (o) {}
          u.data(e, t, n)
        } else n = void 0
      }
      return n
    }

    function R(e) {
      var t;
      for (t in e)
        if (("data" !== t || !u.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
      return !0
    }

    function V(e, t, i, o) {
      if (u.acceptData(e)) {
        var r, a, s = u.expando,
          p = e.nodeType,
          c = p ? u.cache : e,
          d = p ? e[s] : e[s] && s;
        if (d && c[d] && (o || c[d].data) || void 0 !== i || "string" != typeof t) return d || (d = p ? e[s] = n.pop() || u.guid++ : s), c[d] || (c[d] = p ? {} : {
          toJSON: u.noop
        }), ("object" == typeof t || "function" == typeof t) && (o ? c[d] = u.extend(c[d], t) : c[d].data = u.extend(c[d].data, t)), a = c[d], o || (a.data || (a.data = {}), a = a.data), void 0 !== i && (a[u.camelCase(t)] = i), "string" == typeof t ? (r = a[t], null == r && (r = a[u.camelCase(t)])) : r = a, r
      }
    }

    function B(e, t, n) {
      if (u.acceptData(e)) {
        var i, o, r = e.nodeType,
          a = r ? u.cache : e,
          s = r ? e[u.expando] : u.expando;
        if (a[s]) {
          if (t && (i = n ? a[s] : a[s].data)) {
            u.isArray(t) ? t = t.concat(u.map(t, u.camelCase)) : t in i ? t = [t] : (t = u.camelCase(t), t = t in i ? [t] : t.split(" ")), o = t.length;
            for (; o--;) delete i[t[o]];
            if (n ? !R(i) : !u.isEmptyObject(i)) return
          }(n || (delete a[s].data, R(a[s]))) && (r ? u.cleanData([e], !0) : d.deleteExpando || a != a.window ? delete a[s] : a[s] = null)
        }
      }
    }
    u.extend({
      cache: {},
      noData: {
        "applet ": !0,
        "embed ": !0,
        "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
      },
      hasData: function (e) {
        return e = e.nodeType ? u.cache[e[u.expando]] : e[u.expando], !!e && !R(e)
      },
      data: function (e, t, n) {
        return V(e, t, n)
      },
      removeData: function (e, t) {
        return B(e, t)
      },
      _data: function (e, t, n) {
        return V(e, t, n, !0)
      },
      _removeData: function (e, t) {
        return B(e, t, !0)
      }
    }), u.fn.extend({
      data: function (e, t) {
        var n, i, o, r = this[0],
          a = r && r.attributes;
        if (void 0 === e) {
          if (this.length && (o = u.data(r), 1 === r.nodeType && !u._data(r, "parsedAttrs"))) {
            for (n = a.length; n--;) a[n] && (i = a[n].name, 0 === i.indexOf("data-") && (i = u.camelCase(i.slice(5)), F(r, i, o[i])));
            u._data(r, "parsedAttrs", !0)
          }
          return o
        }
        return "object" == typeof e ? this.each(function () {
          u.data(this, e)
        }) : arguments.length > 1 ? this.each(function () {
          u.data(this, e, t)
        }) : r ? F(r, e, u.data(r, e)) : void 0
      },
      removeData: function (e) {
        return this.each(function () {
          u.removeData(this, e)
        })
      }
    }), u.extend({
      queue: function (e, t, n) {
        var i;
        return e ? (t = (t || "fx") + "queue", i = u._data(e, t), n && (!i || u.isArray(n) ? i = u._data(e, t, u.makeArray(n)) : i.push(n)), i || []) : void 0
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var n = u.queue(e, t),
          i = n.length,
          o = n.shift(),
          r = u._queueHooks(e, t),
          a = function () {
            u.dequeue(e, t)
          };
        "inprogress" === o && (o = n.shift(), i--), o && ("fx" === t && n.unshift("inprogress"), delete r.stop, o.call(e, a, r)), !i && r && r.empty.fire()
      },
      _queueHooks: function (e, t) {
        var n = t + "queueHooks";
        return u._data(e, n) || u._data(e, n, {
          empty: u.Callbacks("once memory").add(function () {
            u._removeData(e, t + "queue"), u._removeData(e, n)
          })
        })
      }
    }), u.fn.extend({
      queue: function (e, t) {
        var n = 2;
        return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? u.queue(this[0], e) : void 0 === t ? this : this.each(function () {
          var n = u.queue(this, e, t);
          u._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && u.dequeue(this, e)
        })
      },
      dequeue: function (e) {
        return this.each(function () {
          u.dequeue(this, e)
        })
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", [])
      },
      promise: function (e, t) {
        var n, i = 1,
          o = u.Deferred(),
          r = this,
          a = this.length,
          s = function () {
            --i || o.resolveWith(r, [r])
          };
        for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;) n = u._data(r[a], e + "queueHooks"), n && n.empty && (i++, n.empty.add(s));
        return s(), o.promise(t)
      }
    });
    var z = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      W = ["Top", "Right", "Bottom", "Left"],
      U = function (e, t) {
        return e = t || e, "none" === u.css(e, "display") || !u.contains(e.ownerDocument, e)
      },
      X = u.access = function (e, t, n, i, o, r, a) {
        var s = 0,
          p = e.length,
          c = null == n;
        if ("object" === u.type(n)) {
          o = !0;
          for (s in n) u.access(e, t, s, n[s], !0, r, a)
        } else if (void 0 !== i && (o = !0, u.isFunction(i) || (a = !0), c && (a ? (t.call(e, i), t = null) : (c = t, t = function (e, t, n) {
            return c.call(u(e), n)
          })), t))
          for (; p > s; s++) t(e[s], n, a ? i : i.call(e[s], s, t(e[s], n)));
        return o ? e : c ? t.call(e) : p ? t(e[0], n) : r
      },
      J = /^(?:checkbox|radio)$/i;
    ! function () {
      var e = k.createElement("input"),
        t = k.createElement("div"),
        n = k.createDocumentFragment();
      if (t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", d.leadingWhitespace = 3 === t.firstChild.nodeType, d.tbody = !t.getElementsByTagName("tbody").length, d.htmlSerialize = !!t.getElementsByTagName("link").length, d.html5Clone = "<:nav></:nav>" !== k.createElement("nav").cloneNode(!0).outerHTML, e.type = "checkbox", e.checked = !0, n.appendChild(e), d.appendChecked = e.checked, t.innerHTML = "<textarea>x</textarea>", d.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, n.appendChild(t), t.innerHTML = "<input type='radio' checked='checked' name='t'/>", d.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, d.noCloneEvent = !0, t.attachEvent && (t.attachEvent("onclick", function () {
          d.noCloneEvent = !1
        }), t.cloneNode(!0).click()), null == d.deleteExpando) {
        d.deleteExpando = !0;
        try {
          delete t.test
        } catch (i) {
          d.deleteExpando = !1
        }
      }
    }(),
    function () {
      var t, n, i = k.createElement("div");
      for (t in {
          submit: !0,
          change: !0,
          focusin: !0
        }) n = "on" + t, (d[t + "Bubbles"] = n in e) || (i.setAttribute(n, "t"), d[t + "Bubbles"] = i.attributes[n].expando === !1);
      i = null
    }();
    var Q = /^(?:input|select|textarea)$/i,
      G = /^key/,
      Y = /^(?:mouse|pointer|contextmenu)|click/,
      K = /^(?:focusinfocus|focusoutblur)$/,
      Z = /^([^.]*)(?:\.(.+)|)$/;

    function ee() {
      return !0
    }

    function te() {
      return !1
    }

    function ne() {
      try {
        return k.activeElement
      } catch (e) {}
    }
    u.event = {
      global: {},
      add: function (e, t, n, i, o) {
        var r, a, s, p, c, d, l, f, h, m, g, v = u._data(e);
        if (v) {
          for (n.handler && (p = n, n = p.handler, o = p.selector), n.guid || (n.guid = u.guid++), (a = v.events) || (a = v.events = {}), (d = v.handle) || (d = v.handle = function (e) {
              return typeof u === O || e && u.event.triggered === e.type ? void 0 : u.event.dispatch.apply(d.elem, arguments)
            }, d.elem = e), t = (t || "").match(N) || [""], s = t.length; s--;) r = Z.exec(t[s]) || [], h = g = r[1], m = (r[2] || "").split(".").sort(), h && (c = u.event.special[h] || {}, h = (o ? c.delegateType : c.bindType) || h, c = u.event.special[h] || {}, l = u.extend({
            type: h,
            origType: g,
            data: i,
            handler: n,
            guid: n.guid,
            selector: o,
            needsContext: o && u.expr.match.needsContext.test(o),
            namespace: m.join(".")
          }, p), (f = a[h]) || (f = a[h] = [], f.delegateCount = 0, c.setup && c.setup.call(e, i, m, d) !== !1 || (e.addEventListener ? e.addEventListener(h, d, !1) : e.attachEvent && e.attachEvent("on" + h, d))), c.add && (c.add.call(e, l), l.handler.guid || (l.handler.guid = n.guid)), o ? f.splice(f.delegateCount++, 0, l) : f.push(l), u.event.global[h] = !0);
          e = null
        }
      },
      remove: function (e, t, n, i, o) {
        var r, a, s, p, c, d, l, f, h, m, g, v = u.hasData(e) && u._data(e);
        if (v && (d = v.events)) {
          for (t = (t || "").match(N) || [""], c = t.length; c--;)
            if (s = Z.exec(t[c]) || [], h = g = s[1], m = (s[2] || "").split(".").sort(), h) {
              for (l = u.event.special[h] || {}, h = (i ? l.delegateType : l.bindType) || h, f = d[h] || [], s = s[2] && new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)"), p = r = f.length; r--;) a = f[r], !o && g !== a.origType || n && n.guid !== a.guid || s && !s.test(a.namespace) || i && i !== a.selector && ("**" !== i || !a.selector) || (f.splice(r, 1), a.selector && f.delegateCount--, l.remove && l.remove.call(e, a));
              p && !f.length && (l.teardown && l.teardown.call(e, m, v.handle) !== !1 || u.removeEvent(e, h, v.handle), delete d[h])
            } else
              for (h in d) u.event.remove(e, h + t[c], n, i, !0);
          u.isEmptyObject(d) && (delete v.handle, u._removeData(e, "events"))
        }
      },
      trigger: function (t, n, i, o) {
        var r, a, s, p, d, l, f, h = [i || k],
          m = c.call(t, "type") ? t.type : t,
          g = c.call(t, "namespace") ? t.namespace.split(".") : [];
        if (s = l = i = i || k, 3 !== i.nodeType && 8 !== i.nodeType && !K.test(m + u.event.triggered) && (m.indexOf(".") >= 0 && (g = m.split("."), m = g.shift(), g.sort()), a = m.indexOf(":") < 0 && "on" + m, t = t[u.expando] ? t : new u.Event(m, "object" == typeof t && t), t.isTrigger = o ? 2 : 3, t.namespace = g.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : u.makeArray(n, [t]), d = u.event.special[m] || {}, o || !d.trigger || d.trigger.apply(i, n) !== !1)) {
          if (!o && !d.noBubble && !u.isWindow(i)) {
            for (p = d.delegateType || m, K.test(p + m) || (s = s.parentNode); s; s = s.parentNode) h.push(s), l = s;
            l === (i.ownerDocument || k) && h.push(l.defaultView || l.parentWindow || e)
          }
          for (f = 0;
            (s = h[f++]) && !t.isPropagationStopped();) t.type = f > 1 ? p : d.bindType || m, r = (u._data(s, "events") || {})[t.type] && u._data(s, "handle"), r && r.apply(s, n), r = a && s[a], r && r.apply && u.acceptData(s) && (t.result = r.apply(s, n), t.result === !1 && t.preventDefault());
          if (t.type = m, !o && !t.isDefaultPrevented() && (!d._default || d._default.apply(h.pop(), n) === !1) && u.acceptData(i) && a && i[m] && !u.isWindow(i)) {
            l = i[a], l && (i[a] = null), u.event.triggered = m;
            try {
              i[m]()
            } catch (v) {}
            u.event.triggered = void 0, l && (i[a] = l)
          }
          return t.result
        }
      },
      dispatch: function (e) {
        e = u.event.fix(e);
        var t, n, o, r, a, s = [],
          p = i.call(arguments),
          c = (u._data(this, "events") || {})[e.type] || [],
          d = u.event.special[e.type] || {};
        if (p[0] = e, e.delegateTarget = this, !d.preDispatch || d.preDispatch.call(this, e) !== !1) {
          for (s = u.event.handlers.call(this, e, c), t = 0;
            (r = s[t++]) && !e.isPropagationStopped();)
            for (e.currentTarget = r.elem, a = 0;
              (o = r.handlers[a++]) && !e.isImmediatePropagationStopped();)(!e.namespace_re || e.namespace_re.test(o.namespace)) && (e.handleObj = o, e.data = o.data, n = ((u.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, p), void 0 !== n && (e.result = n) === !1 && (e.preventDefault(), e.stopPropagation()));
          return d.postDispatch && d.postDispatch.call(this, e), e.result
        }
      },
      handlers: function (e, t) {
        var n, i, o, r, a = [],
          s = t.delegateCount,
          p = e.target;
        if (s && p.nodeType && (!e.button || "click" !== e.type))
          for (; p != this; p = p.parentNode || this)
            if (1 === p.nodeType && (p.disabled !== !0 || "click" !== e.type)) {
              for (o = [], r = 0; s > r; r++) i = t[r], n = i.selector + " ", void 0 === o[n] && (o[n] = i.needsContext ? u(n, this).index(p) >= 0 : u.find(n, this, null, [p]).length), o[n] && o.push(i);
              o.length && a.push({
                elem: p,
                handlers: o
              })
            } return s < t.length && a.push({
          elem: this,
          handlers: t.slice(s)
        }), a
      },
      fix: function (e) {
        if (e[u.expando]) return e;
        var t, n, i, o = e.type,
          r = e,
          a = this.fixHooks[o];
        for (a || (this.fixHooks[o] = a = Y.test(o) ? this.mouseHooks : G.test(o) ? this.keyHooks : {}), i = a.props ? this.props.concat(a.props) : this.props, e = new u.Event(r), t = i.length; t--;) n = i[t], e[n] = r[n];
        return e.target || (e.target = r.srcElement || k), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, a.filter ? a.filter(e, r) : e
      },
      props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e, t) {
          return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
        }
      },
      mouseHooks: {
        props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
        filter: function (e, t) {
          var n, i, o, r = t.button,
            a = t.fromElement;
          return null == e.pageX && null != t.clientX && (i = e.target.ownerDocument || k, o = i.documentElement, n = i.body, e.pageX = t.clientX + (o && o.scrollLeft || n && n.scrollLeft || 0) - (o && o.clientLeft || n && n.clientLeft || 0), e.pageY = t.clientY + (o && o.scrollTop || n && n.scrollTop || 0) - (o && o.clientTop || n && n.clientTop || 0)), !e.relatedTarget && a && (e.relatedTarget = a === e.target ? t.toElement : a), e.which || void 0 === r || (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0), e
        }
      },
      special: {
        load: {
          noBubble: !0
        },
        focus: {
          trigger: function () {
            if (this !== ne() && this.focus) try {
              return this.focus(), !1
            } catch (e) {}
          },
          delegateType: "focusin"
        },
        blur: {
          trigger: function () {
            return this === ne() && this.blur ? (this.blur(), !1) : void 0
          },
          delegateType: "focusout"
        },
        click: {
          trigger: function () {
            return u.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0
          },
          _default: function (e) {
            return u.nodeName(e.target, "a")
          }
        },
        beforeunload: {
          postDispatch: function (e) {
            void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
          }
        }
      },
      simulate: function (e, t, n, i) {
        var o = u.extend(new u.Event, n, {
          type: e,
          isSimulated: !0,
          originalEvent: {}
        });
        i ? u.event.trigger(o, null, t) : u.event.dispatch.call(t, o), o.isDefaultPrevented() && n.preventDefault()
      }
    }, u.removeEvent = k.removeEventListener ? function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n, !1)
    } : function (e, t, n) {
      var i = "on" + t;
      e.detachEvent && (typeof e[i] === O && (e[i] = null), e.detachEvent(i, n))
    }, u.Event = function (e, t) {
      return this instanceof u.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && e.returnValue === !1 ? ee : te) : this.type = e, t && u.extend(this, t), this.timeStamp = e && e.timeStamp || u.now(), void(this[u.expando] = !0)) : new u.Event(e, t)
    }, u.Event.prototype = {
      isDefaultPrevented: te,
      isPropagationStopped: te,
      isImmediatePropagationStopped: te,
      preventDefault: function () {
        var e = this.originalEvent;
        this.isDefaultPrevented = ee, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1)
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        this.isPropagationStopped = ee, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0)
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        this.isImmediatePropagationStopped = ee, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation()
      }
    }, u.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function (e, t) {
      u.event.special[e] = {
        delegateType: t,
        bindType: t,
        handle: function (e) {
          var n, i = this,
            o = e.relatedTarget,
            r = e.handleObj;
          return (!o || o !== i && !u.contains(i, o)) && (e.type = r.origType, n = r.handler.apply(this, arguments), e.type = t), n
        }
      }
    }), d.submitBubbles || (u.event.special.submit = {
      setup: function () {
        return !u.nodeName(this, "form") && void u.event.add(this, "click._submit keypress._submit", function (e) {
          var t = e.target,
            n = u.nodeName(t, "input") || u.nodeName(t, "button") ? t.form : void 0;
          n && !u._data(n, "submitBubbles") && (u.event.add(n, "submit._submit", function (e) {
            e._submit_bubble = !0
          }), u._data(n, "submitBubbles", !0))
        })
      },
      postDispatch: function (e) {
        e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && u.event.simulate("submit", this.parentNode, e, !0))
      },
      teardown: function () {
        return !u.nodeName(this, "form") && void u.event.remove(this, "._submit")
      }
    }), d.changeBubbles || (u.event.special.change = {
      setup: function () {
        return Q.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (u.event.add(this, "propertychange._change", function (e) {
          "checked" === e.originalEvent.propertyName && (this._just_changed = !0)
        }), u.event.add(this, "click._change", function (e) {
          this._just_changed && !e.isTrigger && (this._just_changed = !1), u.event.simulate("change", this, e, !0)
        })), !1) : void u.event.add(this, "beforeactivate._change", function (e) {
          var t = e.target;
          Q.test(t.nodeName) && !u._data(t, "changeBubbles") && (u.event.add(t, "change._change", function (e) {
            !this.parentNode || e.isSimulated || e.isTrigger || u.event.simulate("change", this.parentNode, e, !0)
          }), u._data(t, "changeBubbles", !0))
        })
      },
      handle: function (e) {
        var t = e.target;
        return this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type ? e.handleObj.handler.apply(this, arguments) : void 0
      },
      teardown: function () {
        return u.event.remove(this, "._change"), !Q.test(this.nodeName)
      }
    }), d.focusinBubbles || u.each({
      focus: "focusin",
      blur: "focusout"
    }, function (e, t) {
      var n = function (e) {
        u.event.simulate(t, e.target, u.event.fix(e), !0)
      };
      u.event.special[t] = {
        setup: function () {
          var i = this.ownerDocument || this,
            o = u._data(i, t);
          o || i.addEventListener(e, n, !0), u._data(i, t, (o || 0) + 1)
        },
        teardown: function () {
          var i = this.ownerDocument || this,
            o = u._data(i, t) - 1;
          o ? u._data(i, t, o) : (i.removeEventListener(e, n, !0), u._removeData(i, t))
        }
      }
    }), u.fn.extend({
      on: function (e, t, n, i, o) {
        var r, a;
        if ("object" == typeof e) {
          "string" != typeof t && (n = n || t, t = void 0);
          for (r in e) this.on(r, t, n, e[r], o);
          return this
        }
        if (null == n && null == i ? (i = t, n = t = void 0) : null == i && ("string" == typeof t ? (i = n, n = void 0) : (i = n, n = t, t = void 0)), i === !1) i = te;
        else if (!i) return this;
        return 1 === o && (a = i, i = function (e) {
          return u().off(e), a.apply(this, arguments)
        }, i.guid = a.guid || (a.guid = u.guid++)), this.each(function () {
          u.event.add(this, e, i, n, t)
        })
      },
      one: function (e, t, n, i) {
        return this.on(e, t, n, i, 1)
      },
      off: function (e, t, n) {
        var i, o;
        if (e && e.preventDefault && e.handleObj) return i = e.handleObj, u(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
        if ("object" == typeof e) {
          for (o in e) this.off(o, t, e[o]);
          return this
        }
        return (t === !1 || "function" == typeof t) && (n = t, t = void 0), n === !1 && (n = te), this.each(function () {
          u.event.remove(this, e, n, t)
        })
      },
      trigger: function (e, t) {
        return this.each(function () {
          u.event.trigger(e, t, this)
        })
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        return n ? u.event.trigger(e, t, n, !0) : void 0
      }
    });

    function ie(e) {
      var t = oe.split("|"),
        n = e.createDocumentFragment();
      if (n.createElement)
        for (; t.length;) n.createElement(t.pop());
      return n
    }
    var oe = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
      re = / jQuery\d+="(?:null|\d+)"/g,
      ae = new RegExp("<(?:" + oe + ")[\\s/>]", "i"),
      se = /^\s+/,
      pe = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      ce = /<([\w:]+)/,
      de = /<tbody/i,
      le = /<|&#?\w+;/,
      ue = /<(?:script|style|link)/i,
      fe = /checked\s*(?:[^=]|=\s*.checked.)/i,
      he = /^$|\/(?:java|ecma)script/i,
      me = /^true\/(.*)/,
      ge = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      ve = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        legend: [1, "<fieldset>", "</fieldset>"],
        area: [1, "<map>", "</map>"],
        param: [1, "<object>", "</object>"],
        thead: [1, "<table>", "</table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: d.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
      },
      ye = ie(k),
      we = ye.appendChild(k.createElement("div"));
    ve.optgroup = ve.option, ve.tbody = ve.tfoot = ve.colgroup = ve.caption = ve.thead, ve.th = ve.td;

    function be(e, t) {
      var n, i, o = 0,
        r = typeof e.getElementsByTagName !== O ? e.getElementsByTagName(t || "*") : typeof e.querySelectorAll !== O ? e.querySelectorAll(t || "*") : void 0;
      if (!r)
        for (r = [], n = e.childNodes || e; null != (i = n[o]); o++) !t || u.nodeName(i, t) ? r.push(i) : u.merge(r, be(i, t));
      return void 0 === t || t && u.nodeName(e, t) ? u.merge([e], r) : r
    }

    function xe(e) {
      J.test(e.type) && (e.defaultChecked = e.checked)
    }

    function Ce(e, t) {
      return u.nodeName(e, "table") && u.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }

    function Se(e) {
      return e.type = (null !== u.find.attr(e, "type")) + "/" + e.type, e
    }

    function ke(e) {
      var t = me.exec(e.type);
      return t ? e.type = t[1] : e.removeAttribute("type"), e
    }

    function Te(e, t) {
      for (var n, i = 0; null != (n = e[i]); i++) u._data(n, "globalEval", !t || u._data(t[i], "globalEval"))
    }

    function Ee(e, t) {
      if (1 === t.nodeType && u.hasData(e)) {
        var n, i, o, r = u._data(e),
          a = u._data(t, r),
          s = r.events;
        if (s) {
          delete a.handle, a.events = {};
          for (n in s)
            for (i = 0, o = s[n].length; o > i; i++) u.event.add(t, n, s[n][i])
        }
        a.data && (a.data = u.extend({}, a.data))
      }
    }

    function $e(e, t) {
      var n, i, o;
      if (1 === t.nodeType) {
        if (n = t.nodeName.toLowerCase(), !d.noCloneEvent && t[u.expando]) {
          o = u._data(t);
          for (i in o.events) u.removeEvent(t, i, o.handle);
          t.removeAttribute(u.expando)
        }
        "script" === n && t.text !== e.text ? (Se(t).text = e.text, ke(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML), d.html5Clone && e.innerHTML && !u.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && J.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : ("input" === n || "textarea" === n) && (t.defaultValue = e.defaultValue)
      }
    }
    u.extend({
      clone: function (e, t, n) {
        var i, o, r, a, s, p = u.contains(e.ownerDocument, e);
        if (d.html5Clone || u.isXMLDoc(e) || !ae.test("<" + e.nodeName + ">") ? r = e.cloneNode(!0) : (we.innerHTML = e.outerHTML, we.removeChild(r = we.firstChild)), !(d.noCloneEvent && d.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || u.isXMLDoc(e)))
          for (i = be(r), s = be(e), a = 0; null != (o = s[a]); ++a) i[a] && $e(o, i[a]);
        if (t)
          if (n)
            for (s = s || be(e), i = i || be(r), a = 0; null != (o = s[a]); a++) Ee(o, i[a]);
          else Ee(e, r);
        return i = be(r, "script"), i.length > 0 && Te(i, !p && be(e, "script")), i = s = o = null, r
      },
      buildFragment: function (e, t, n, i) {
        for (var o, r, a, s, p, c, l, f = e.length, h = ie(t), m = [], g = 0; f > g; g++)
          if (r = e[g], r || 0 === r)
            if ("object" === u.type(r)) u.merge(m, r.nodeType ? [r] : r);
            else if (le.test(r)) {
          for (s = s || h.appendChild(t.createElement("div")), p = (ce.exec(r) || ["", ""])[1].toLowerCase(), l = ve[p] || ve._default, s.innerHTML = l[1] + r.replace(pe, "<$1></$2>") + l[2], o = l[0]; o--;) s = s.lastChild;
          if (!d.leadingWhitespace && se.test(r) && m.push(t.createTextNode(se.exec(r)[0])), !d.tbody)
            for (r = "table" !== p || de.test(r) ? "<table>" !== l[1] || de.test(r) ? 0 : s : s.firstChild, o = r && r.childNodes.length; o--;) u.nodeName(c = r.childNodes[o], "tbody") && !c.childNodes.length && r.removeChild(c);
          for (u.merge(m, s.childNodes), s.textContent = ""; s.firstChild;) s.removeChild(s.firstChild);
          s = h.lastChild
        } else m.push(t.createTextNode(r));
        for (s && h.removeChild(s), d.appendChecked || u.grep(be(m, "input"), xe), g = 0; r = m[g++];)
          if ((!i || -1 === u.inArray(r, i)) && (a = u.contains(r.ownerDocument, r), s = be(h.appendChild(r), "script"), a && Te(s), n))
            for (o = 0; r = s[o++];) he.test(r.type || "") && n.push(r);
        return s = null, h
      },
      cleanData: function (e, t) {
        for (var i, o, r, a, s = 0, p = u.expando, c = u.cache, l = d.deleteExpando, f = u.event.special; null != (i = e[s]); s++)
          if ((t || u.acceptData(i)) && (r = i[p], a = r && c[r])) {
            if (a.events)
              for (o in a.events) f[o] ? u.event.remove(i, o) : u.removeEvent(i, o, a.handle);
            c[r] && (delete c[r], l ? delete i[p] : typeof i.removeAttribute !== O ? i.removeAttribute(p) : i[p] = null, n.push(r))
          }
      }
    }), u.fn.extend({
      text: function (e) {
        return X(this, function (e) {
          return void 0 === e ? u.text(this) : this.empty().append((this[0] && this[0].ownerDocument || k).createTextNode(e))
        }, null, e, arguments.length)
      },
      append: function () {
        return this.domManip(arguments, function (e) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var t = Ce(this, e);
            t.appendChild(e)
          }
        })
      },
      prepend: function () {
        return this.domManip(arguments, function (e) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var t = Ce(this, e);
            t.insertBefore(e, t.firstChild)
          }
        })
      },
      before: function () {
        return this.domManip(arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this)
        })
      },
      after: function () {
        return this.domManip(arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
        })
      },
      remove: function (e, t) {
        for (var n, i = e ? u.filter(e, this) : this, o = 0; null != (n = i[o]); o++) t || 1 !== n.nodeType || u.cleanData(be(n)), n.parentNode && (t && u.contains(n.ownerDocument, n) && Te(be(n, "script")), n.parentNode.removeChild(n));
        return this
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++) {
          for (1 === e.nodeType && u.cleanData(be(e, !1)); e.firstChild;) e.removeChild(e.firstChild);
          e.options && u.nodeName(e, "select") && (e.options.length = 0)
        }
        return this
      },
      clone: function (e, t) {
        return e = null != e && e, t = null == t ? e : t, this.map(function () {
          return u.clone(this, e, t)
        })
      },
      html: function (e) {
        return X(this, function (e) {
          var t = this[0] || {},
            n = 0,
            i = this.length;
          if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(re, "") : void 0;
          if (!("string" != typeof e || ue.test(e) || !d.htmlSerialize && ae.test(e) || !d.leadingWhitespace && se.test(e) || ve[(ce.exec(e) || ["", ""])[1].toLowerCase()])) {
            e = e.replace(pe, "<$1></$2>");
            try {
              for (; i > n; n++) t = this[n] || {}, 1 === t.nodeType && (u.cleanData(be(t, !1)), t.innerHTML = e);
              t = 0
            } catch (o) {}
          }
          t && this.empty().append(e)
        }, null, e, arguments.length)
      },
      replaceWith: function () {
        var e = arguments[0];
        return this.domManip(arguments, function (t) {
          e = this.parentNode, u.cleanData(be(this)), e && e.replaceChild(t, this)
        }), e && (e.length || e.nodeType) ? this : this.remove()
      },
      detach: function (e) {
        return this.remove(e, !0)
      },
      domManip: function (e, t) {
        e = o.apply([], e);
        var n, i, r, a, s, p, c = 0,
          l = this.length,
          f = this,
          h = l - 1,
          m = e[0],
          g = u.isFunction(m);
        if (g || l > 1 && "string" == typeof m && !d.checkClone && fe.test(m)) return this.each(function (n) {
          var i = f.eq(n);
          g && (e[0] = m.call(this, n, i.html())), i.domManip(e, t)
        });
        if (l && (p = u.buildFragment(e, this[0].ownerDocument, !1, this), n = p.firstChild, 1 === p.childNodes.length && (p = n), n)) {
          for (a = u.map(be(p, "script"), Se), r = a.length; l > c; c++) i = p, c !== h && (i = u.clone(i, !0, !0), r && u.merge(a, be(i, "script"))), t.call(this[c], i, c);
          if (r)
            for (s = a[a.length - 1].ownerDocument, u.map(a, ke), c = 0; r > c; c++) i = a[c], he.test(i.type || "") && !u._data(i, "globalEval") && u.contains(s, i) && (i.src ? u._evalUrl && u._evalUrl(i.src) : u.globalEval((i.text || i.textContent || i.innerHTML || "").replace(ge, "")));
          p = n = null
        }
        return this
      }
    }), u.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function (e, t) {
      u.fn[e] = function (e) {
        for (var n, i = 0, o = [], a = u(e), s = a.length - 1; s >= i; i++) n = i === s ? this : this.clone(!0), u(a[i])[t](n), r.apply(o, n.get());
        return this.pushStack(o)
      }
    });
    var Me, _e = {};

    function Ne(t, n) {
      var i, o = u(n.createElement(t)).appendTo(n.body),
        r = e.getDefaultComputedStyle && (i = e.getDefaultComputedStyle(o[0])) ? i.display : u.css(o[0], "display");
      return o.detach(), r
    }

    function Ae(e) {
      var t = k,
        n = _e[e];
      return n || (n = Ne(e, t), "none" !== n && n || (Me = (Me || u("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement), t = (Me[0].contentWindow || Me[0].contentDocument).document, t.write(), t.close(), n = Ne(e, t), Me.detach()), _e[e] = n), n
    }! function () {
      var e;
      d.shrinkWrapBlocks = function () {
        if (null != e) return e;
        e = !1;
        var t, n, i;
        return n = k.getElementsByTagName("body")[0], n && n.style ? (t = k.createElement("div"), i = k.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(i).appendChild(t), typeof t.style.zoom !== O && (t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", t.appendChild(k.createElement("div")).style.width = "5px", e = 3 !== t.offsetWidth), n.removeChild(i), e) : void 0
      }
    }();
    var Le, Ie, je = /^margin/,
      Pe = new RegExp("^(" + z + ")(?!px)[a-z%]+$", "i"),
      De = /^(top|right|bottom|left)$/;
    e.getComputedStyle ? (Le = function (t) {
      return t.ownerDocument.defaultView.opener ? t.ownerDocument.defaultView.getComputedStyle(t, null) : e.getComputedStyle(t, null)
    }, Ie = function (e, t, n) {
      var i, o, r, a, s = e.style;
      return n = n || Le(e), a = n ? n.getPropertyValue(t) || n[t] : void 0, n && ("" !== a || u.contains(e.ownerDocument, e) || (a = u.style(e, t)), Pe.test(a) && je.test(t) && (i = s.width, o = s.minWidth, r = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = i, s.minWidth = o, s.maxWidth = r)), void 0 === a ? a : a + ""
    }) : k.documentElement.currentStyle && (Le = function (e) {
      return e.currentStyle
    }, Ie = function (e, t, n) {
      var i, o, r, a, s = e.style;
      return n = n || Le(e), a = n ? n[t] : void 0, null == a && s && s[t] && (a = s[t]), Pe.test(a) && !De.test(t) && (i = s.left, o = e.runtimeStyle, r = o && o.left, r && (o.left = e.currentStyle.left), s.left = "fontSize" === t ? "1em" : a, a = s.pixelLeft + "px", s.left = i, r && (o.left = r)), void 0 === a ? a : a + "" || "auto"
    });

    function Oe(e, t) {
      return {
        get: function () {
          var n = e();
          if (null != n) return n ? void delete this.get : (this.get = t).apply(this, arguments)
        }
      }
    }! function () {
      var t, n, i, o, r, a, s;
      if (t = k.createElement("div"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", i = t.getElementsByTagName("a")[0], n = i && i.style) {
        n.cssText = "float:left;opacity:.5", d.opacity = "0.5" === n.opacity, d.cssFloat = !!n.cssFloat, t.style.backgroundClip = "content-box", t.cloneNode(!0).style.backgroundClip = "", d.clearCloneStyle = "content-box" === t.style.backgroundClip, d.boxSizing = "" === n.boxSizing || "" === n.MozBoxSizing || "" === n.WebkitBoxSizing, u.extend(d, {
          reliableHiddenOffsets: function () {
            return null == a && p(), a
          },
          boxSizingReliable: function () {
            return null == r && p(), r
          },
          pixelPosition: function () {
            return null == o && p(), o
          },
          reliableMarginRight: function () {
            return null == s && p(), s
          }
        });

        function p() {
          var t, n, i, p;
          n = k.getElementsByTagName("body")[0], n && n.style && (t = k.createElement("div"), i = k.createElement("div"), i.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(i).appendChild(t), t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", o = r = !1, s = !0, e.getComputedStyle && (o = "1%" !== (e.getComputedStyle(t, null) || {}).top, r = "4px" === (e.getComputedStyle(t, null) || {
            width: "4px"
          }).width, p = t.appendChild(k.createElement("div")), p.style.cssText = t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", p.style.marginRight = p.style.width = "0", t.style.width = "1px", s = !parseFloat((e.getComputedStyle(p, null) || {}).marginRight), t.removeChild(p)), t.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", p = t.getElementsByTagName("td"), p[0].style.cssText = "margin:0;border:0;padding:0;display:none", a = 0 === p[0].offsetHeight, a && (p[0].style.display = "", p[1].style.display = "none", a = 0 === p[0].offsetHeight), n.removeChild(i))
        }
      }
    }(), u.swap = function (e, t, n, i) {
      var o, r, a = {};
      for (r in t) a[r] = e.style[r], e.style[r] = t[r];
      o = n.apply(e, i || []);
      for (r in t) e.style[r] = a[r];
      return o
    };
    var He = /alpha\([^)]*\)/i,
      qe = /opacity\s*=\s*([^)]*)/,
      Fe = /^(none|table(?!-c[ea]).+)/,
      Re = new RegExp("^(" + z + ")(.*)$", "i"),
      Ve = new RegExp("^([+-])=(" + z + ")", "i"),
      Be = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
      ze = {
        letterSpacing: "0",
        fontWeight: "400"
      },
      We = ["Webkit", "O", "Moz", "ms"];

    function Ue(e, t) {
      if (t in e) return t;
      for (var n = t.charAt(0).toUpperCase() + t.slice(1), i = t, o = We.length; o--;)
        if (t = We[o] + n, t in e) return t;
      return i
    }

    function Xe(e, t) {
      for (var n, i, o, r = [], a = 0, s = e.length; s > a; a++) i = e[a], i.style && (r[a] = u._data(i, "olddisplay"), n = i.style.display, t ? (r[a] || "none" !== n || (i.style.display = ""), "" === i.style.display && U(i) && (r[a] = u._data(i, "olddisplay", Ae(i.nodeName)))) : (o = U(i), (n && "none" !== n || !o) && u._data(i, "olddisplay", o ? n : u.css(i, "display"))));
      for (a = 0; s > a; a++) i = e[a], i.style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? r[a] || "" : "none"));
      return e
    }

    function Je(e, t, n) {
      var i = Re.exec(t);
      return i ? Math.max(0, i[1] - (n || 0)) + (i[2] || "px") : t
    }

    function Qe(e, t, n, i, o) {
      for (var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, a = 0; 4 > r; r += 2) "margin" === n && (a += u.css(e, n + W[r], !0, o)), i ? ("content" === n && (a -= u.css(e, "padding" + W[r], !0, o)), "margin" !== n && (a -= u.css(e, "border" + W[r] + "Width", !0, o))) : (a += u.css(e, "padding" + W[r], !0, o), "padding" !== n && (a += u.css(e, "border" + W[r] + "Width", !0, o)));
      return a
    }

    function Ge(e, t, n) {
      var i = !0,
        o = "width" === t ? e.offsetWidth : e.offsetHeight,
        r = Le(e),
        a = d.boxSizing && "border-box" === u.css(e, "boxSizing", !1, r);
      if (0 >= o || null == o) {
        if (o = Ie(e, t, r), (0 > o || null == o) && (o = e.style[t]), Pe.test(o)) return o;
        i = a && (d.boxSizingReliable() || o === e.style[t]), o = parseFloat(o) || 0
      }
      return o + Qe(e, t, n || (a ? "border" : "content"), i, r) + "px"
    }
    u.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var n = Ie(e, "opacity");
              return "" === n ? "1" : n
            }
          }
        }
      },
      cssNumber: {
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0
      },
      cssProps: {
        "float": d.cssFloat ? "cssFloat" : "styleFloat"
      },
      style: function (e, t, n, i) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var o, r, a, s = u.camelCase(t),
            p = e.style;
          if (t = u.cssProps[s] || (u.cssProps[s] = Ue(p, s)), a = u.cssHooks[t] || u.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (o = a.get(e, !1, i)) ? o : p[t];
          if (r = typeof n, "string" === r && (o = Ve.exec(n)) && (n = (o[1] + 1) * o[2] + parseFloat(u.css(e, t)), r = "number"), null != n && n === n && ("number" !== r || u.cssNumber[s] || (n += "px"), d.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (p[t] = "inherit"), !(a && "set" in a && void 0 === (n = a.set(e, n, i))))) try {
            p[t] = n
          } catch (c) {}
        }
      },
      css: function (e, t, n, i) {
        var o, r, a, s = u.camelCase(t);
        return t = u.cssProps[s] || (u.cssProps[s] = Ue(e.style, s)), a = u.cssHooks[t] || u.cssHooks[s], a && "get" in a && (r = a.get(e, !0, n)), void 0 === r && (r = Ie(e, t, i)), "normal" === r && t in ze && (r = ze[t]), "" === n || n ? (o = parseFloat(r), n === !0 || u.isNumeric(o) ? o || 0 : r) : r
      }
    }), u.each(["height", "width"], function (e, t) {
      u.cssHooks[t] = {
        get: function (e, n, i) {
          return n ? Fe.test(u.css(e, "display")) && 0 === e.offsetWidth ? u.swap(e, Be, function () {
            return Ge(e, t, i)
          }) : Ge(e, t, i) : void 0
        },
        set: function (e, n, i) {
          var o = i && Le(e);
          return Je(e, n, i ? Qe(e, t, i, d.boxSizing && "border-box" === u.css(e, "boxSizing", !1, o), o) : 0)
        }
      }
    }), d.opacity || (u.cssHooks.opacity = {
      get: function (e, t) {
        return qe.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : ""
      },
      set: function (e, t) {
        var n = e.style,
          i = e.currentStyle,
          o = u.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
          r = i && i.filter || n.filter || "";
        n.zoom = 1, (t >= 1 || "" === t) && "" === u.trim(r.replace(He, "")) && n.removeAttribute && (n.removeAttribute("filter"), "" === t || i && !i.filter) || (n.filter = He.test(r) ? r.replace(He, o) : r + " " + o)
      }
    }), u.cssHooks.marginRight = Oe(d.reliableMarginRight, function (e, t) {
      return t ? u.swap(e, {
        display: "inline-block"
      }, Ie, [e, "marginRight"]) : void 0
    }), u.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function (e, t) {
      u.cssHooks[e + t] = {
        expand: function (n) {
          for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) o[e + W[i] + t] = r[i] || r[i - 2] || r[0];
          return o
        }
      }, je.test(e) || (u.cssHooks[e + t].set = Je)
    }), u.fn.extend({
      css: function (e, t) {
        return X(this, function (e, t, n) {
          var i, o, r = {},
            a = 0;
          if (u.isArray(t)) {
            for (i = Le(e), o = t.length; o > a; a++) r[t[a]] = u.css(e, t[a], !1, i);
            return r
          }
          return void 0 !== n ? u.style(e, t, n) : u.css(e, t)
        }, e, t, arguments.length > 1)
      },
      show: function () {
        return Xe(this, !0)
      },
      hide: function () {
        return Xe(this)
      },
      toggle: function (e) {
        return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
          U(this) ? u(this).show() : u(this).hide()
        })
      }
    });

    function Ye(e, t, n, i, o) {
      return new Ye.prototype.init(e, t, n, i, o)
    }
    u.Tween = Ye,
      Ye.prototype = {
        constructor: Ye,
        init: function (e, t, n, i, o, r) {
          this.elem = e, this.prop = n, this.easing = o || "swing", this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = r || (u.cssNumber[n] ? "" : "px")
        },
        cur: function () {
          var e = Ye.propHooks[this.prop];
          return e && e.get ? e.get(this) : Ye.propHooks._default.get(this)
        },
        run: function (e) {
          var t, n = Ye.propHooks[this.prop];
          return this.options.duration ? this.pos = t = u.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : Ye.propHooks._default.set(this), this
        }
      }, Ye.prototype.init.prototype = Ye.prototype, Ye.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = u.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0) : e.elem[e.prop]
          },
          set: function (e) {
            u.fx.step[e.prop] ? u.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[u.cssProps[e.prop]] || u.cssHooks[e.prop]) ? u.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
          }
        }
      }, Ye.propHooks.scrollTop = Ye.propHooks.scrollLeft = {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
      }, u.easing = {
        linear: function (e) {
          return e
        },
        swing: function (e) {
          return .5 - Math.cos(e * Math.PI) / 2
        }
      }, u.fx = Ye.prototype.init, u.fx.step = {};
    var Ke, Ze, et = /^(?:toggle|show|hide)$/,
      tt = new RegExp("^(?:([+-])=|)(" + z + ")([a-z%]*)$", "i"),
      nt = /queueHooks$/,
      it = [pt],
      ot = {
        "*": [function (e, t) {
          var n = this.createTween(e, t),
            i = n.cur(),
            o = tt.exec(t),
            r = o && o[3] || (u.cssNumber[e] ? "" : "px"),
            a = (u.cssNumber[e] || "px" !== r && +i) && tt.exec(u.css(n.elem, e)),
            s = 1,
            p = 20;
          if (a && a[3] !== r) {
            r = r || a[3], o = o || [], a = +i || 1;
            do s = s || ".5", a /= s, u.style(n.elem, e, a + r); while (s !== (s = n.cur() / i) && 1 !== s && --p)
          }
          return o && (a = n.start = +a || +i || 0, n.unit = r, n.end = o[1] ? a + (o[1] + 1) * o[2] : +o[2]), n
        }]
      };

    function rt() {
      return setTimeout(function () {
        Ke = void 0
      }), Ke = u.now()
    }

    function at(e, t) {
      var n, i = {
          height: e
        },
        o = 0;
      for (t = t ? 1 : 0; 4 > o; o += 2 - t) n = W[o], i["margin" + n] = i["padding" + n] = e;
      return t && (i.opacity = i.width = e), i
    }

    function st(e, t, n) {
      for (var i, o = (ot[t] || []).concat(ot["*"]), r = 0, a = o.length; a > r; r++)
        if (i = o[r].call(n, t, e)) return i
    }

    function pt(e, t, n) {
      var i, o, r, a, s, p, c, l, f = this,
        h = {},
        m = e.style,
        g = e.nodeType && U(e),
        v = u._data(e, "fxshow");
      n.queue || (s = u._queueHooks(e, "fx"), null == s.unqueued && (s.unqueued = 0, p = s.empty.fire, s.empty.fire = function () {
        s.unqueued || p()
      }), s.unqueued++, f.always(function () {
        f.always(function () {
          s.unqueued--, u.queue(e, "fx").length || s.empty.fire()
        })
      })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [m.overflow, m.overflowX, m.overflowY], c = u.css(e, "display"), l = "none" === c ? u._data(e, "olddisplay") || Ae(e.nodeName) : c, "inline" === l && "none" === u.css(e, "float") && (d.inlineBlockNeedsLayout && "inline" !== Ae(e.nodeName) ? m.zoom = 1 : m.display = "inline-block")), n.overflow && (m.overflow = "hidden", d.shrinkWrapBlocks() || f.always(function () {
        m.overflow = n.overflow[0], m.overflowX = n.overflow[1], m.overflowY = n.overflow[2]
      }));
      for (i in t)
        if (o = t[i], et.exec(o)) {
          if (delete t[i], r = r || "toggle" === o, o === (g ? "hide" : "show")) {
            if ("show" !== o || !v || void 0 === v[i]) continue;
            g = !0
          }
          h[i] = v && v[i] || u.style(e, i)
        } else c = void 0;
      if (u.isEmptyObject(h)) "inline" === ("none" === c ? Ae(e.nodeName) : c) && (m.display = c);
      else {
        v ? "hidden" in v && (g = v.hidden) : v = u._data(e, "fxshow", {}), r && (v.hidden = !g), g ? u(e).show() : f.done(function () {
          u(e).hide()
        }), f.done(function () {
          var t;
          u._removeData(e, "fxshow");
          for (t in h) u.style(e, t, h[t])
        });
        for (i in h) a = st(g ? v[i] : 0, i, f), i in v || (v[i] = a.start, g && (a.end = a.start, a.start = "width" === i || "height" === i ? 1 : 0))
      }
    }

    function ct(e, t) {
      var n, i, o, r, a;
      for (n in e)
        if (i = u.camelCase(n), o = t[i], r = e[n], u.isArray(r) && (o = r[1], r = e[n] = r[0]), n !== i && (e[i] = r, delete e[n]), a = u.cssHooks[i], a && "expand" in a) {
          r = a.expand(r), delete e[i];
          for (n in r) n in e || (e[n] = r[n], t[n] = o)
        } else t[i] = o
    }

    function dt(e, t, n) {
      var i, o, r = 0,
        a = it.length,
        s = u.Deferred().always(function () {
          delete p.elem
        }),
        p = function () {
          if (o) return !1;
          for (var t = Ke || rt(), n = Math.max(0, c.startTime + c.duration - t), i = n / c.duration || 0, r = 1 - i, a = 0, p = c.tweens.length; p > a; a++) c.tweens[a].run(r);
          return s.notifyWith(e, [c, r, n]), 1 > r && p ? n : (s.resolveWith(e, [c]), !1)
        },
        c = s.promise({
          elem: e,
          props: u.extend({}, t),
          opts: u.extend(!0, {
            specialEasing: {}
          }, n),
          originalProperties: t,
          originalOptions: n,
          startTime: Ke || rt(),
          duration: n.duration,
          tweens: [],
          createTween: function (t, n) {
            var i = u.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
            return c.tweens.push(i), i
          },
          stop: function (t) {
            var n = 0,
              i = t ? c.tweens.length : 0;
            if (o) return this;
            for (o = !0; i > n; n++) c.tweens[n].run(1);
            return t ? s.resolveWith(e, [c, t]) : s.rejectWith(e, [c, t]), this
          }
        }),
        d = c.props;
      for (ct(d, c.opts.specialEasing); a > r; r++)
        if (i = it[r].call(c, e, d, c.opts)) return i;
      return u.map(d, st, c), u.isFunction(c.opts.start) && c.opts.start.call(e, c), u.fx.timer(u.extend(p, {
        elem: e,
        anim: c,
        queue: c.opts.queue
      })), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
    }
    u.Animation = u.extend(dt, {
        tweener: function (e, t) {
          u.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");
          for (var n, i = 0, o = e.length; o > i; i++) n = e[i], ot[n] = ot[n] || [], ot[n].unshift(t)
        },
        prefilter: function (e, t) {
          t ? it.unshift(e) : it.push(e)
        }
      }), u.speed = function (e, t, n) {
        var i = e && "object" == typeof e ? u.extend({}, e) : {
          complete: n || !n && t || u.isFunction(e) && e,
          duration: e,
          easing: n && t || t && !u.isFunction(t) && t
        };
        return i.duration = u.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in u.fx.speeds ? u.fx.speeds[i.duration] : u.fx.speeds._default, (null == i.queue || i.queue === !0) && (i.queue = "fx"), i.old = i.complete, i.complete = function () {
          u.isFunction(i.old) && i.old.call(this), i.queue && u.dequeue(this, i.queue)
        }, i
      }, u.fn.extend({
        fadeTo: function (e, t, n, i) {
          return this.filter(U).css("opacity", 0).show().end().animate({
            opacity: t
          }, e, n, i)
        },
        animate: function (e, t, n, i) {
          var o = u.isEmptyObject(e),
            r = u.speed(t, n, i),
            a = function () {
              var t = dt(this, u.extend({}, e), r);
              (o || u._data(this, "finish")) && t.stop(!0)
            };
          return a.finish = a, o || r.queue === !1 ? this.each(a) : this.queue(r.queue, a)
        },
        stop: function (e, t, n) {
          var i = function (e) {
            var t = e.stop;
            delete e.stop, t(n)
          };
          return "string" != typeof e && (n = t, t = e, e = void 0), t && e !== !1 && this.queue(e || "fx", []), this.each(function () {
            var t = !0,
              o = null != e && e + "queueHooks",
              r = u.timers,
              a = u._data(this);
            if (o) a[o] && a[o].stop && i(a[o]);
            else
              for (o in a) a[o] && a[o].stop && nt.test(o) && i(a[o]);
            for (o = r.length; o--;) r[o].elem !== this || null != e && r[o].queue !== e || (r[o].anim.stop(n), t = !1, r.splice(o, 1));
            (t || !n) && u.dequeue(this, e)
          })
        },
        finish: function (e) {
          return e !== !1 && (e = e || "fx"), this.each(function () {
            var t, n = u._data(this),
              i = n[e + "queue"],
              o = n[e + "queueHooks"],
              r = u.timers,
              a = i ? i.length : 0;
            for (n.finish = !0, u.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--;) r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
            for (t = 0; a > t; t++) i[t] && i[t].finish && i[t].finish.call(this);
            delete n.finish
          })
        }
      }), u.each(["toggle", "show", "hide"], function (e, t) {
        var n = u.fn[t];
        u.fn[t] = function (e, i, o) {
          return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(at(t, !0), e, i, o)
        }
      }), u.each({
        slideDown: at("show"),
        slideUp: at("hide"),
        slideToggle: at("toggle"),
        fadeIn: {
          opacity: "show"
        },
        fadeOut: {
          opacity: "hide"
        },
        fadeToggle: {
          opacity: "toggle"
        }
      }, function (e, t) {
        u.fn[e] = function (e, n, i) {
          return this.animate(t, e, n, i)
        }
      }), u.timers = [], u.fx.tick = function () {
        var e, t = u.timers,
          n = 0;
        for (Ke = u.now(); n < t.length; n++) e = t[n], e() || t[n] !== e || t.splice(n--, 1);
        t.length || u.fx.stop(), Ke = void 0
      }, u.fx.timer = function (e) {
        u.timers.push(e), e() ? u.fx.start() : u.timers.pop()
      }, u.fx.interval = 13, u.fx.start = function () {
        Ze || (Ze = setInterval(u.fx.tick, u.fx.interval))
      }, u.fx.stop = function () {
        clearInterval(Ze), Ze = null
      }, u.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
      }, u.fn.delay = function (e, t) {
        return e = u.fx ? u.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function (t, n) {
          var i = setTimeout(t, e);
          n.stop = function () {
            clearTimeout(i)
          }
        })
      },
      function () {
        var e, t, n, i, o;
        t = k.createElement("div"), t.setAttribute("className", "t"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", i = t.getElementsByTagName("a")[0], n = k.createElement("select"), o = n.appendChild(k.createElement("option")), e = t.getElementsByTagName("input")[0], i.style.cssText = "top:1px", d.getSetAttribute = "t" !== t.className, d.style = /top/.test(i.getAttribute("style")), d.hrefNormalized = "/a" === i.getAttribute("href"), d.checkOn = !!e.value, d.optSelected = o.selected, d.enctype = !!k.createElement("form").enctype, n.disabled = !0, d.optDisabled = !o.disabled, e = k.createElement("input"), e.setAttribute("value", ""), d.input = "" === e.getAttribute("value"), e.value = "t", e.setAttribute("type", "radio"), d.radioValue = "t" === e.value
      }();
    var lt = /\r/g;
    u.fn.extend({
      val: function (e) {
        var t, n, i, o = this[0];
        return arguments.length ? (i = u.isFunction(e), this.each(function (n) {
          var o;
          1 === this.nodeType && (o = i ? e.call(this, n, u(this).val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : u.isArray(o) && (o = u.map(o, function (e) {
            return null == e ? "" : e + ""
          })), t = u.valHooks[this.type] || u.valHooks[this.nodeName.toLowerCase()], t && "set" in t && void 0 !== t.set(this, o, "value") || (this.value = o))
        })) : o ? (t = u.valHooks[o.type] || u.valHooks[o.nodeName.toLowerCase()], t && "get" in t && void 0 !== (n = t.get(o, "value")) ? n : (n = o.value, "string" == typeof n ? n.replace(lt, "") : null == n ? "" : n)) : void 0
      }
    }), u.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = u.find.attr(e, "value");
            return null != t ? t : u.trim(u.text(e))
          }
        },
        select: {
          get: function (e) {
            for (var t, n, i = e.options, o = e.selectedIndex, r = "select-one" === e.type || 0 > o, a = r ? null : [], s = r ? o + 1 : i.length, p = 0 > o ? s : r ? o : 0; s > p; p++)
              if (n = i[p], !(!n.selected && p !== o || (d.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || n.parentNode.disabled && u.nodeName(n.parentNode, "optgroup"))) {
                if (t = u(n).val(), r) return t;
                a.push(t)
              } return a
          },
          set: function (e, t) {
            for (var n, i, o = e.options, r = u.makeArray(t), a = o.length; a--;)
              if (i = o[a], u.inArray(u.valHooks.option.get(i), r) >= 0) try {
                i.selected = n = !0
              } catch (s) {
                i.scrollHeight
              } else i.selected = !1;
            return n || (e.selectedIndex = -1), o
          }
        }
      }
    }), u.each(["radio", "checkbox"], function () {
      u.valHooks[this] = {
        set: function (e, t) {
          return u.isArray(t) ? e.checked = u.inArray(u(e).val(), t) >= 0 : void 0
        }
      }, d.checkOn || (u.valHooks[this].get = function (e) {
        return null === e.getAttribute("value") ? "on" : e.value
      })
    });
    var ut, ft, ht = u.expr.attrHandle,
      mt = /^(?:checked|selected)$/i,
      gt = d.getSetAttribute,
      vt = d.input;
    u.fn.extend({
      attr: function (e, t) {
        return X(this, u.attr, e, t, arguments.length > 1)
      },
      removeAttr: function (e) {
        return this.each(function () {
          u.removeAttr(this, e)
        })
      }
    }), u.extend({
      attr: function (e, t, n) {
        var i, o, r = e.nodeType;
        if (e && 3 !== r && 8 !== r && 2 !== r) return typeof e.getAttribute === O ? u.prop(e, t, n) : (1 === r && u.isXMLDoc(e) || (t = t.toLowerCase(), i = u.attrHooks[t] || (u.expr.match.bool.test(t) ? ft : ut)), void 0 === n ? i && "get" in i && null !== (o = i.get(e, t)) ? o : (o = u.find.attr(e, t), null == o ? void 0 : o) : null !== n ? i && "set" in i && void 0 !== (o = i.set(e, n, t)) ? o : (e.setAttribute(t, n + ""), n) : void u.removeAttr(e, t))
      },
      removeAttr: function (e, t) {
        var n, i, o = 0,
          r = t && t.match(N);
        if (r && 1 === e.nodeType)
          for (; n = r[o++];) i = u.propFix[n] || n, u.expr.match.bool.test(n) ? vt && gt || !mt.test(n) ? e[i] = !1 : e[u.camelCase("default-" + n)] = e[i] = !1 : u.attr(e, n, ""), e.removeAttribute(gt ? n : i)
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!d.radioValue && "radio" === t && u.nodeName(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t
            }
          }
        }
      }
    }), ft = {
      set: function (e, t, n) {
        return t === !1 ? u.removeAttr(e, n) : vt && gt || !mt.test(n) ? e.setAttribute(!gt && u.propFix[n] || n, n) : e[u.camelCase("default-" + n)] = e[n] = !0, n
      }
    }, u.each(u.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = ht[t] || u.find.attr;
      ht[t] = vt && gt || !mt.test(t) ? function (e, t, i) {
        var o, r;
        return i || (r = ht[t], ht[t] = o, o = null != n(e, t, i) ? t.toLowerCase() : null, ht[t] = r), o
      } : function (e, t, n) {
        return n ? void 0 : e[u.camelCase("default-" + t)] ? t.toLowerCase() : null
      }
    }), vt && gt || (u.attrHooks.value = {
      set: function (e, t, n) {
        return u.nodeName(e, "input") ? void(e.defaultValue = t) : ut && ut.set(e, t, n)
      }
    }), gt || (ut = {
      set: function (e, t, n) {
        var i = e.getAttributeNode(n);
        return i || e.setAttributeNode(i = e.ownerDocument.createAttribute(n)), i.value = t += "", "value" === n || t === e.getAttribute(n) ? t : void 0
      }
    }, ht.id = ht.name = ht.coords = function (e, t, n) {
      var i;
      return n ? void 0 : (i = e.getAttributeNode(t)) && "" !== i.value ? i.value : null
    }, u.valHooks.button = {
      get: function (e, t) {
        var n = e.getAttributeNode(t);
        return n && n.specified ? n.value : void 0
      },
      set: ut.set
    }, u.attrHooks.contenteditable = {
      set: function (e, t, n) {
        ut.set(e, "" !== t && t, n)
      }
    }, u.each(["width", "height"], function (e, t) {
      u.attrHooks[t] = {
        set: function (e, n) {
          return "" === n ? (e.setAttribute(t, "auto"), n) : void 0
        }
      }
    })), d.style || (u.attrHooks.style = {
      get: function (e) {
        return e.style.cssText || void 0
      },
      set: function (e, t) {
        return e.style.cssText = t + ""
      }
    });
    var yt = /^(?:input|select|textarea|button|object)$/i,
      wt = /^(?:a|area)$/i;
    u.fn.extend({
      prop: function (e, t) {
        return X(this, u.prop, e, t, arguments.length > 1)
      },
      removeProp: function (e) {
        return e = u.propFix[e] || e, this.each(function () {
          try {
            this[e] = void 0, delete this[e]
          } catch (t) {}
        })
      }
    }), u.extend({
      propFix: {
        "for": "htmlFor",
        "class": "className"
      },
      prop: function (e, t, n) {
        var i, o, r, a = e.nodeType;
        if (e && 3 !== a && 8 !== a && 2 !== a) return r = 1 !== a || !u.isXMLDoc(e), r && (t = u.propFix[t] || t, o = u.propHooks[t]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : e[t] = n : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = u.find.attr(e, "tabindex");
            return t ? parseInt(t, 10) : yt.test(e.nodeName) || wt.test(e.nodeName) && e.href ? 0 : -1
          }
        }
      }
    }), d.hrefNormalized || u.each(["href", "src"], function (e, t) {
      u.propHooks[t] = {
        get: function (e) {
          return e.getAttribute(t, 4)
        }
      }
    }), d.optSelected || (u.propHooks.selected = {
      get: function (e) {
        var t = e.parentNode;
        return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null
      }
    }), u.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
      u.propFix[this.toLowerCase()] = this
    }), d.enctype || (u.propFix.enctype = "encoding");
    var bt = /[\t\r\n\f]/g;
    u.fn.extend({
      addClass: function (e) {
        var t, n, i, o, r, a, s = 0,
          p = this.length,
          c = "string" == typeof e && e;
        if (u.isFunction(e)) return this.each(function (t) {
          u(this).addClass(e.call(this, t, this.className))
        });
        if (c)
          for (t = (e || "").match(N) || []; p > s; s++)
            if (n = this[s], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(bt, " ") : " ")) {
              for (r = 0; o = t[r++];) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
              a = u.trim(i), n.className !== a && (n.className = a)
            } return this
      },
      removeClass: function (e) {
        var t, n, i, o, r, a, s = 0,
          p = this.length,
          c = 0 === arguments.length || "string" == typeof e && e;
        if (u.isFunction(e)) return this.each(function (t) {
          u(this).removeClass(e.call(this, t, this.className))
        });
        if (c)
          for (t = (e || "").match(N) || []; p > s; s++)
            if (n = this[s], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(bt, " ") : "")) {
              for (r = 0; o = t[r++];)
                for (; i.indexOf(" " + o + " ") >= 0;) i = i.replace(" " + o + " ", " ");
              a = e ? u.trim(i) : "", n.className !== a && (n.className = a)
            } return this
      },
      toggleClass: function (e, t) {
        var n = typeof e;
        return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : this.each(u.isFunction(e) ? function (n) {
          u(this).toggleClass(e.call(this, n, this.className, t), t)
        } : function () {
          if ("string" === n)
            for (var t, i = 0, o = u(this), r = e.match(N) || []; t = r[i++];) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
          else(n === O || "boolean" === n) && (this.className && u._data(this, "__className__", this.className), this.className = this.className || e === !1 ? "" : u._data(this, "__className__") || "")
        })
      },
      hasClass: function (e) {
        for (var t = " " + e + " ", n = 0, i = this.length; i > n; n++)
          if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(bt, " ").indexOf(t) >= 0) return !0;
        return !1
      }
    }), u.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
      u.fn[t] = function (e, n) {
        return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
      }
    }), u.fn.extend({
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e)
      },
      bind: function (e, t, n) {
        return this.on(e, null, t, n)
      },
      unbind: function (e, t) {
        return this.off(e, null, t)
      },
      delegate: function (e, t, n, i) {
        return this.on(t, e, n, i)
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
      }
    });
    var xt = u.now(),
      Ct = /\?/,
      St = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    u.parseJSON = function (t) {
      if (e.JSON && e.JSON.parse) return e.JSON.parse(t + "");
      var n, i = null,
        o = u.trim(t + "");
      return o && !u.trim(o.replace(St, function (e, t, o, r) {
        return n && t && (i = 0), 0 === i ? e : (n = o || t, i += !r - !o, "")
      })) ? Function("return " + o)() : u.error("Invalid JSON: " + t)
    }, u.parseXML = function (t) {
      var n, i;
      if (!t || "string" != typeof t) return null;
      try {
        e.DOMParser ? (i = new DOMParser, n = i.parseFromString(t, "text/xml")) : (n = new ActiveXObject("Microsoft.XMLDOM"), n.async = "false", n.loadXML(t))
      } catch (o) {
        n = void 0
      }
      return n && n.documentElement && !n.getElementsByTagName("parsererror").length || u.error("Invalid XML: " + t), n
    };
    var kt, Tt, Et = /#.*$/,
      $t = /([?&])_=[^&]*/,
      Mt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      _t = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Nt = /^(?:GET|HEAD)$/,
      At = /^\/\//,
      Lt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
      It = {},
      jt = {},
      Pt = "*/".concat("*");
    try {
      Tt = location.href
    } catch (Dt) {
      Tt = k.createElement("a"), Tt.href = "", Tt = Tt.href
    }
    kt = Lt.exec(Tt.toLowerCase()) || [];

    function Ot(e) {
      return function (t, n) {
        "string" != typeof t && (n = t, t = "*");
        var i, o = 0,
          r = t.toLowerCase().match(N) || [];
        if (u.isFunction(n))
          for (; i = r[o++];) "+" === i.charAt(0) ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
      }
    }

    function Ht(e, t, n, i) {
      var o = {},
        r = e === jt;

      function a(s) {
        var p;
        return o[s] = !0, u.each(e[s] || [], function (e, s) {
          var c = s(t, n, i);
          return "string" != typeof c || r || o[c] ? r ? !(p = c) : void 0 : (t.dataTypes.unshift(c), a(c), !1)
        }), p
      }
      return a(t.dataTypes[0]) || !o["*"] && a("*")
    }

    function qt(e, t) {
      var n, i, o = u.ajaxSettings.flatOptions || {};
      for (i in t) void 0 !== t[i] && ((o[i] ? e : n || (n = {}))[i] = t[i]);
      return n && u.extend(!0, e, n), e
    }

    function Ft(e, t, n) {
      for (var i, o, r, a, s = e.contents, p = e.dataTypes;
        "*" === p[0];) p.shift(), void 0 === o && (o = e.mimeType || t.getResponseHeader("Content-Type"));
      if (o)
        for (a in s)
          if (s[a] && s[a].test(o)) {
            p.unshift(a);
            break
          } if (p[0] in n) r = p[0];
      else {
        for (a in n) {
          if (!p[0] || e.converters[a + " " + p[0]]) {
            r = a;
            break
          }
          i || (i = a)
        }
        r = r || i
      }
      return r ? (r !== p[0] && p.unshift(r), n[r]) : void 0
    }

    function Rt(e, t, n, i) {
      var o, r, a, s, p, c = {},
        d = e.dataTypes.slice();
      if (d[1])
        for (a in e.converters) c[a.toLowerCase()] = e.converters[a];
      for (r = d.shift(); r;)
        if (e.responseFields[r] && (n[e.responseFields[r]] = t), !p && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), p = r, r = d.shift())
          if ("*" === r) r = p;
          else if ("*" !== p && p !== r) {
        if (a = c[p + " " + r] || c["* " + r], !a)
          for (o in c)
            if (s = o.split(" "), s[1] === r && (a = c[p + " " + s[0]] || c["* " + s[0]])) {
              a === !0 ? a = c[o] : c[o] !== !0 && (r = s[0], d.unshift(s[1]));
              break
            } if (a !== !0)
          if (a && e["throws"]) t = a(t);
          else try {
            t = a(t)
          } catch (l) {
            return {
              state: "parsererror",
              error: a ? l : "No conversion from " + p + " to " + r
            }
          }
      }
      return {
        state: "success",
        data: t
      }
    }
    u.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Tt,
        type: "GET",
        isLocal: _t.test(kt[1]),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Pt,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /xml/,
          html: /html/,
          json: /json/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": u.parseJSON,
          "text xml": u.parseXML
        },
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      ajaxSetup: function (e, t) {
        return t ? qt(qt(e, u.ajaxSettings), t) : qt(u.ajaxSettings, e)
      },
      ajaxPrefilter: Ot(It),
      ajaxTransport: Ot(jt),
      ajax: function (e, t) {
        "object" == typeof e && (t = e, e = void 0), t = t || {};
        var n, i, o, r, a, s, p, c, d = u.ajaxSetup({}, t),
          l = d.context || d,
          f = d.context && (l.nodeType || l.jquery) ? u(l) : u.event,
          h = u.Deferred(),
          m = u.Callbacks("once memory"),
          g = d.statusCode || {},
          v = {},
          y = {},
          w = 0,
          b = "canceled",
          x = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (2 === w) {
                if (!c)
                  for (c = {}; t = Mt.exec(r);) c[t[1].toLowerCase()] = t[2];
                t = c[e.toLowerCase()]
              }
              return null == t ? null : t
            },
            getAllResponseHeaders: function () {
              return 2 === w ? r : null
            },
            setRequestHeader: function (e, t) {
              var n = e.toLowerCase();
              return w || (e = y[n] = y[n] || e, v[e] = t), this
            },
            overrideMimeType: function (e) {
              return w || (d.mimeType = e), this
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (2 > w)
                  for (t in e) g[t] = [g[t], e[t]];
                else x.always(e[x.status]);
              return this
            },
            abort: function (e) {
              var t = e || b;
              return p && p.abort(t), S(0, t), this
            }
          };
        if (h.promise(x).complete = m.add, x.success = x.done, x.error = x.fail, d.url = ((e || d.url || Tt) + "").replace(Et, "").replace(At, kt[1] + "//"), d.type = t.method || t.type || d.method || d.type, d.dataTypes = u.trim(d.dataType || "*").toLowerCase().match(N) || [""], null == d.crossDomain && (n = Lt.exec(d.url.toLowerCase()), d.crossDomain = !(!n || n[1] === kt[1] && n[2] === kt[2] && (n[3] || ("http:" === n[1] ? "80" : "443")) === (kt[3] || ("http:" === kt[1] ? "80" : "443")))), d.data && d.processData && "string" != typeof d.data && (d.data = u.param(d.data, d.traditional)), Ht(It, d, t, x), 2 === w) return x;
        s = u.event && d.global, s && 0 === u.active++ && u.event.trigger("ajaxStart"), d.type = d.type.toUpperCase(), d.hasContent = !Nt.test(d.type), o = d.url, d.hasContent || (d.data && (o = d.url += (Ct.test(o) ? "&" : "?") + d.data, delete d.data), d.cache === !1 && (d.url = $t.test(o) ? o.replace($t, "$1_=" + xt++) : o + (Ct.test(o) ? "&" : "?") + "_=" + xt++)), d.ifModified && (u.lastModified[o] && x.setRequestHeader("If-Modified-Since", u.lastModified[o]), u.etag[o] && x.setRequestHeader("If-None-Match", u.etag[o])), (d.data && d.hasContent && d.contentType !== !1 || t.contentType) && x.setRequestHeader("Content-Type", d.contentType), x.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + Pt + "; q=0.01" : "") : d.accepts["*"]);
        for (i in d.headers) x.setRequestHeader(i, d.headers[i]);
        if (d.beforeSend && (d.beforeSend.call(l, x, d) === !1 || 2 === w)) return x.abort();
        b = "abort";
        for (i in {
            success: 1,
            error: 1,
            complete: 1
          }) x[i](d[i]);
        if (p = Ht(jt, d, t, x)) {
          x.readyState = 1, s && f.trigger("ajaxSend", [x, d]), d.async && d.timeout > 0 && (a = setTimeout(function () {
            x.abort("timeout")
          }, d.timeout));
          try {
            w = 1, p.send(v, S)
          } catch (C) {
            if (!(2 > w)) throw C;
            S(-1, C)
          }
        } else S(-1, "No Transport");

        function S(e, t, n, i) {
          var c, v, y, b, C, S = t;
          2 !== w && (w = 2, a && clearTimeout(a), p = void 0, r = i || "", x.readyState = e > 0 ? 4 : 0, c = e >= 200 && 300 > e || 304 === e, n && (b = Ft(d, x, n)), b = Rt(d, b, x, c), c ? (d.ifModified && (C = x.getResponseHeader("Last-Modified"), C && (u.lastModified[o] = C), C = x.getResponseHeader("etag"), C && (u.etag[o] = C)), 204 === e || "HEAD" === d.type ? S = "nocontent" : 304 === e ? S = "notmodified" : (S = b.state, v = b.data, y = b.error, c = !y)) : (y = S, (e || !S) && (S = "error", 0 > e && (e = 0))), x.status = e, x.statusText = (t || S) + "", c ? h.resolveWith(l, [v, S, x]) : h.rejectWith(l, [x, S, y]), x.statusCode(g), g = void 0, s && f.trigger(c ? "ajaxSuccess" : "ajaxError", [x, d, c ? v : y]), m.fireWith(l, [x, S]), s && (f.trigger("ajaxComplete", [x, d]), --u.active || u.event.trigger("ajaxStop")))
        }
        return x
      },
      getJSON: function (e, t, n) {
        return u.get(e, t, n, "json")
      },
      getScript: function (e, t) {
        return u.get(e, void 0, t, "script")
      }
    }), u.each(["get", "post"], function (e, t) {
      u[t] = function (e, n, i, o) {
        return u.isFunction(n) && (o = o || i, i = n, n = void 0), u.ajax({
          url: e,
          type: t,
          dataType: o,
          data: n,
          success: i
        })
      }
    }), u._evalUrl = function (e) {
      return u.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        async: !1,
        global: !1,
        "throws": !0
      })
    }, u.fn.extend({
      wrapAll: function (e) {
        if (u.isFunction(e)) return this.each(function (t) {
          u(this).wrapAll(e.call(this, t))
        });
        if (this[0]) {
          var t = u(e, this[0].ownerDocument).eq(0).clone(!0);
          this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
            for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) e = e.firstChild;
            return e
          }).append(this)
        }
        return this
      },
      wrapInner: function (e) {
        return this.each(u.isFunction(e) ? function (t) {
          u(this).wrapInner(e.call(this, t))
        } : function () {
          var t = u(this),
            n = t.contents();
          n.length ? n.wrapAll(e) : t.append(e)
        })
      },
      wrap: function (e) {
        var t = u.isFunction(e);
        return this.each(function (n) {
          u(this).wrapAll(t ? e.call(this, n) : e)
        })
      },
      unwrap: function () {
        return this.parent().each(function () {
          u.nodeName(this, "body") || u(this).replaceWith(this.childNodes)
        }).end()
      }
    }), u.expr.filters.hidden = function (e) {
      return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !d.reliableHiddenOffsets() && "none" === (e.style && e.style.display || u.css(e, "display"))
    }, u.expr.filters.visible = function (e) {
      return !u.expr.filters.hidden(e)
    };
    var Vt = /%20/g,
      Bt = /\[\]$/,
      zt = /\r?\n/g,
      Wt = /^(?:submit|button|image|reset|file)$/i,
      Ut = /^(?:input|select|textarea|keygen)/i;

    function Xt(e, t, n, i) {
      var o;
      if (u.isArray(t)) u.each(t, function (t, o) {
        n || Bt.test(e) ? i(e, o) : Xt(e + "[" + ("object" == typeof o ? t : "") + "]", o, n, i)
      });
      else if (n || "object" !== u.type(t)) i(e, t);
      else
        for (o in t) Xt(e + "[" + o + "]", t[o], n, i)
    }
    u.param = function (e, t) {
      var n, i = [],
        o = function (e, t) {
          t = u.isFunction(t) ? t() : null == t ? "" : t, i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
        };
      if (void 0 === t && (t = u.ajaxSettings && u.ajaxSettings.traditional), u.isArray(e) || e.jquery && !u.isPlainObject(e)) u.each(e, function () {
        o(this.name, this.value)
      });
      else
        for (n in e) Xt(n, e[n], t, o);
      return i.join("&").replace(Vt, "+")
    }, u.fn.extend({
      serialize: function () {
        return u.param(this.serializeArray())
      },
      serializeArray: function () {
        return this.map(function () {
          var e = u.prop(this, "elements");
          return e ? u.makeArray(e) : this
        }).filter(function () {
          var e = this.type;
          return this.name && !u(this).is(":disabled") && Ut.test(this.nodeName) && !Wt.test(e) && (this.checked || !J.test(e))
        }).map(function (e, t) {
          var n = u(this).val();
          return null == n ? null : u.isArray(n) ? u.map(n, function (e) {
            return {
              name: t.name,
              value: e.replace(zt, "\r\n")
            }
          }) : {
            name: t.name,
            value: n.replace(zt, "\r\n")
          }
        }).get()
      }
    }), u.ajaxSettings.xhr = void 0 !== e.ActiveXObject ? function () {
      return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && Yt() || Kt()
    } : Yt;
    var Jt = 0,
      Qt = {},
      Gt = u.ajaxSettings.xhr();
    e.attachEvent && e.attachEvent("onunload", function () {
      for (var e in Qt) Qt[e](void 0, !0)
    }), d.cors = !!Gt && "withCredentials" in Gt, Gt = d.ajax = !!Gt, Gt && u.ajaxTransport(function (e) {
      if (!e.crossDomain || d.cors) {
        var t;
        return {
          send: function (n, i) {
            var o, r = e.xhr(),
              a = ++Jt;
            if (r.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
              for (o in e.xhrFields) r[o] = e.xhrFields[o];
            e.mimeType && r.overrideMimeType && r.overrideMimeType(e.mimeType), e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest");
            for (o in n) void 0 !== n[o] && r.setRequestHeader(o, n[o] + "");
            r.send(e.hasContent && e.data || null), t = function (n, o) {
              var s, p, c;
              if (t && (o || 4 === r.readyState))
                if (delete Qt[a], t = void 0, r.onreadystatechange = u.noop, o) 4 !== r.readyState && r.abort();
                else {
                  c = {}, s = r.status, "string" == typeof r.responseText && (c.text = r.responseText);
                  try {
                    p = r.statusText
                  } catch (d) {
                    p = ""
                  }
                  s || !e.isLocal || e.crossDomain ? 1223 === s && (s = 204) : s = c.text ? 200 : 404
                } c && i(s, p, c, r.getAllResponseHeaders())
            }, e.async ? 4 === r.readyState ? setTimeout(t) : r.onreadystatechange = Qt[a] = t : t()
          },
          abort: function () {
            t && t(void 0, !0)
          }
        }
      }
    });

    function Yt() {
      try {
        return new e.XMLHttpRequest
      } catch (t) {}
    }

    function Kt() {
      try {
        return new e.ActiveXObject("Microsoft.XMLHTTP")
      } catch (t) {}
    }
    u.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /(?:java|ecma)script/
      },
      converters: {
        "text script": function (e) {
          return u.globalEval(e), e
        }
      }
    }), u.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1)
    }), u.ajaxTransport("script", function (e) {
      if (e.crossDomain) {
        var t, n = k.head || u("head")[0] || k.documentElement;
        return {
          send: function (i, o) {
            t = k.createElement("script"), t.async = !0, e.scriptCharset && (t.charset = e.scriptCharset), t.src = e.url, t.onload = t.onreadystatechange = function (e, n) {
              (n || !t.readyState || /loaded|complete/.test(t.readyState)) && (t.onload = t.onreadystatechange = null, t.parentNode && t.parentNode.removeChild(t), t = null, n || o(200, "success"))
            }, n.insertBefore(t, n.firstChild)
          },
          abort: function () {
            t && t.onload(void 0, !0)
          }
        }
      }
    });
    var Zt = [],
      en = /(=)\?(?=&|$)|\?\?/;
    u.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = Zt.pop() || u.expando + "_" + xt++;
        return this[e] = !0, e
      }
    }), u.ajaxPrefilter("json jsonp", function (t, n, i) {
      var o, r, a, s = t.jsonp !== !1 && (en.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && en.test(t.data) && "data");
      return s || "jsonp" === t.dataTypes[0] ? (o = t.jsonpCallback = u.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(en, "$1" + o) : t.jsonp !== !1 && (t.url += (Ct.test(t.url) ? "&" : "?") + t.jsonp + "=" + o), t.converters["script json"] = function () {
        return a || u.error(o + " was not called"), a[0]
      }, t.dataTypes[0] = "json", r = e[o], e[o] = function () {
        a = arguments
      }, i.always(function () {
        e[o] = r, t[o] && (t.jsonpCallback = n.jsonpCallback, Zt.push(o)), a && u.isFunction(r) && r(a[0]), a = r = void 0
      }), "script") : void 0
    }), u.parseHTML = function (e, t, n) {
      if (!e || "string" != typeof e) return null;
      "boolean" == typeof t && (n = t, t = !1), t = t || k;
      var i = b.exec(e),
        o = !n && [];
      return i ? [t.createElement(i[1])] : (i = u.buildFragment([e], t, o), o && o.length && u(o).remove(), u.merge([], i.childNodes))
    };
    var tn = u.fn.load;
    u.fn.load = function (e, t, n) {
      if ("string" != typeof e && tn) return tn.apply(this, arguments);
      var i, o, r, a = this,
        s = e.indexOf(" ");
      return s >= 0 && (i = u.trim(e.slice(s, e.length)), e = e.slice(0, s)), u.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (r = "POST"), a.length > 0 && u.ajax({
        url: e,
        type: r,
        dataType: "html",
        data: t
      }).done(function (e) {
        o = arguments, a.html(i ? u("<div>").append(u.parseHTML(e)).find(i) : e)
      }).complete(n && function (e, t) {
        a.each(n, o || [e.responseText, t, e])
      }), this
    }, u.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
      u.fn[t] = function (e) {
        return this.on(t, e)
      }
    }), u.expr.filters.animated = function (e) {
      return u.grep(u.timers, function (t) {
        return e === t.elem
      }).length
    };
    var nn = e.document.documentElement;

    function on(e) {
      return u.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow)
    }
    u.offset = {
      setOffset: function (e, t, n) {
        var i, o, r, a, s, p, c, d = u.css(e, "position"),
          l = u(e),
          f = {};
        "static" === d && (e.style.position = "relative"), s = l.offset(), r = u.css(e, "top"), p = u.css(e, "left"), c = ("absolute" === d || "fixed" === d) && u.inArray("auto", [r, p]) > -1, c ? (i = l.position(), a = i.top, o = i.left) : (a = parseFloat(r) || 0, o = parseFloat(p) || 0), u.isFunction(t) && (t = t.call(e, n, s)), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + o), "using" in t ? t.using.call(e, f) : l.css(f)
      }
    }, u.fn.extend({
      offset: function (e) {
        if (arguments.length) return void 0 === e ? this : this.each(function (t) {
          u.offset.setOffset(this, e, t)
        });
        var t, n, i = {
            top: 0,
            left: 0
          },
          o = this[0],
          r = o && o.ownerDocument;
        return r ? (t = r.documentElement, u.contains(t, o) ? (typeof o.getBoundingClientRect !== O && (i = o.getBoundingClientRect()), n = on(r), {
          top: i.top + (n.pageYOffset || t.scrollTop) - (t.clientTop || 0),
          left: i.left + (n.pageXOffset || t.scrollLeft) - (t.clientLeft || 0)
        }) : i) : void 0
      },
      position: function () {
        if (this[0]) {
          var e, t, n = {
              top: 0,
              left: 0
            },
            i = this[0];
          return "fixed" === u.css(i, "position") ? t = i.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), u.nodeName(e[0], "html") || (n = e.offset()), n.top += u.css(e[0], "borderTopWidth", !0), n.left += u.css(e[0], "borderLeftWidth", !0)), {
            top: t.top - n.top - u.css(i, "marginTop", !0),
            left: t.left - n.left - u.css(i, "marginLeft", !0)
          }
        }
      },
      offsetParent: function () {
        return this.map(function () {
          for (var e = this.offsetParent || nn; e && !u.nodeName(e, "html") && "static" === u.css(e, "position");) e = e.offsetParent;
          return e || nn
        })
      }
    }), u.each({
      scrollLeft: "pageXOffset",
      scrollTop: "pageYOffset"
    }, function (e, t) {
      var n = /Y/.test(t);
      u.fn[e] = function (i) {
        return X(this, function (e, i, o) {
          var r = on(e);
          return void 0 === o ? r ? t in r ? r[t] : r.document.documentElement[i] : e[i] : void(r ? r.scrollTo(n ? u(r).scrollLeft() : o, n ? o : u(r).scrollTop()) : e[i] = o)
        }, e, i, arguments.length, null)
      }
    }), u.each(["top", "left"], function (e, t) {
      u.cssHooks[t] = Oe(d.pixelPosition, function (e, n) {
        return n ? (n = Ie(e, t), Pe.test(n) ? u(e).position()[t] + "px" : n) : void 0
      })
    }), u.each({
      Height: "height",
      Width: "width"
    }, function (e, t) {
      u.each({
        padding: "inner" + e,
        content: t,
        "": "outer" + e
      }, function (n, i) {
        u.fn[i] = function (i, o) {
          var r = arguments.length && (n || "boolean" != typeof i),
            a = n || (i === !0 || o === !0 ? "margin" : "border");
          return X(this, function (t, n, i) {
            var o;
            return u.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? u.css(t, n, a) : u.style(t, n, i, a)
          }, t, r ? i : void 0, r, null)
        }
      })
    }), u.fn.size = function () {
      return this.length
    }, u.fn.andSelf = u.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function () {
      return u
    });
    var rn = e.jQuery,
      an = e.$;
    return u.noConflict = function (t) {
      return e.$ === u && (e.$ = an), t && e.jQuery === u && (e.jQuery = rn), u
    }, typeof t === O && (e.jQuery = e.$ = u), u
  }), Array.prototype.filter || (Array.prototype.filter = function (e) {
      "use strict";
      if (void 0 === this || null === this) throw new TypeError;
      var t = Object(this),
        n = t.length >>> 0;
      if ("function" != typeof e) throw new TypeError;
      for (var i = [], o = arguments.length >= 2 ? arguments[1] : void 0, r = 0; r < n; r++)
        if (r in t) {
          var a = t[r];
          e.call(o, a, r, t) && i.push(a)
        } return i
    }), Array.prototype.map || (Array.prototype.map = function (e, t) {
      var n, i, o;
      if (null == this) throw new TypeError(" this is null or not defined");
      var r = Object(this),
        a = r.length >>> 0;
      if ("function" != typeof e) throw new TypeError(e + " is not a function");
      for (arguments.length > 1 && (n = t), i = new Array(a), o = 0; o < a;) {
        var s, p;
        o in r && (s = r[o], p = e.call(n, s, o, r), i[o] = p), o++
      }
      return i
    }), Array.prototype.reduce || (Array.prototype.reduce = function (e) {
      "use strict";
      if (null == this) throw new TypeError("Array.prototype.reduce called on null or undefined");
      if ("function" != typeof e) throw new TypeError(e + " is not a function");
      var t, n = Object(this),
        i = n.length >>> 0,
        o = 0;
      if (2 == arguments.length) t = arguments[1];
      else {
        for (; o < i && !(o in n);) o++;
        if (o >= i) throw new TypeError("Reduce of empty array with no initial value");
        t = n[o++]
      }
      for (; o < i; o++) o in n && (t = e(t, n[o], o, n));
      return t
    }), Array.prototype.forEach || (Array.prototype.forEach = function (e) {
      var t, n;
      if (null == this) throw new TypeError("this is null or not defined");
      var i = Object(this),
        o = i.length >>> 0;
      if ("function" != typeof e) throw new TypeError(e + " is not a function");
      for (arguments.length > 1 && (t = arguments[1]), n = 0; n < o;) {
        var r;
        n in i && (r = i[n], e.call(t, r, n, i)), n++
      }
    }),
    function () {
      if ("function" == typeof window.CustomEvent) return !1;

      function e(e, t) {
        t = t || {
          bubbles: !1,
          cancelable: !1,
          detail: null
        };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n
      }
      window.CustomEvent = e
    }(),
    function (e) {
      var t = window.Cookies,
        n = window.Cookies = e(window.jQuery);
      n.noConflict = function () {
        return window.Cookies = t, n
      }
    }(function (e) {
      var t = /\+/g;

      function n(e) {
        return c.raw ? e : encodeURIComponent(e)
      }

      function i(e) {
        return c.raw ? e : decodeURIComponent(e)
      }

      function o(e) {
        return n(c.json ? JSON.stringify(e) : String(e))
      }

      function r(e) {
        0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
        try {
          return e = decodeURIComponent(e.replace(t, " ")), c.json ? JSON.parse(e) : e
        } catch (n) {}
      }

      function a(e, t) {
        var n = c.raw ? e : r(e);
        return p(t) ? t(n) : n
      }

      function s() {
        for (var e, t, n = 0, i = {}; n < arguments.length; n++) {
          t = arguments[n];
          for (e in t) i[e] = t[e]
        }
        return i
      }

      function p(e) {
        return "[object Function]" === Object.prototype.toString.call(e)
      }
      var c = function (e, t, r) {
        if (arguments.length > 1 && !p(t)) {
          if (r = s(c.defaults, r), "number" == typeof r.expires) {
            var d = r.expires,
              l = r.expires = new Date;
            l.setMilliseconds(l.getMilliseconds() + 864e5 * d)
          }
          return document.cookie = [n(e), "=", o(t), r.expires ? "; expires=" + r.expires.toUTCString() : "", r.path ? "; path=" + r.path : "", r.domain ? "; domain=" + r.domain : "", r.secure ? "; secure" : ""].join("")
        }
        for (var u = e ? void 0 : {}, f = document.cookie ? document.cookie.split("; ") : [], h = 0, m = f.length; h < m; h++) {
          var g = f[h].split("="),
            v = i(g.shift()),
            y = g.join("=");
          if (e === v) {
            u = a(y, t);
            break
          }
          e || void 0 === (y = a(y)) || (u[v] = y)
        }
        return u
      };
      return c.get = c.set = c, c.defaults = {}, c.remove = function (e, t) {
        return c(e, "", s(t, {
          expires: -1
        })), !c(e)
      }, e && (e.cookie = c, e.removeCookie = c.remove), c
    }),
    function (e, t) {
      e.Handlebars = t()
    }(this, function () {
      return function (e) {
        var t = {};

        function n(i) {
          if (t[i]) return t[i].exports;
          var o = t[i] = {
            exports: {},
            id: i,
            loaded: !1
          };
          return e[i].call(o.exports, o, o.exports, n), o.loaded = !0, o.exports
        }
        return n.m = e, n.c = t, n.p = "", n(0)
      }([function (e, t, n) {
        "use strict";
        var i = n(7)["default"],
          o = n(8)["default"];
        t.__esModule = !0;
        var r = n(1),
          a = i(r),
          s = n(2),
          p = o(s),
          c = n(3),
          d = o(c),
          l = n(4),
          u = i(l),
          f = n(5),
          h = i(f),
          m = n(6),
          g = o(m);

        function v() {
          var e = new a.HandlebarsEnvironment;
          return u.extend(e, a), e.SafeString = p["default"], e.Exception = d["default"], e.Utils = u, e.escapeExpression = u.escapeExpression, e.VM = h, e.template = function (t) {
            return h.template(t, e)
          }, e
        }
        var y = v();
        y.create = v, g["default"](y), y["default"] = y, t["default"] = y, e.exports = t["default"]
      }, function (e, t, n) {
        "use strict";
        var i = n(7)["default"],
          o = n(8)["default"];
        t.__esModule = !0, t.HandlebarsEnvironment = g, t.createFrame = b;
        var r = n(4),
          a = i(r),
          s = n(3),
          p = o(s),
          c = "3.0.1";
        t.VERSION = c;
        var d = 6;
        t.COMPILER_REVISION = d;
        var l = {
          1: "<= 1.0.rc.2",
          2: "== 1.0.0-rc.3",
          3: "== 1.0.0-rc.4",
          4: "== 1.x.x",
          5: "== 2.0.0-alpha.x",
          6: ">= 2.0.0-beta.1"
        };
        t.REVISION_CHANGES = l;
        var u = a.isArray,
          f = a.isFunction,
          h = a.toString,
          m = "[object Object]";

        function g(e, t) {
          this.helpers = e || {}, this.partials = t || {}, v(this)
        }
        g.prototype = {
          constructor: g,
          logger: y,
          log: w,
          registerHelper: function (e, t) {
            if (h.call(e) === m) {
              if (t) throw new p["default"]("Arg not supported with multiple helpers");
              a.extend(this.helpers, e)
            } else this.helpers[e] = t
          },
          unregisterHelper: function (e) {
            delete this.helpers[e]
          },
          registerPartial: function (e, t) {
            if (h.call(e) === m) a.extend(this.partials, e);
            else {
              if ("undefined" == typeof t) throw new p["default"]("Attempting to register a partial as undefined");
              this.partials[e] = t
            }
          },
          unregisterPartial: function (e) {
            delete this.partials[e]
          }
        };

        function v(e) {
          e.registerHelper("helperMissing", function () {
            if (1 !== arguments.length) throw new p["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"')
          }), e.registerHelper("blockHelperMissing", function (t, n) {
            var i = n.inverse,
              o = n.fn;
            if (t === !0) return o(this);
            if (t === !1 || null == t) return i(this);
            if (u(t)) return t.length > 0 ? (n.ids && (n.ids = [n.name]), e.helpers.each(t, n)) : i(this);
            if (n.data && n.ids) {
              var r = b(n.data);
              r.contextPath = a.appendContextPath(n.data.contextPath, n.name), n = {
                data: r
              }
            }
            return o(t, n)
          }), e.registerHelper("each", function (e, t) {
            if (!t) throw new p["default"]("Must pass iterator to #each");
            var n = t.fn,
              i = t.inverse,
              o = 0,
              r = "",
              s = void 0,
              c = void 0;
            t.data && t.ids && (c = a.appendContextPath(t.data.contextPath, t.ids[0]) + "."), f(e) && (e = e.call(this)), t.data && (s = b(t.data));

            function d(t, i, o) {
              s && (s.key = t, s.index = i, s.first = 0 === i, s.last = !!o, c && (s.contextPath = c + t)), r += n(e[t], {
                data: s,
                blockParams: a.blockParams([e[t], t], [c + t, null])
              })
            }
            if (e && "object" == typeof e)
              if (u(e))
                for (var l = e.length; o < l; o++) d(o, o, o === e.length - 1);
              else {
                var h = void 0;
                for (var m in e) e.hasOwnProperty(m) && (h && d(h, o - 1), h = m, o++);
                h && d(h, o - 1, !0)
              } return 0 === o && (r = i(this)), r
          }), e.registerHelper("if", function (e, t) {
            return f(e) && (e = e.call(this)), !t.hash.includeZero && !e || a.isEmpty(e) ? t.inverse(this) : t.fn(this)
          }), e.registerHelper("unless", function (t, n) {
            return e.helpers["if"].call(this, t, {
              fn: n.inverse,
              inverse: n.fn,
              hash: n.hash
            })
          }), e.registerHelper("with", function (e, t) {
            f(e) && (e = e.call(this));
            var n = t.fn;
            if (a.isEmpty(e)) return t.inverse(this);
            if (t.data && t.ids) {
              var i = b(t.data);
              i.contextPath = a.appendContextPath(t.data.contextPath, t.ids[0]), t = {
                data: i
              }
            }
            return n(e, t)
          }), e.registerHelper("log", function (t, n) {
            var i = n.data && null != n.data.level ? parseInt(n.data.level, 10) : 1;
            e.log(i, t)
          }), e.registerHelper("lookup", function (e, t) {
            return e && e[t]
          })
        }
        var y = {
          methodMap: {
            0: "debug",
            1: "info",
            2: "warn",
            3: "error"
          },
          DEBUG: 0,
          INFO: 1,
          WARN: 2,
          ERROR: 3,
          level: 1,
          log: function (e, t) {
            if ("undefined" != typeof console && y.level <= e) {
              var n = y.methodMap[e];
              (console[n] || console.log).call(console, t)
            }
          }
        };
        t.logger = y;
        var w = y.log;
        t.log = w;

        function b(e) {
          var t = a.extend({}, e);
          return t._parent = e, t
        }
      }, function (e, t, n) {
        "use strict";
        t.__esModule = !0;

        function i(e) {
          this.string = e
        }
        i.prototype.toString = i.prototype.toHTML = function () {
          return "" + this.string
        }, t["default"] = i, e.exports = t["default"]
      }, function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];

        function o(e, t) {
          var n = t && t.loc,
            r = void 0,
            a = void 0;
          n && (r = n.start.line, a = n.start.column, e += " - " + r + ":" + a);
          for (var s = Error.prototype.constructor.call(this, e), p = 0; p < i.length; p++) this[i[p]] = s[i[p]];
          Error.captureStackTrace && Error.captureStackTrace(this, o), n && (this.lineNumber = r, this.column = a)
        }
        o.prototype = new Error, t["default"] = o, e.exports = t["default"]
      }, function (e, t, n) {
        "use strict";
        t.__esModule = !0, t.extend = s, t.indexOf = l, t.escapeExpression = u, t.isEmpty = f, t.blockParams = h, t.appendContextPath = m;
        var i = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
          },
          o = /[&<>"'`]/g,
          r = /[&<>"'`]/;

        function a(e) {
          return i[e]
        }

        function s(e) {
          for (var t = 1; t < arguments.length; t++)
            for (var n in arguments[t]) Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
          return e
        }
        var p = Object.prototype.toString;
        t.toString = p;
        var c = function (e) {
          return "function" == typeof e
        };
        c(/x/) && (t.isFunction = c = function (e) {
          return "function" == typeof e && "[object Function]" === p.call(e)
        });
        var c;
        t.isFunction = c;
        var d = Array.isArray || function (e) {
          return !(!e || "object" != typeof e) && "[object Array]" === p.call(e)
        };
        t.isArray = d;

        function l(e, t) {
          for (var n = 0, i = e.length; n < i; n++)
            if (e[n] === t) return n;
          return -1
        }

        function u(e) {
          if ("string" != typeof e) {
            if (e && e.toHTML) return e.toHTML();
            if (null == e) return "";
            if (!e) return e + "";
            e = "" + e
          }
          return r.test(e) ? e.replace(o, a) : e
        }

        function f(e) {
          return !e && 0 !== e || !(!d(e) || 0 !== e.length)
        }

        function h(e, t) {
          return e.path = t, e
        }

        function m(e, t) {
          return (e ? e + "." : "") + t
        }
      }, function (e, t, n) {
        "use strict";
        var i = n(7)["default"],
          o = n(8)["default"];
        t.__esModule = !0, t.checkRevision = d, t.template = l, t.wrapProgram = u, t.resolvePartial = f, t.invokePartial = h, t.noop = m;
        var r = n(4),
          a = i(r),
          s = n(3),
          p = o(s),
          c = n(1);

        function d(e) {
          var t = e && e[0] || 1,
            n = c.COMPILER_REVISION;
          if (t !== n) {
            if (t < n) {
              var i = c.REVISION_CHANGES[n],
                o = c.REVISION_CHANGES[t];
              throw new p["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + i + ") or downgrade your runtime to an older version (" + o + ").")
            }
            throw new p["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + e[1] + ").")
          }
        }

        function l(e, t) {
          if (!t) throw new p["default"]("No environment passed to template");
          if (!e || !e.main) throw new p["default"]("Unknown template object: " + typeof e);
          t.VM.checkRevision(e.compiler);

          function n(n, i, o) {
            o.hash && (i = a.extend({}, i, o.hash)), n = t.VM.resolvePartial.call(this, n, i, o);
            var r = t.VM.invokePartial.call(this, n, i, o);
            if (null == r && t.compile && (o.partials[o.name] = t.compile(n, e.compilerOptions, t), r = o.partials[o.name](i, o)), null != r) {
              if (o.indent) {
                for (var s = r.split("\n"), c = 0, d = s.length; c < d && (s[c] || c + 1 !== d); c++) s[c] = o.indent + s[c];
                r = s.join("\n")
              }
              return r
            }
            throw new p["default"]("The partial " + o.name + " could not be compiled when running in runtime-only mode")
          }
          var i = {
            strict: function (e, t) {
              if (!(t in e)) throw new p["default"]('"' + t + '" not defined in ' + e);
              return e[t]
            },
            lookup: function (e, t) {
              for (var n = e.length, i = 0; i < n; i++)
                if (e[i] && null != e[i][t]) return e[i][t]
            },
            lambda: function (e, t) {
              return "function" == typeof e ? e.call(t) : e
            },
            escapeExpression: a.escapeExpression,
            invokePartial: n,
            fn: function (t) {
              return e[t]
            },
            programs: [],
            program: function (e, t, n, i, o) {
              var r = this.programs[e],
                a = this.fn(e);
              return t || o || i || n ? r = u(this, e, a, t, n, i, o) : r || (r = this.programs[e] = u(this, e, a)), r
            },
            data: function (e, t) {
              for (; e && t--;) e = e._parent;
              return e
            },
            merge: function (e, t) {
              var n = e || t;
              return e && t && e !== t && (n = a.extend({}, t, e)), n
            },
            noop: t.VM.noop,
            compilerInfo: e.compiler
          };

          function o(t) {
            var n = void 0 === arguments[1] ? {} : arguments[1],
              r = n.data;
            o._setup(n), !n.partial && e.useData && (r = g(t, r));
            var a = void 0,
              s = e.useBlockParams ? [] : void 0;
            return e.useDepths && (a = n.depths ? [t].concat(n.depths) : [t]), e.main.call(i, t, i.helpers, i.partials, r, s, a)
          }
          return o.isTop = !0, o._setup = function (n) {
            n.partial ? (i.helpers = n.helpers, i.partials = n.partials) : (i.helpers = i.merge(n.helpers, t.helpers), e.usePartial && (i.partials = i.merge(n.partials, t.partials)))
          }, o._child = function (t, n, o, r) {
            if (e.useBlockParams && !o) throw new p["default"]("must pass block params");
            if (e.useDepths && !r) throw new p["default"]("must pass parent depths");
            return u(i, t, e[t], n, 0, o, r)
          }, o
        }

        function u(e, t, n, i, o, r, a) {
          function s(t) {
            var o = void 0 === arguments[1] ? {} : arguments[1];
            return n.call(e, t, e.helpers, e.partials, o.data || i, r && [o.blockParams].concat(r), a && [t].concat(a))
          }
          return s.program = t, s.depth = a ? a.length : 0, s.blockParams = o || 0, s
        }

        function f(e, t, n) {
          return e ? e.call || n.name || (n.name = e, e = n.partials[e]) : e = n.partials[n.name], e
        }

        function h(e, t, n) {
          if (n.partial = !0, void 0 === e) throw new p["default"]("The partial " + n.name + " could not be found");
          if (e instanceof Function) return e(t, n)
        }

        function m() {
          return ""
        }

        function g(e, t) {
          return t && "root" in t || (t = t ? c.createFrame(t) : {}, t.root = e), t
        }
      }, function (e, t, n) {
        (function (n) {
          "use strict";
          t.__esModule = !0, t["default"] = function (e) {
            var t = "undefined" != typeof n ? n : window,
              i = t.Handlebars;
            e.noConflict = function () {
              t.Handlebars === e && (t.Handlebars = i)
            }
          }, e.exports = t["default"]
        }).call(t, function () {
          return this
        }())
      }, function (e, t, n) {
        "use strict";
        t["default"] = function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if ("object" == typeof e && null !== e)
            for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return t["default"] = e, t
        }, t.__esModule = !0
      }, function (e, t, n) {
        "use strict";
        t["default"] = function (e) {
          return e && e.__esModule ? e : {
            "default": e
          }
        }, t.__esModule = !0
      }])
    }),
    function (e) {
      "use strict";
      e.console = e.console || {};
      for (var t, n, i = e.console, o = {}, r = function () {}, a = "memory".split(","), s = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); t = a.pop();) i[t] || (i[t] = o);
      for (; n = s.pop();) i[n] || (i[n] = r)
    }("undefined" == typeof window ? this : window), window.Shoppad = window.Shoppad || {}, Shoppad.$ ? jQuery.noConflict(!0) : Shoppad.$ = jQuery.noConflict(!0);
  var $ = Shoppad.$;
  Shoppad.Cookies ? Cookies.noConflict() : Shoppad.Cookies = Cookies.noConflict(), Shoppad.Handlebars || (Shoppad.Handlebars = Handlebars), Handlebars.noConflict(), Shoppad = $.extend(!0, Shoppad, {
    apps: {},
    getUrlQuery: function (e) {
      var t = document.createElement("a");
      return t.href = e, t.search
    },
    getUrlParameterByName: function (e, t) {
      var n = t ? this.getUrlQuery(t) : window.location.search;
      e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var i = new RegExp("[\\?&]" + e + "=([^&#]*)"),
        o = i.exec(n);
      return null == o ? "" : decodeURIComponent(o[1].replace(/\+/g, " "))
    },
    loadScript: function (e, t) {
      var n = document.createElement("script");
      n.type = "text/javascript", n.readyState ? n.onreadystatechange = function () {
        "loaded" != n.readyState && "complete" != n.readyState || (n.onreadystatechange = null, t())
      } : n.onload = function () {
        t()
      }, n.src = e, document.getElementsByTagName("head")[0].appendChild(n)
    }
  });

  function getEventData(e, t) {
    return e._data ? e._data(t, "events") : e.data ? e.data(t, "events") : null
  }

  function DatePicker() {
    var e = this;
    e.intervals = {
      legacyHandlersFix: {}
    };

    function t(e) {
      var t = $("#infiniteoptions-container .datepicker input").is(e.target),
        n = $("#infiniteoptions-container .ui-datepicker-inline").is(e.target),
        i = $("#infiniteoptions-container .ui-datepicker-inline").has(e.target).length;
      t || n || i || $("#infiniteoptions-container .ui-datepicker-inline").hide()
    }

    function n(e) {
      e.handler = t
    }

    function i(e, t) {
      if (!e[t]) return !1;
      for (var i = 0; i < e[t].length; i++) {
        var o = e[t][i],
          r = "!$('#infiniteoptions-container .ui-datepicker-inline').is(e.target)";
        if (o.handler.toString().indexOf(r) >= 0) return spLog(!1, "date picker: legacy " + t + " event handler found, replacing.", !0), n(o), !0
      }
      return !1
    }

    function o(t, n) {
      var o = getEventData(n, window.document);
      if (!o) return void e.intervals.legacyHandlersFix[t].count++;
      if (replacedTouchStart = i(o, "touchstart"), replacedMouseUp = i(o, "mouseup"), !replacedTouchStart && !replacedMouseUp) return e.intervals.legacyHandlersFix[t].count >= 9 ? (spLog(!1, "date picker: unable to locate the legacy datepicker handlers event after polling for 5 seconds.", !0), delete e.intervals.legacyHandlersFix[t], void clearInterval(t)) : void e.intervals.legacyHandlersFix[t].count++;
      for (var r in e.intervals.legacyHandlersFix) delete e.intervals.legacyHandlersFix[r], clearInterval(r)
    }
    return e.hasDatePicker = function (e) {
      var t = e.reduce(function (e, t) {
        return e.concat(t)
      }, []);
      return t.filter(function (e) {
        return "datepicker" === e["class"]
      }).length > 0
    }, e.fixLegacyHandlers = function () {
      spLog(!1, "date picker: input found, polling for legacy event handlers.", !0);
      var t = setInterval(function () {
        o(t, window.Shoppad.$)
      }, 500);
      if (e.intervals.legacyHandlersFix[t] = {
          count: 0
        }, window.$) {
        var n = setInterval(function () {
          o(n, window.$)
        }, 500);
        e.intervals.legacyHandlersFix[n] = {
          count: 0
        }
      }
    }, e
  }
  var datePicker = new DatePicker,
    customizeryRules = new function () {
      var e = this;
      return e.getUrlQueryString = function (e) {
        var t = document.createElement("a");
        return t.href = e, t.search
      }, e.getUrlParameterByName = function (t, n) {
        t = t.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var i = new RegExp("[\\?&]" + t + "=([^&#]*)"),
          o = i.exec(e.getUrlQueryString(n));
        return null == o ? "" : decodeURIComponent(o[1].replace(/\+/g, " "))
      }, e.getHandleFromUrl = function (e) {
        var t = e.replace(/\/$/, "").split("/");
        return ("products" == t[t.length - 2] || "products_preview" === t.pop()) && t[t.length - 1].replace(/(.*)?\?.*$/, "$1")
      }, e.getProduct = function (t, n) {
        var i = e.getProductFromWindow();
        i ? n(i) : t ? e.pullProduct(t, n) : n(!1)
      }, e.getProductFromWindow = function () {
        function e(e) {
          return !!(e instanceof Object && e.hasOwnProperty) && (e.hasOwnProperty("handle") && e.hasOwnProperty("vendor") && e.hasOwnProperty("tags") && (e.hasOwnProperty("type") || e.hasOwnProperty("product_type")))
        }
        return window.shoppadProductJSON instanceof Object ? window.shoppadProductJSON : window.productJSON instanceof Array && e(window.productJSON[0]) ? window.productJSON[0] : !!(window.productJSON instanceof Object && e(window.productJSON)) && window.productJSON
      }, e.pullProduct = function (e, t) {
        if (window.Shoppad && window.Shoppad.pos && window.Shoppad.pos.products) {
          var n = window.Shoppad.pos.products.find(function (t) {
            return t.handle === e
          });
          return void(n && t(n))
        }
        if (window.IS_SHOPPAD) return void $.getJSON("//" + window.shopConfiguration.uuid + ".myshopify.com/products/" + e + ".json", function (e) {
          t(e.product)
        });
        var i = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/",
          o = i + "products/" + e + ".json";
        $.ajax({
          dataType: "json",
          cache: !1,
          url: o,
          success: function (e) {
            t(e.product)
          },
          error: function (e) {
            throw "Infinite Options product lookup error"
          }
        })
      }, e.checkRuleForProduct = function (t, n) {
        switch (t.selector = String(t.selector).toLowerCase(), t.type) {
          case "all":
            return !0;
          case "product_handle":
            return n.handle.toLowerCase() === t.selector;
          case "product_url":
            var i = t.selector;
            return n.handle.toLowerCase() === e.getHandleFromUrl(i);
          case "tag":
            return "string" == typeof n.tags ? (n.tags = n.tags.toLowerCase(), n.tags.indexOf(", ") >= 0 ? n.tags.split(", ").indexOf(t.selector) >= 0 : n.tags === t.selector) : (n.tags = n.tags.join(",").toLowerCase().split(","), n.tags.indexOf(t.selector) >= 0);
          case "vendor":
            return n.vendor.toLowerCase() === t.selector;
          case "type":
            if (n.type) return n.type.toLowerCase() === t.selector;
            if (n.product_type) return n.product_type.toLowerCase() === t.selector
        }
      }, e.checkRuleSetForProduct = function (t, n) {
        var i = !1;
        return $.each(t, function (t, o) {
          if (o && o.selector && o.type && e.checkRuleForProduct(o, n)) return i = !0, !1
        }), i
      }, e.isShopifyAdmin = function () {
        return !!document.getElementById("admin_bar_iframe")
      }, e.checkAllRules = function (t, n, i, o) {
        return t[n] && t[n].length ? (i || (i = e.getHandleFromUrl(location.pathname)), void e.getProduct(i, function (i) {
          return i ? void o(t[n].filter(function (t) {
            if (!t.ruleSets || !t.ruleSets.length) return !1;
            if (t.allProducts) return !0;
            var n = t.ruleSets.filter(function (t) {
              return e.checkRuleSetForProduct(t, i)
            });
            return n.length === t.ruleSets.length
          }), i) : o(null)
        })) : o(null)
      }, e
    },
    priceMod = {
      options: {
        appendPrice: 1,
        skipPriceModIfVisible: ""
      },
      variantSubmissionAlters: [],
      orderId: "",
      variantOrdering: [],
      activeVariants: {},
      isLegacyValue: function (e) {
        return !e || "string" == typeof e || e instanceof String
      },
      hasVariant: function (e) {
        return !priceMod.isLegacyValue(e) && e.variant && e.variant.id && e.variant.price && e.variant.variantId
      },
      formatWithDelimiters: function (e, t, n) {
        if (null == t && (t = 2), null == n && (n = "."), isNaN(e) || null === e) return 0;
        e /= 100, e = e.toFixed(t);
        var i = e.split("."),
          o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1");
        return cents = i[1] ? n + i[1] : "", o + cents
      },
      priceMarkup: function (e, t) {
        return '<span class="money">' + (t ? "" : "$") + e + "</span>"
      },
      getValueText: function (e) {
        if (priceMod.isLegacyValue(e)) return {
          value: e,
          display: e
        };
        // console.log('priceMod', priceMod, priceMod.options.appendPrice, priceMod.options);
        if (e && e.label) {
          if (!priceMod.options.appendPrice || !priceMod.hasVariant(e)) return {
            value: e.label,
            display: e.label
          };
          // var t = $("<span>" + e.label + " +" + priceMod.priceMarkup(e.variant.price) + "</span>");
          var t = $('<span class="inf-inner" data-price="' + e.variant.price.replace('.00', '') + '">' + e.label + " +" + priceMod.priceMarkup(e.variant.price.replace('.00', '')) + '</span>');
          return {
            value: t.text(),
            display: t
          }
        }
        return {
          value: !1,
          display: !1
        }
      },
      getVariantString: function (e, t, n) {
        return e + "-" + t + "-" + priceMod.variantOrdering.length
      },
      findInput: function (e) {
        return window.Shoppad.$('[variant-string="' + e + '"]')
      },
      variantData: function (e, t) {
        return {
          name: e,
          productId: t.data("variant-product"),
          handle: t.data("product-handle"),
          variantId: t.data("variant-id"),
          price: t.data("variant-price"),
          quantity: 1,
          $input: t
        }
      },
      addVariant: function (e, t, n) {
        priceMod.orderId || (priceMod.orderId = (new Date).getTime()), priceMod.activeVariants[t] = priceMod.variantData(e, n), spLog({
          string: t,
          data: priceMod.activeVariants[t]
        }, "adding variant to current", !0), eventApi.productBundleAdd({
          name: e,
          element: n,
          productBundle: priceMod.activeVariants[t],
          orderId: priceMod.orderId
        })
      },
      removeVariant: function (e, t, n) {
        var i = priceMod.activeVariants[t];
        spLog({
          string: t,
          data: i
        }, "removing variant from current", !0), delete priceMod.activeVariants[t], eventApi.productBundleRemove({
          name: e,
          element: n,
          productBundle: i
        })
      },
      variantChangeSingle: function (e, t) {
        var n = t.data("variant-string");
        t.is(":checked") && !priceMod.activeVariants[n] ? priceMod.addVariant(e, n, t) : !t.is(":checked") && priceMod.activeVariants[n] && priceMod.removeVariant(e, n, t)
      },
      variantChange: function (e, t) {
        window.Shoppad.$.each(t, function (t, n) {
          var i = $(n);
          i.data("variant-id") && priceMod.variantChangeSingle(e, i)
        })
      },
      attachData: function (e, t, n, i) {
        if (priceMod.hasVariant(n)) {
          var o = $(e),
            r = priceMod.getVariantString(t, n.variant.variantId, i);
          o.data("variant-string", r), o.data("variant-product", n.variant.id), o.data("product-handle", n.variant.handle), o.data("variant-id", n.variant.variantId), o.data("variant-price", n.variant.price), priceMod.variantOrdering.push(r)
        }
        return e
      },
      postingQueue: [],
      postVariant: function (e, t) {
        var n = eventApi.beforeVariantPost({
          variant: e,
          callback: t,
          properties: {
            _io_parent_order_group: priceMod.orderId,
            _io_field_name: e.name
          }
        });
        return !n && void window.Shoppad.$.post("/cart/add.js", {
          quantity: e.quantity,
          id: e.variantId,
          properties: Object.assign(e.properties ? e.properties : {}, {
            _io_parent_order_group: priceMod.orderId,
            _io_field_name: e.name
          })
        }, function (e) {
          return spLog(e, "variant post complete", !0), e && e.variant_id ? void t() : t(new Error("Was not added to cart"))
        }, "json").fail(function (e, n, i) {
          return spLog({
            xhr: e,
            status: n,
            error: i
          }, "variant post fail", !0), e && e.responseJSON && e.responseJSON.status && 422 === e.responseJSON.status ? t(e.responseJSON, !0) : void t(i)
        })
      },
      postVariants: function (e, t) {
        if (priceMod.postingQueue.length) {
          var n = priceMod.postingQueue.shift();
          priceMod.postVariant(n, function (n, i) {
            if (n) {
              if (i && n.description) return spLog(n, "customer facing error", !0), alert(n.description), void t(n);
              spLog(n, "removing variant from current", !0)
            }
            priceMod.postVariants(e, t)
          })
        } else t()
      },
      getVariantSubmissions: function () {
        if (priceMod.options.skipPriceModIfVisible && $(priceMod.options.skipPriceModIfVisible).is(":visible")) return null;
        var e = [];
        if (window.Shoppad && window.Shoppad.pos)
          for (var t in priceMod.activeVariants) e.push(priceMod.activeVariants[t]);
        else $.each(priceMod.variantOrdering.reverse(), function (t, n) {
          priceMod.activeVariants[n] && e.push(priceMod.activeVariants[n])
        });
        return priceMod.alterVariantValues(e)
      },
      alterVariantValues: function (e) {
        return e && e.length && this.variantSubmissionAlters.length && $.each(this.variantSubmissionAlters, function (t, n) {
          e = n(e), e || spLog(n, "priceMod: variantSubmissionAlter did not return any values", !0)
        }), e
      },
      updateOrderGroup: function (e, t) {
        if (!window.Shoppad || !window.Shoppad.pos) {
          if (!t.length) return void $('[name="properties[_io_order_group]"]').remove();
          if ($('[name="properties[_io_order_group]"]').length) $('[name="properties[_io_order_group]"]').attr("value", priceMod.orderId);
          else {
            var n = $("<input />").attr("type", "hidden").attr("name", "properties[_io_order_group]").val(priceMod.orderId);
            $(e.target).before(n)
          }
        }
      },
      addToCart: function (e, t, n) {
        if (n = n ? priceMod.alterVariantValues(n) : priceMod.getVariantSubmissions(), !n || !n.length) return !0;
        e.preventDefault(), e.stopImmediatePropagation(), priceMod.orderId || (priceMod.orderId = (new Date).getTime());
        var i = priceMod.getVariantSubmissions();
        priceMod.updateOrderGroup(e, i);
        var o = $(window.Shoppad.apps.infiniteoptions.quantityInput).val() || 1;
        $.each(n, function (e, t) {
          t.quantity = o
        }), window.Shoppad && window.Shoppad.pos && $.each(n, function (e, t) {
          t.containerId && (t.quantity = $('[data-infinite-options-container-id="' + t.containerId + '"]').data("line-item-quantity"))
        });
        var r = eventApi.beforeVariantsPost({
          variantValues: n,
          orderId: priceMod.orderId,
          callback: t
        });
        return !r && (priceMod.postingQueue = n, priceMod.postVariants(e, function (e) {
          priceMod.orderId = "", t && t(e)
        }), !1)
      },
      resetState: function () {
        priceMod.orderId = "", priceMod.options = {
          appendPrice: 1,
          skipPriceModIfVisible: ""
        }, priceMod.variantOrdering = [], priceMod.variantSubmissionAlters = [], priceMod.activeVariants = {}
      },
      init: function (e) {
        priceMod.resetState(), $.extend(priceMod.options, e)
      }
    },
    priceModCart = {
      form: null,
      cartItems: [],
      parentItems: {},
      variantItems: {},
      options: {
        appendPrice: !1,
        appendCount: !0,
        hideVariantRow: !1,
        disableVariantRow: !0
      },
      getCart: function (e) {
        window.Shoppad.$.getJSON("/cart.js", function (t) {
          e(t)
        }).fail(function (e, t, n) {
          console.log(n)
        })
      },
      postCart: function (e, t) {
        window.Shoppad.$.post("/cart/update.js", e, function (e) {
          t()
        }, "json").fail(function (e, n, i) {
          console.log(i), t(i)
        })
      },
      updateFromCart: function (e) {
        priceModCart.getCart(function (t) {
          var n = {
              updates: []
            },
            i = !1;
          $.each(t.items, function (e, t) {
            var o = priceModCart.cartItems[e];
            if (o && o.quantityField) {
              var r = parseInt(o.quantityField.value, 10);
              if (o.variant) {
                var a = void 0 !== priceModCart.parentItems[o.group] ? priceModCart.cartItems[priceModCart.parentItems[o.group]] : null;
                if (a)
                  if (a.quantityField && parseInt(a.quantityField.value, 10) !== r) n.updates.push(a.quantityField.value), i = !0;
                  else {
                    if (priceModCart.options.appendPrice || priceModCart.options.appendCount) {
                      var s = "";
                      priceModCart.options.appendPrice && (s += '<span class="customizery-variant-price">+' + priceMod.priceMarkup(priceMod.formatWithDelimiters(t.price * r)) + "</span>"), priceModCart.options.appendCount && (s += '<span class="customizery-variant-count"></span> x ' + r + "</span>"), a.anchor.siblings('[data-io-field-name="' + t.properties._io_field_name + '"]').each(function () {
                        $("customizery-variant-price, .customizery-variant-count", $(this)).remove()
                      }).append(s)
                    }
                    n.updates.push(r)
                  }
                else n.updates.push(0), i = !0
              } else n.updates.push(r)
            }
          }), i ? e ? priceModCart.postCart(n, e) : priceModCart.postCart(n, function (e) {
            e || window.location.reload(!1)
          }) : e && e()
        })
      },
      buildCartModel: function () {
        priceModCart.parentItems = [], priceModCart.cartItems = [], priceModCart.variantItems = [];
        var e = $("[data-io-cart-item]");
        if (e.length) {
          var t = $('input[name="updates[]"]');
          e.each(function (e, n) {
            var i = $(n).parent(),
              o = $("[data-io-order-group]", i);
            if (o.length) return priceModCart.parentItems[o.data("io-order-group")] = e, void priceModCart.cartItems.push({
              parent: !0,
              index: e,
              group: o.data("io-order-group"),
              anchor: o,
              quantityField: t[e]
            });
            var r = $("[data-io-parent-order-group]", i);
            if (r.length) {
              if (priceModCart.variantItems[r.data("io-parent-order-group") + "-" + e] = e, priceModCart.cartItems.push({
                  variant: !0,
                  index: e,
                  group: r.data("io-parent-order-group"),
                  anchor: r,
                  quantityField: t[e]
                }), priceModCart.options.hideVariantRow || priceModCart.options.disableVariantRow) {
                var a = r.closest(".cart-row, .cart__row, .cart-item");
                priceModCart.options.hideVariantRow ? a.hide() : priceModCart.options.disableVariantRow && ($(t[e]).attr("disabled", "disabled").siblings("button").attr("disabled", "disabled"), $('a[href^="/cart/change"]', a).css({
                  opacity: 0
                }))
              }
            } else priceModCart.cartItems.push({
              index: e,
              quantityField: t[e]
            })
          }), priceModCart.updateFromCart()
        }
      },
      cartSubmitClick: function (e, t) {
        if (!t || !t.skip_processing) {
          e.preventDefault(), e.stopPropagation();
          var n = this;
          priceModCart.updateFromCart(function () {
            $(n).trigger("click", {
              skip_processing: !0
            })
          })
        }
      },
      bindCart: function () {
        if (priceModCart.form && priceModCart.form.length || (priceModCart.form = $('form[action$="/cart"]')), priceModCart.form.length) {
          if (priceModCart.form.hasClass("io-form-processed")) return void priceModCart.buildCartModel();
          priceModCart.form.addClass("io-form-processed"), $('[type="submit"]', $('form[action$="/cart"]')).on("click", priceModCart.cartSubmitClick), priceModCart.buildCartModel()
        }
      },
      origOpen: null,
      init: function (e) {
        $.extend(priceModCart.options, e), priceModCart.origOpen || (priceModCart.origOpen = XMLHttpRequest.prototype.open, XMLHttpRequest.prototype.open = function () {
          this.addEventListener("load", function () {
            this.responseURL.indexOf("cart/change.js") !== -1 && setTimeout(function () {
              priceModCart.bindCart()
            }, 10)
          }), priceModCart.origOpen.apply(this, arguments)
        }), priceModCart.bindCart()
      }
    };
  !window.Handlebars || !window.Handlebars.registerHelper || "containsIn" in Handlebars.helpers || Handlebars.registerHelper("containsIn", function (e, t) {
    return e.indexOf(t) !== -1
  });

  function conditionalLogicFactory(e) {
    var t = this;
    t.active = !1, t.isPreview = !1, t.watching = {}, t.reactions = {}, t.timers = {
      running: {
        Change: 0,
        React: 0
      }
    }, t.intervals = [];

    function n(e, n, i) {
      spLog(e, n, i || !0), t.isPreview && (n = "Infinite Options preview: " + n, alert(n))
    }

    function i(n) {
      spLog(n, "conditional logic: hiding", !0), n.$input.attr({
        disabled: "disabled"
      }).fadeTo(100, 0, function () {
        n.hidden !== !1 && (e('input:not([type="checkbox"]),select,textarea,fieldset', n.$input).not("[disabled]").each(function () {
          e(this).attr({
            disabled: "disabled",
            "name-disabled": e(this).attr("name")
          }).removeAttr("name")
        }), e(this)[0].style.setProperty("display", "none", "important"))
      }), n.hidden = !0, eventApi.fieldHide({
        reaction: n
      }), t.watching[n.name] && (t.watching[n.name].hidden = !0, d(t.watching[n.name], 0))
    }

    function o(n) {
      spLog(n, "conditional logic: showing field", !0), e('input:not([type="checkbox"]),select,textarea,fieldset', n.$input).filter("[disabled]").each(function () {
        e(this).attr({
          name: e(this).attr("name-disabled")
        }).removeAttr("name-disabled").removeAttr("disabled")
      }), n.$input.removeAttr("disabled").show().fadeTo(100, 1), n.hidden = !1, eventApi.fieldShow({
        reaction: n
      }), t.watching[n.name] && (t.watching[n.name].hidden = !1, d(t.watching[n.name], 0))
    }

    function r(e, t, n) {
      switch (e) {
        case "contains":
          return !!t && t.indexOf(n) !== -1;
        case "is":
          return t == n;
        case "isnot":
          return t != n;
        case "greater":
          return t > n;
        case "less":
          return t < n;
        default:
          return spLog(e, "conditional logic: unknown type for rule compare", !0), !1
      }
    }

    function a(e, t, n) {
      if ("greater" == e || "less" == e) {
        try {
          var i = parseFloat(t),
            o = parseFloat(n);
          if (!isNaN(i) && !isNaN(o)) return r(e, i, o)
        } catch (a) {
          spLog(a, "conditional logic: greater / less error", !0)
        }
        return !1
      }
      return t = t ? t.toLowerCase() : "", n = n ? n.toLowerCase() : "", r(e, t, n)
    }

    function s(i) {
      if (!i.$input) return void n(i, "conditional logic: page missing input, name: " + i.name);
      var o;
      if (i.$input.not("[disabled]").length) switch (i.input.type) {
        case "radio":
          o = e("input:checked", i.$input).val();
          break;
        case "swatch":
          o = e("input:checked", i.$input).map(function () {
            return e(this).val()
          }).toArray();
          break;
        case "checkbox":
          o = e("input:checked", i.$input).map(function () {
            return e(this).val()
          }).toArray();
          break;
        default:
          o = e("input,select,textarea", i.$input).not('[type="hidden"]').first().val()
      }
      o != i.value && (i.value = o, e.each(i.reactions, function (o, r) {
        t.reactions[r].rules[i.name] && t.reactions[r].rules[i.name].length ? e.each(t.reactions[r].rules[i.name], function (e, t) {
          t.doesMatch = void 0
        }) : n({
          watch: i,
          field: r
        }, "conditional logic: missing reaction, name: " + i.name + ", field: " + r), l(t.reactions[r])
      }))
    }

    function p(r) {
      if (!r.$input) return void n(r, "conditional logic: page missing input, name: " + r.name);
      var s = "all" === r.logic;
      e.each(r.rules, function (n, i) {
        e.each(i, function (i, o) {
          if (void 0 === o.doesMatch) {
            var p = t.watching[n];
            Array.isArray(p.value) ? p.value.length ? (o.doesMatch = !1, e.each(p.value, function (e, t) {
              o.doesMatch = a(o.type, t, o.value) || o.doesMatch
            })) : o.doesMatch = a(o.type, "", o.value) : o.doesMatch = a(o.type, p.value, o.value)
          }
          s = "all" === r.logic ? o.doesMatch && s : o.doesMatch || s
        })
      }), "hide" === r.type ? s ? !r.hidden && i(r) : r.hidden && o(r) : s ? r.hidden && o(r) : !r.hidden && i(r)
    }
    t.runAfterTimeouts = function (e) {
      var n = setInterval(function () {
        if (!t.timers.running.Change && !t.timers.running.React) {
          clearInterval(n);
          var i = t.intervals.indexOf(n);
          i !== -1 && t.intervals.splice(i, 1), e()
        }
      }, 100);
      t.intervals.push(n)
    };

    function c(e, n, i, o) {
      var r = e.name + n;
      t.timers[r] || t.timers.running[n]++, clearTimeout(t.timers[r]), t.timers[r] = setTimeout(function () {
        delete t.timers[r], t.timers.running[n]--, o(e)
      }, void 0 === i ? 50 : i)
    }

    function d(e, t) {
      c(e, "Change", t, s)
    }

    function l(e, t) {
      c(e, "React", t, p)
    }
    t.register = function (i, o, r) {
      if (t.active) {
        if (t.reactions[i.name]) {
          var a = t.reactions[i.name];
          if (a.$input) return void n({
            reaction: a,
            input: i
          }, "conditional logic: duplicate input, name: " + i.name + ", label: " + i.label);
          a.$input = o, l(a, 50)
        }
        if (t.watching[i.name]) {
          var p = t.watching[i.name];
          if (p.$input) return void n({
            watch: p,
            input: i
          }, "conditional logic: duplicate input, name: " + i.name + ", label: " + i.label);
          p.input = i, p.$input = o, e.each(r, function (t, n) {
            var i = e(n);
            i.not("fieldset,input,select,textarea").length && (i = e("fieldset,input,select,textarea", i).not('[type="hidden"]').first()), i.is("[type=text],[type=number],textarea") && i.on("keydown", function (e) {
              d(p)
            }), i.on("change", function (e) {
              d(p)
            })
          }), s(p)
        }
      }
    };

    function u(n) {
      if (n.conditional && n.conditional.rules && n.conditional.rules.length) {
        t.active = !0, "uploadery" !== n.type || n.name || (n.name = n.stub_input_id.$oid);
        var i = {
          name: n.name,
          logic: n.conditional.logic,
          type: n.conditional.type,
          hidden: !1,
          $input: null,
          rules: {}
        };
        return e.each(n.conditional.rules, function (e, o) {
          t.watching[o.field] || (t.watching[o.field] = {
            name: o.field,
            value: void 0,
            reactions: []
          }), t.watching[o.field].reactions.indexOf(n.name) === -1 && t.watching[o.field].reactions.push(n.name), i.rules[o.field] || (i.rules[o.field] = []), i.rules[o.field].push({
            doesMatch: void 0,
            type: o.type,
            value: o.value
          })
        }), spLog(i.rules, "conditional logic: " + n.name + " will " + i.type + " when " + i.logic + " match:", !0), t.reactions[n.name] = i, i
      }
    }

    function f(n) {
      var i = [];
      return e.each(n, function (e, n) {
        return window.Shoppad && window.Shoppad.pos ? void(n.$input.parent(":disabled").length || i.push(n)) : void(t.reactions[n.name] && t.reactions[n.name].hidden || i.push(n))
      }), i
    }

    function h() {
      Object.keys(t.timers).filter(function (e) {
        return "running" !== e
      }).forEach(function (e) {
        clearTimeout(t.timers[e])
      }), t.intervals.forEach(function (e) {
        clearInterval(e)
      }), t.active = !1, t.isPreview = !1, t.watching = {}, t.reactions = {}, t.intervals = [], t.timers.running = {
        Change: 0,
        React: 0
      }
    }
    return t.init = function (n, i) {
      i && h(), e.each(n, function (e, t) {
        u(t)
      }), t.active && (priceMod.variantSubmissionAlters.push(f), window.Shoppad.Cookies.get("io_preview") && (t.isPreview = !0))
    }, t
  }
  var conditionalLogicInstances = {
    "default": ""
  };

  function EventApi(e) {
    var t = this;
    return t.subscribe = function (e, t) {
      "function" == typeof t && document.addEventListener("infiniteoptions." + e, function (e) {
        t(e)
      })
    }, t.trigger = function (e, t, n) {
      n = !!n && n;
      var i = new CustomEvent(e, {
        detail: t,
        cancelable: n
      });
      return document.dispatchEvent(i), i
    }, t.getValue = function (t, n) {
      var i = n.find('[name*="properties"]'),
        o = "";
      return i.is("textarea, input[type=text], input[type=number], input[type=hidden]") ? o = i.val() : i.is("select") ? o = e.isArray(i.val()) ? i.val().join(",") : i.val() : i.is("input[type=radio]") && (o = n.find('input[type="radio"]:checked').val()), o
    }, t.appLoad = function (e) {
      t.trigger("infiniteoptions.appLoad", e)
    }, t.fieldLoad = function (e) {
      e.hasBundledProducts = !1;
      for (var n in priceMod.activeVariants) priceMod.activeVariants[n].name && priceMod.activeVariants[n].name === e.fieldConfig.name && (e.hasBundledProducts = !0);
      e.value = t.getValue(e.fieldConfig.name, e.element), t.trigger("infiniteoptions.fieldLoad", e)
    }, t.fieldChange = function (e) {
      t.trigger("infiniteoptions.fieldChange", e)
    }, t.productBundleAdd = function (e) {
      e.element = e.element.closest("div"), t.trigger("infiniteoptions.productBundleAdd", e)
    }, t.productBundleRemove = function (e) {
      e.element = e.element.closest("div"), t.trigger("infiniteoptions.productBundleRemove", e)
    }, t.fieldShow = function (e) {
      var n = {
        name: e.reaction.name,
        value: t.getValue(e.reaction.name, e.reaction.$input),
        element: e.reaction.$input
      };
      t.trigger("infiniteoptions.fieldShow", n), eventApi.fieldChange({
        name: e.reaction.name,
        value: t.getValue(e.reaction.name, e.reaction.$input),
        element: e.reaction.$input
      }), Object.keys(priceMod.activeVariants).filter(function (t) {
        return priceMod.activeVariants[t].name === e.reaction.name
      }).forEach(function (t) {
        eventApi.productBundleAdd({
          name: e.reaction.name,
          element: e.reaction.$input,
          productBundle: priceMod.activeVariants[t]
        })
      })
    }, t.fieldHide = function (e) {
      var n = {
        name: e.reaction.name,
        value: t.getValue(e.reaction.name, e.reaction.$input),
        element: e.reaction.$input
      };
      t.trigger("infiniteoptions.fieldHide", n), eventApi.fieldChange({
        name: e.reaction.name,
        value: "",
        element: e.reaction.$input
      }), Object.keys(priceMod.activeVariants).filter(function (t) {
        return priceMod.activeVariants[t].name === e.reaction.name
      }).forEach(function (t) {
        eventApi.productBundleRemove({
          name: e.reaction.name,
          element: e.reaction.$input,
          productBundle: priceMod.activeVariants[t]
        })
      })
    }, t.validationFail = function (e) {
      var n = t.trigger("infiniteoptions.validationFail", e, !0);
      return n.defaultPrevented
    }, t.validationSuccess = function (e) {
      t.trigger("infiniteoptions.validationSuccess", e)
    }, t.productBundleCartSubmit = function (e) {
      var n = t.trigger("infiniteoptions.productBundleCartSubmit", e, !0);
      return n.defaultPrevented
    }, t.beforeVariantPost = function (e) {
      var n = t.trigger("infiniteoptions.beforeVariantPost", e, !0);
      return n.defaultPrevented
    }, t.beforeVariantsPost = function (e) {
      var n = t.trigger("infiniteoptions.beforeVariantsPost", e, !0);
      return n.defaultPrevented
    }, t
  }
  var eventApi = new EventApi(window.Shoppad.$);

  function AdminPreview(e) {
    var t = this,
      n = !1,
      i = {
        "default": {
          wrapper: "body",
          insertMethod: "append",
          html: '<div id="infiniteoptions-preview-bar" style="position: fixed; bottom: 0px !important; left: 0px; right: 0px; z-index: 999999999999; background: rgba(40, 52, 61, 0.9);"> <div id="infiniteoptions-preview-bar-wrapper" style="position: relative; margin: 20px; width: auto; min-height: 33px; text-align: center;"> <p style="display: inline-block; margin: 0px 25px 0px 0px; line-height: 33px; color: rgb(255, 255, 255); font-size: 14px; font-weight: normal; font-family: sans-serif; -webkit-font-smoothing: antialiased;"><span id="infiniteoptions-preview-bar-title">You are previewing your unsaved changes to Infinite Options</span></p><a id="infiniteoptions-preview-bar-close" style="display: inline-block; float: right; line-height: 13px; padding: 10px; margin: 0px 0px 20px; cursor: pointer; border: none; border-radius: 3px; color: rgb(71, 156, 207); background-color: rgb(252, 252, 252); text-decoration: none; font-size: 13px; font-family: sans-serif; -webkit-font-smoothing: antialiased;">Close Preview</a></div></div>',
          css: ""
        },
        themeAppExtensionNotFound: {
          wrapper: "#infiniteoptions-preview-bar",
          insertMethod: "prepend",
          html: '<div id="infiniteoptions-no-atc-warning-wrapper"><p id="infiniteoptions-no-atc-message"><svg class="infiniteoptions-no-atc-warning-icon" id="infiniteoptions-warning-bar-alert-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="400" height="400" viewBox="0, 0, 400,400"><g id="svgg"><path id="path0" d="M112.409 59.946 C 13.743 120.103,13.743 279.897,112.409 340.054 C 222.495 407.174,359.925 329.411,359.925 200.000 C 359.925 70.589,222.495 -7.174,112.409 59.946 M220.000 160.000 C 220.000 193.333,216.667 200.000,200.000 200.000 C 183.333 200.000,180.000 193.333,180.000 160.000 C 180.000 126.667,183.333 120.000,200.000 120.000 C 216.667 120.000,220.000 126.667,220.000 160.000 M220.000 260.000 C 220.000 273.333,213.333 280.000,200.000 280.000 C 186.667 280.000,180.000 273.333,180.000 260.000 C 180.000 246.667,186.667 240.000,200.000 240.000 C 213.333 240.000,220.000 246.667,220.000 260.000 " stroke="none" fill="#ffffff" fill-rule="evenodd"></path></g></svg>This theme\'s product form is missing elements for the Infinite Options theme app extension. Please reach out to our team for assistance.</span></p></div>',
          css: "#infiniteoptions-no-atc-warning-wrapper { position: relative; padding: 10px; width: auto; min-height: 20px; text-align: center; background: rgb(192, 2, 7); } #infiniteoptions-no-atc-warning-wrapper p { display: inline; margin: 0 25px 0 0; line-height: 20px; color: rgb(255, 255, 255); font-size: 14px; font-weight: 700; font-family: sans-serif; -webkit-font-smoothing: antialiased; } #infiniteoptions-warning-bar-link-wrapper { white-space: nowrap; } #infiniteoptions-warning-bar-alert-icon { display:inline-block; height: 20px; width: 20px; margin: 2px 0 0 -25px; position: absolute; }"
        },
        addToCartButtonNotFound: {
          wrapper: "#infiniteoptions-preview-bar",
          insertMethod: "prepend",
          html: '<div id="infiniteoptions-no-atc-warning-wrapper"><p id="infiniteoptions-no-atc-message"><svg class="infiniteoptions-no-atc-warning-icon" id="infiniteoptions-warning-bar-alert-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="400" height="400" viewBox="0, 0, 400,400"><g id="svgg"><path id="path0" d="M112.409 59.946 C 13.743 120.103,13.743 279.897,112.409 340.054 C 222.495 407.174,359.925 329.411,359.925 200.000 C 359.925 70.589,222.495 -7.174,112.409 59.946 M220.000 160.000 C 220.000 193.333,216.667 200.000,200.000 200.000 C 183.333 200.000,180.000 193.333,180.000 160.000 C 180.000 126.667,183.333 120.000,200.000 120.000 C 216.667 120.000,220.000 126.667,220.000 160.000 M220.000 260.000 C 220.000 273.333,213.333 280.000,200.000 280.000 C 186.667 280.000,180.000 273.333,180.000 260.000 C 180.000 246.667,186.667 240.000,200.000 240.000 C 213.333 240.000,220.000 246.667,220.000 260.000 " stroke="none" fill="#ffffff" fill-rule="evenodd"></path></g></svg>This theme\'s cart will require a custom configuration in order to work with the bundle feature and required options. Please reach out to our team for assistance.</span></p></div>',
          css: "#infiniteoptions-no-atc-warning-wrapper { position: relative; padding: 10px; width: auto; min-height: 20px; text-align: center; background: rgb(192, 2, 7); } #infiniteoptions-no-atc-warning-wrapper p { display: inline; margin: 0 25px 0 0; line-height: 20px; color: rgb(255, 255, 255); font-size: 14px; font-weight: 700; font-family: sans-serif; -webkit-font-smoothing: antialiased; } #infiniteoptions-warning-bar-link-wrapper { white-space: nowrap; } #infiniteoptions-warning-bar-alert-icon { display:inline-block; height: 20px; width: 20px; margin: 2px 0 0 -25px; position: absolute; }"
        }
      };

    function o(e) {
      e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var t = new RegExp("[\\?&]" + e + "=([^&#]*)"),
        n = t.exec(location.search);
      return null === n ? "" : decodeURIComponent(n[1].replace(/\+/g, " "))
    }
    return t.isPreviewActive = function () {
      return o("io_preview") ? (t.preview = o("io_preview"), spLog(t.preview, "Preview id (from querystring)", !0)) : window.Shoppad && window.Shoppad.Cookies && "undefined" != typeof window.Shoppad.Cookies("io_preview") && (t.preview = window.Shoppad.Cookies("io_preview"), spLog(t.preview, "Preview id (from cookie)", !0)), n = !!t.preview
    }, t.getPreviewConfig = function () {
      return new Promise(function (n, i) {
        var o = e('script[src*="customizery.js"]').attr("src");
        if (!o.replace) return e("#infiniteoptions-preview-bar-title").text("There was an error retrieving your Infinite Options preview configuration"), void i();
        e("#infiniteoptions-preview-bar").find("#infiniteoptions-preview-bar-close").bind("click", function () {
          window.Shoppad.Cookies.remove("io_preview");
          try {
            window.close(), window.location.href = window.location.href.replace("io_preview", "io_close_preview")
          } catch (e) {}
        });
        var r = o.replace("customizery.js?", "customizery-preview.json?io_preview=" + t.preview + "&");
        e.get(r).done(function (o) {
          window.Shoppad.Cookies("io_preview") != t.preview && (window.Shoppad.Cookies.set("io_preview", t.preview, {
            expires: 1 / 24
          }), spLog(t.preview, "Setting preview cookie", !0)), o.config ? (customizeryConfig = o.config, spLog(customizeryConfig.optionSets, "Overwriting optionsets with PREVIEW configuration", !0), n()) : (e("#infiniteoptions-preview-bar-title").text("There was an error retrieving your Infinite Options preview configuration"), i())
        }).fail(function () {
          e("#infiniteoptions-preview-bar-title").text("There was an error retrieving your Infinite Options preview configuration"), i()
        })
      })
    }, t.insert = function (t) {
      var n = i[t],
        o = e(n.wrapper);
      o.length && (n.css && o.append("<style>" + n.css + "</style>"), e(n.wrapper)[n.insertMethod](n.html))
    }, t
  }
  var adminPreview = new AdminPreview(window.Shoppad.$);

  function spLog(e, t, n) {
    var i = "IO",
      o = "DodgerBlue";
    "function" == typeof window.spLogCallback && window.spLogCallback(i, e, t, n === !0 ? o : n);
    try {
      "on" === localStorage.getItem("spLog") && console.log([i, t, e])
    } catch (r) {}
  }

  function safeJsonStringify(e) {
    var t = [],
      n = "";
    try {
      n = JSON.stringify(e, function (e, n) {
        if ("function" == typeof n) return "function(){}";
        if ("object" == typeof n && null !== n) {
          if (t.includes(n)) return "Circular object";
          t.push(n)
        }
        return n
      })
    } catch (i) {
      console.error("Failed to constuct json string: ", i, e)
    }
    return t = null, n
  }
  $(function () {
    var e = {
      _createRadioButton: function (e, t, n, i) {
        var o = priceMod.getValueText(t);
        console.log('o', o);
        var r = window.Shoppad.$("<input/>").attr("type", "radio").attr("name", "properties[" + e + "]").attr("value", o.value).addClass("spb-productoptiontextcolor").addClass("spb-productoptionbackground").on("change", function (t, n) {
            n || eventApi.fieldChange({
              name: e,
              value: t.target.value,
              element: $(this).closest("div")
            }), i(t)
          });

          // const price = t?.variant?.price || '0';
          // const inp = $('<span class="inf-inner">').attr('data-price', price);
          // const displayText = price !== '0' ? `${o.display} (+$${price.replace('.00', '')})` : o.display;
          // inp.append(displayText);
          

          console.log('e', e, 't', t, 'n', n, 'i', i, 'o', o);
          // return window.Shoppad.apps.infiniteoptions.themeAppExtensionId && r.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId),
          //       n ? window.Shoppad.$("<label></label>").append(priceMod.attachData(r, e, t, o.display)).append(inp) : r
        return window.Shoppad.apps.infiniteoptions.themeAppExtensionId && r.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId), 
        n ? window.Shoppad.$("<label></label>").append(priceMod.attachData(r, e, t, o.display)).append(o.display) : r
      },
      _createCheckboxButton: function (e, t, n) {
        var i = priceMod.getValueText(t),
          o = window.Shoppad.$("<input/>").attr("type", "checkbox").attr("value", i.value).addClass("spb-productoptiontextcolor").addClass("spb-productoptionbackground");
        return window.Shoppad.apps.infiniteoptions.themeAppExtensionId && o.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId), n ? window.Shoppad.$("<label></label>").append(priceMod.attachData(o, e.name, t, i.display)).append(i.display) : o
      },
      _createSelectMenu: function (t, n, i, o, r) {
        var a = window.Shoppad.$('<div class="spb-select"></div>'),
          s = window.Shoppad.$('<select class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></select>').attr("id", r);
        if (o && s.attr("required", "required"), window.Shoppad.apps.infiniteoptions.themeAppExtensionId && s.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId), void 0 !== i && "" !== i) {
          if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && !e.ffCssFix) {
            var p = ".spb-select select:invalid { box-shadow: none; }",
              c = document.head || document.getElementsByTagName("head")[0],
              d = document.createElement("style");
            d.type = "text/css", d.styleSheet ? d.styleSheet.cssText = p : d.appendChild(document.createTextNode(p)), c.appendChild(d), e.ffCssFix = !0
          }
          s.append(window.Shoppad.$("<option>").text(i).attr("value", "").attr("disabled", "true").attr("selected", !0))
        }
        return n && n.length && (window.Shoppad.$.each(n, function (e, n) {
          var i = priceMod.getValueText(n),
            o = window.Shoppad.$("<option></option>").attr("value", i.value).html(i.display);
          s.append(priceMod.attachData(o, t, n, i.display))
        }), s.prop("name", "properties[" + t + "]"), s.on("change", function (e, n) {
          window.Shoppad.apps.infiniteoptions.toggleInputError(s, !0), n || eventApi.fieldChange({
            name: t,
            value: e.target.value,
            element: $(this).closest("div:not(.spb-select)")
          });
          var i = $("option", s);
          priceMod.variantChange(t, i)
        })), a.append(s), s.trigger("change", ["onLoad"]), a
      },
      _createUploaderyStubContainer: function (e) {
        return window.Shoppad.$("<div>").addClass("uploadery-stub-container").attr("uploadery-input-id", e)
      },
      _createHiddenInput: function (e) {
        var t = window.Shoppad.$("<input />").attr("type", "hidden").attr("name", "properties[" + e + "]");
        return window.Shoppad.apps.infiniteoptions.themeAppExtensionId && t.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId), t
      },
      _createTextInput: function (e, t, n, i, o, r) {
        i = i && parseInt(i, 10) > 0 ? parseInt(i, 10) : 0;
        var a = window.Shoppad.$("<input/>").attr("type", "text").attr("name", "properties[" + e + "]").attr("id", r).addClass("spb-productdescfont").addClass("spb-productoptiontextcolor").addClass("spb-productoptionbackground").on("keyup touchend", function (t) {
          var n = t.target.value;
          i && n.length > i && (n = n.substr(0, i), a.val(n)), eventApi.fieldChange({
            name: e,
            value: n,
            element: $(this).closest("div")
          })
        });
        return window.Shoppad.apps.infiniteoptions.themeAppExtensionId && a.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId), void 0 !== t && "" !== t && a.val(t), void 0 !== n && "" !== n && a.prop("placeholder", n), i && a.prop({
          maxlength: i,
          size: i
        }), a.on("blur", function () {
          window.Shoppad.apps.infiniteoptions.toggleInputError(a, !0)
        }), o && a.prop("required", o), a
      },
      _createTextArea: function (e, t, n, i, o, r) {
        var a = window.Shoppad.$("<textarea>").attr("name", "properties[" + e + "]").attr("id", r).addClass("spb-productdescfont").addClass("spb-productoptiontextcolor").addClass("spb-productoptionbackground").on("keyup touchend", function (t) {
          eventApi.fieldChange({
            name: e,
            value: t.target.value,
            element: $(this).closest("div")
          })
        });
        if (window.Shoppad.apps.infiniteoptions.themeAppExtensionId && a.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId), void 0 !== t && "" !== t && a.val(t), void 0 !== n && "" !== n && a.prop("placeholder", n), i && parseInt(i, 10) > 0) {
          a.prop("maxlength", i);
          var s = window.Shoppad.$("<p class='spb-productdescfont spb-productdesctextcolor'><span>" + (i - a.val().length) + "</span> " + window.Shoppad.apps.infiniteoptions.strings.charactersRemaining + "</p>");
          a.on("keyup", function () {
            var e = parseInt(i, 10) - a.val().length;
            s.find("span").html(e)
          }), a = a.add(s)
        }
        return a.on("blur", function () {
          window.Shoppad.apps.infiniteoptions.toggleInputError(a, !0)
        }), o && a.prop("required", o), a
      },
      _createNumberInput: function (e, t, n, i, o, r, a) {
        var s = window.Shoppad.$("<input/>").attr("type", "number").attr("step", "any").attr("name", "properties[" + e + "]").attr("id", a).addClass("spb-productdescfont").addClass("spb-productoptiontextcolor").addClass("spb-productoptionbackground").on("keyup touchend", function (t) {
          eventApi.fieldChange({
            name: e,
            value: t.target.value,
            element: $(this).closest("div")
          })
        });
        window.Shoppad.apps.infiniteoptions.themeAppExtensionId && s.attr("form", window.Shoppad.apps.infiniteoptions.themeAppExtensionId), void 0 !== t && "" !== t && s.val(t), void 0 !== n && "" !== n && s.prop("placeholder", n), r && s.prop("required", r), s.on("keypress", function (e) {
          var t = String.fromCharCode(e.which);
          return Boolean(t.match(/[0-9\.-]/))
        });
        var p = function (e) {
          i = parseFloat(i), o = parseFloat(o), input = parseFloat(s.val()), void 0 !== i && "" !== i && input < i && "keyup" != e.type && s.val(i), void 0 !== o && "" !== o && input > o && s.val(o)
        };
        return s.on("keyup", function (e) {
          p(e)
        }), s.on("blur", function (e) {
          p(e), window.Shoppad.apps.infiniteoptions.toggleInputError(s, !0)
        }), s
      },
      _createSwatch: function (t, n, i, o) {
        var r, a = priceMod.getValueText(n),
          s = "url" === n.swatch.type ? "background-image: url('" + n.swatch.value + "');" : "background:" + n.swatch.value + "; color:" + n.swatch.value + ";",
          p = window.Shoppad.$('<label class="spb-productoptionswatchwrapper"></label>'),
          c = window.Shoppad.$('<span class="spb-productoptionswatch" style="' + s + '"></span>'),
          d = t.multi ? e._createCheckboxButton(t.name, n, !1) : e._createRadioButton(t, n, !1, o);
        return console.log("typeof window.Shoppad.apps.infiniteoptions.ready", typeof window.Shoppad.apps.infiniteoptions.beforeReady), "function" == typeof window.Shoppad.apps.infiniteoptions.beforeReady ? (spLog(null, "Swatch: beforeReady() method detected, skipping wrapping the swatch label in a <span> for legacy snippet support.", !0), r = a.display) : r = window.Shoppad.$('<span class="spb-swatchlabel">' + a.display + "</span>"), i ? p.append(priceMod.attachData(d, d.name, n, a.display)).append(c).append(r) : d
      },
      createRadioList: function (e, t, n, i) {
        t.attr("id", n).removeAttr("for");
        var o = [];
        return e.values && window.Shoppad.$.each(e.values, function () {
          o.push(i(e.name, this, !0, function (t) {
            priceMod.variantChange(e.name, $(o).map(function () {
              return $(this).children().first()
            }))
          }))
        }), o.length && o[0].find("input").each(function () {
          $(this).prop("checked", "checked"), $(this).trigger("change", ["onLoad"])
        }), o
      },
      createCheckboxList: function (t, n, i) {
        var o = window.Shoppad.$("<fieldset></fieldset>").append(window.Shoppad.$("<legend></legend>").attr("style", "position: absolute !important;top: 0;clip: rect(1px, 1px, 1px, 1px) !important;overflow: hidden !important;height: 1px !important;width: 1px !important;padding: 0 !important;border: 0 !important;").text(t.label || ""));
        n.removeAttr("for"), t.required && o.attr("data-required", "true");
        var r = e._createHiddenInput(t.name);
        return o.append(r), t.values && window.Shoppad.$.each(t.values, function () {
          o.append(i(t, this, !0))
        }), t.valuesmin && parseInt(t.valuesmin, 10) > 0 && o.data("valuesmin", t.valuesmin), o.on("change", function (e) {
          var n = window.Shoppad.$(this).find('input[type="checkbox"]');
          p(t, o, n), priceMod.variantChange(t.name, n), window.Shoppad.apps.infiniteoptions.toggleInputError(o, !0);
          var i = n.filter(":checked").map(function () {
            return this.value
          }).get().join(",");
          r.val(i), eventApi.fieldChange({
            name: t.name,
            value: i,
            element: $(this).closest("div")
          })
        }), o
      },
      add: function (n, i, r, a, s) {
        var p = [],
          c = n.name + "-" + r;
        "default" !== s && (c = c + "-" + s);
        var d = t(a, s),
          l = window.Shoppad.$("<label><label>").attr("for", c).addClass("spb-productdescfont").addClass("spb-productdesctextcolor").text(n.label || ""),
          u = n && n.help_text_display && "" !== n.help_text_display && "uploadery" !== n.type ? n.help_text_display : "",
          f = n && n.help_text && "" !== n.help_text && "uploadery" !== n.type ? n.help_text : "",
          h = "";

        // JOEL Added theme style tooltips
        if ("" !== f && "tooltip" === u) {
          l.attr('data-tooltip', f);
          // l.html(n.label + '<div class="tooltip-icon">ⓘ</div>');
        }

        if ("" !== f && "below" === u) var h = window.Shoppad.$("<div><div>").addClass("spb-productdescfont").addClass("spb-productdesctextcolor").addClass("spb-helptext").html(f);
        // else if ("" !== f && "tooltip" === u) var h = window.Shoppad.$("<div><div>").attr("title", f).addClass("spb-productdescfont").addClass("spb-productdesctextcolor").addClass("spb-tooltip").append('ⓘ<span class="spb-tooltiptext">' + f + "</span>");

        switch (n.type) {
          case "text":
            p.push(e._createTextInput(n.name, n["default"], n.placeholder, n.maxlength, n.required, c));
            break;
          case "number":
            p.push(e._createNumberInput(n.name, n["default"], n.placeholder, n.min, n.max, n.required, c));
            break;
          case "textarea":
            p.push(e._createTextArea(n.name, n["default"], n.placeholder, n.maxlength, n.required, c));
            break;
          case "radio":
            var m = e.createRadioList(n, l, c, e._createRadioButton);
            window.Shoppad.$.merge(p, m);
            break;
          case "swatch":
            if (n.multi) {
              var g = e.createCheckboxList(n, l, e._createSwatch);
              p.push(g)
            } else {
              var m = e.createRadioList(n, l, c, e._createSwatch);
              window.Shoppad.$.merge(p, m)
            }
            break;
          case "checkbox":
            var g = e.createCheckboxList(n, l, e._createCheckboxButton);
            p.push(g);
            break;
          case "select":
            var v = e._createSelectMenu(n.name, n.values, n.placeholder, n.required, c);
            p.push(v);
            break;
          case "uploadery":
            var y = e._createUploaderyStubContainer(n.stub_input_id.$oid);
            p.push(y)
        }
        if (p.length) {
          var w = n["class"] || "",
            b = window.Shoppad.$("<div></div>").addClass('infin-option').addClass(w);
          if ("uploadery" !== n.type)
            if ("tooltip" === u) {
              var x = window.Shoppad.$("<div></div>").addClass("spb-label-tooltip").append(l).append(h);
              b.append(x)
            } else b.append(l);
          b.append("<span></span>"), ("radio" == n.type || "swatch" == n.type && !n.multi) && b.attr("role", "group").attr("aria-labelledby", c), "below" === u ? b.find("span").append(p).append(h) : b.find("span").not(".spb-tooltiptext").append(p), conditionalLogicInstances[s].register(n, b, p), o(n, b, a, s, d)
        }
      }
    };

    function t(e, t) {
      var n = "div",
        i = "infiniteoptions-container",
        o = null,
        r = window.Shoppad.apps.infiniteoptions;
      if (r.insertContainerAfter) {
        var a = $(r.insertContainerAfter).filter(":first").next(".infiniteoptions-auto-insert");
        0 === a.length ? (spLog(r.insertContainerAfter, "container insert location specified, inserting infiniteoptions-container after it", !0), o = $("<" + n + " id=" + i + ' class="infiniteoptions-auto-insert"></' + n + ">"), o.insertAfter(r.insertContainerAfter + ":first")) : o = a
      } else if (t && "default" !== t) o = $("[data-infinite-options-container-id=" + t + "]");
      else if ($("div[data-infinite-options]").length && e) o = $("div[data-infinite-options=" + e + "]");
      else if ($("#" + i).length > 0) o = $("#" + i);
      else {
        if (!$('form[action$="/cart/add"]').length) throw "IO could not find product form to insert #infiniteoptions-container";
        0 == customizeryConfig.autoInject ? spLog(!0, "New install (config.autoInject is false), we require installation of the theme app block or code snippet.", !0) : (spLog(!0, "Could not find #" + i + ", automatically inserting one.", !0), $form = $('form[action$="/cart/add"]'), $form.length > 1 && ($form.filter("[id*=product-form-installment]").length ? ($form = $form.filter(":not([id*=product-form-installment])"), spLog(!0, "Dawn, Colorblock or Ride theme: found multiple forms, inserting the container into the first non #product-form-installment form.", !0)) : spLog(!0, "found multiple forms, inserting the container into the first.", !0), $form = $form.filter(":first")), o = $("<" + n + " id=" + i + "></" + n + ">"), $form.find("div#product-variants").length ? $form.find("div#product-variants").first().prepend(o) : $form.find("div#product-options").length ? $form.find("div#product-options").first().prepend(o) : $form.find("div.product-options").length ? $form.find("div.product-options").first().prepend(o) : $form.prepend(o))
      }
      var s;
      if (window.Shoppad.apps.infiniteoptions.themeAppExtensionActive && !window.Shoppad.apps.infiniteoptions.themeAppExtensionCheckRan && !window.Shoppad.apps.infiniteoptions.themeAppExtensionId) {
        if (s = o.attr("form"), !s) {
          var p = o.parents("form");
          p.length ? (1 === p.length ? spLog(!0, "Theme app extension (theme 2.0) infinite options container already inside a form.", !0) : spLog(!0, "Theme app extension (theme 2.0) infinite options container already inside a form... WARNING: multiple parent forms may not work properly with IO submissions.", !0), s = $(p[0]).attr("id")) : $('form[action*="/cart/add"]').each(function () {
            if (!s) {
              var e = $(this).attr("id");
              e && ($("input[form='" + e + "'], select[form='" + e + "']").length ? (spLog(!0, "Theme app extension (theme 2.0) form ID found by locating [form=] inputs.", !0), $("input[type=submit],button[type=submit]", $(this)).length && (s = e)) : e.match(/^((AddToCart|product|add[-_]item)[-_]{0,2}?form?([-_]buttons)?([-_]{0,2}template)?[-_]*[0-9]{6,}[-_]?([0-9]{6,})?|product-form)/i) && $("input[type=submit],button[type=submit]", $(this)).length && (spLog(e, "Theme app extension (theme 2.0) form ID found by regex.", !0), s = e))
            }
          })
        }
        s ? (o.attr("form", s), window.Shoppad.apps.infiniteoptions.themeAppExtensionId = s) : (spLog($('form[action$="/cart/add"]'), 'Container is placed as a theme app extension (theme 2.0), but required form elements were not found.  Try using the "runtime config" themeAppExtensionId to manually set this.', !0), adminPreview.isPreviewActive() && adminPreview.insert("themeAppExtensionNotFound"))
      }
      return window.Shoppad.apps.infiniteoptions.themeAppExtensionId && !window.Shoppad.apps.infiniteoptions.themeAppExtensionCheckRan && (s ? spLog(!0, "Container is placed as a theme app extension (theme 2.0).", !0) : spLog(!0, 'Container is placed as a theme app extension (theme 2.0), and using themeAppExtensionId from "runtime config"', !0)), window.Shoppad.apps.infiniteoptions.themeAppExtensionCheckRan = !0, customizeryConfig && customizeryConfig.currentTheme && (window.Shoppad.apps.infiniteoptions.themeName = customizeryConfig.currentTheme), o
    }

    function n(e, n, i) {
      var o = conditionalLogicInstances[i],
        e = e || t(n, i);
      if (o.active && !e.hasClass("io-inputs-loading")) {
        window.Shoppad.apps.infiniteoptions.containerCssDisplay = e.css("display");
        var r = e[0];
        r.style.setProperty("display", "none", "important"), e.addClass("io-inputs-loading")
      }
    }

    function i(e, n) {
      var i = conditionalLogicInstances[n];
      i.active && i.runAfterTimeouts(function () {
        $formContainer = t(e, n);
        var i = $formContainer[0];
        i.style.removeProperty("display"), "none" !== window.Shoppad.apps.infiniteoptions.containerCssDisplay && i.style.setProperty("display", window.Shoppad.apps.infiniteoptions.containerCssDisplay || "block", ""), $formContainer.removeClass("io-inputs-loading")
      })
    }

    function o(e, i, o, r, a) {
      var a = a || t(o, r),
        s = conditionalLogicInstances[r];
      a && (n(a, o, r), a.append(i), eventApi.fieldLoad({
        name: e.name,
        element: i,
        fieldConfig: e,
        hasConditionalLogic: !!s.reactions[e.name]
      }))
    }

    function r(t, n, o) {
      var r = $('[id="infiniteoptions-container"]');
      r.length > 1 && spLog(!0, "multiple #infiniteoptions-container containers", !0), r.empty();
      var p = !1,
        c = !1,
        d = conditionalLogicInstances[o],
        l = t.filter(function (e, t) {
          return !(!e.inputs || !e.inputs.length) && (d.init(e.inputs, !t), !0)
        }).map(function (t, i) {
          return $.each(t.inputs, function (t, r) {
            e.add(this, {
              uuid: UUID
            }, i + "-" + t, n, o), r && r.help_text_display && "" !== r.help_text_display && r.help_text && "" !== r.help_text && (c = !0), "swatch" === r.type && (p = !0)
          }), t.inputs
        });
      s(), window.Shoppad.apps.infiniteoptions._fieldsReady = !0, i(n, o), C(), "function" == typeof window.Shoppad.apps.infiniteoptions.ready && (window.Shoppad.apps.infiniteoptions.ready.call($("#infiniteoptions-container"), Array.prototype.concat.apply([], l)), datePicker.hasDatePicker(l) && datePicker.fixLegacyHandlers()), "function" == typeof window.Shoppad.apps.infiniteoptions.uploaderyReady && window.Shoppad.apps.infiniteoptions.uploaderyReady.call($("#infiniteoptions-container"), Array.prototype.concat.apply([], l)), a(p, c), eventApi.appLoad({
        fields: l,
        hasConditionalLogic: d.active,
        hasBundledProducts: !!priceMod.activeVariants.length
      })
    }

    function a(e, t) {
      customizeryConfig.css && customizeryConfig.css.length && $("head").append("<style>" + customizeryConfig.css + "</style>"), e && $("head").append('<style>.spb-productoptionswatchwrapper { vertical-align: middle; } .spb-productoptionswatch { width: 32px; height: 32px; display: inline-block; vertical-align: middle; margin-right: 5px; border-radius: 2px; background-size: cover; box-sizing: border-box; cursor: pointer; } .spb-productoptionswatchwrapper input[type="radio"] {\tposition: fixed; opacity: 0; } .spb-productoptionswatchwrapper input[type="radio"]:checked + .spb-productoptionswatch { border: 1px solid #fff; box-shadow: 0px 0px 0px 1px currentColor; } .spb-productoptionswatchwrapper input[type="checkbox"] { position: fixed; opacity: 0; } .spb-productoptionswatchwrapper input[type="checkbox"]:checked + .spb-productoptionswatch { border: 1px solid #fff; box-shadow: 0px 0px 0px 1px currentColor; }</style>'), t && $("head").append('<style>.spb-tooltip{position:relative;display:inline-block;}.spb-tooltip .spb-tooltiptext{visibility:hidden;width:240px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:8px 2px;position:absolute;z-index:1;bottom:150%;left:50%;margin-left:-120px;word-break: break-word;}.spb-tooltip:hover .spb-tooltiptext{visibility:visible}.spb-tooltip .spb-tooltiptext::after{content:" ";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:#000 transparent transparent transparent}.spb-label-tooltip label{display:inline;padding-right:.5rem}.spb-helptext{padding-bottom: 1rem;}  @media only screen and (max-width: 768px) {.spb-tooltip .spb-tooltiptext {font-size: 1rem;max-width: 20rem;position: fixed;bottom: auto;top: 50%;left: 50%;transform: translate(-50%);white-space: normal;margin-top: 30px;margin-left: 0;z-index: 10000;}.spb-tooltip .spb-tooltiptext::after {display: none;}}</style>')
    }

    function s() {
      var e = $('[id="infiniteoptions-container"]');
      e.length > 0 && $.each(e, function (e, t) {
        var n = $(t).closest("form"),
          i = [],
          o = [];
        $(n).find(":input").each(function (e, t) {
          t.name && t.name.indexOf("properties[") > -1 && !$(t).parents("#infiniteoptions-container").length > 0 && t.name && (o[t.name] = [t.name])
        });
        var r = "",
          a = !1,
          s = !0;
        $(t).find(":input").each(function (e, t) {
          var n = t.name,
            p = !1;
          if ("checkbox" !== t.type) {
            if ("radio" === t.type) {
              var c = $(t).closest('[role="group"]').attr("aria-labelledby");
              p = c === r, p || (a = !1), r = c
            } else a = !1, r = "";
            if (p && a || !p)
              if (o[n] ? (s = !1, a = !0) : i[n] && (s = !0, a = !0), a) {
                if (i[n]) var d = i[n];
                else var d = {
                  existing_entries: [],
                  is_io_duplicate: s
                };
                p || d.existing_entries.push(n);
                var l = s ? "_io_duplicate" : "_third_party_duplicate",
                  u = s ? d.existing_entries.length - 1 : d.existing_entries.length,
                  f = "properties[" + n.replace("properties[", "").replace("]", "").replace("properties[", "").replace("]", "") + "_" + u + l + "]";
                spLog(!0, (s ? "IO" : "Third party") + " field already exists with name " + n + ". Renaming IO field with name:" + f, !0), i[n] = d, t.name = f
              } else i[n] = {
                existing_entries: [n],
                is_io_duplicate: s
              }
          }
        })
      })
    }

    function p(e, t, n) {
      if (n.length) {
        var i = e.valuesmax;
        i && parseInt(i, 10) > 0 && (n.filter(":checked").length >= i ? n.filter(":not(:checked)").each(function () {
          this.disabled = "disabled"
        }) : n.filter(":disabled").each(function () {
          this.removeAttribute("disabled")
        }))
      }
    }

    function c(e) {
      var t = 0,
        n = !0,
        i = e(window.Shoppad.apps.infiniteoptions.addToCartButton),
        o = {};
      i.length && (o = getEventData(e, i[0])), o && o.click && (t = o.click.length);
      for (var r = 0; r < t; r++)
        if (n = o.click[r].handler.toString().indexOf("window.Shoppad.apps.customizery.overrideDeprecatedValidation") >= 0) return !0;
      return !1
    }

    function d(e, t) {
      t ? e.css({
        background: "",
        color: "",
        border: ""
      }) : e.css({
        background: window.Shoppad.apps.infiniteoptions.errorStyles.background,
        color: window.Shoppad.apps.infiniteoptions.errorStyles.color,
        border: "1px solid " + window.Shoppad.apps.infiniteoptions.errorStyles["border-color"]
      })
    }

    function l(e, t) {
      var n, i = e.tagName.toLowerCase();
      n = "input" === i ? e.type + ":" + t : "fieldset" === i ? "checkboxes:" + t : i + ":" + t;
      var o = window.Shoppad.apps.infiniteoptions,
        r = $(e);
      switch (n) {
        case "textarea:required":
        case "text:required":
        case "number:required":
          return "" === r.val() ? (o.toggleInputError(r, !1), "number" === e.type ? o.strings.errorMessages.forNumberInputs : o.strings.errorMessages.forTextInputs) : "";
        case "select:required":
          return $("option:selected:disabled", r).length ? (o.toggleInputError(r, !1), o.strings.errorMessages.forDropdowns) : "";
        case "checkboxes:required":
          return 0 === $("input[type=checkbox]", r).length ? "" : 0 === $('input[type="checkbox"]:checked', r).length ? (o.toggleInputError(r, !1), o.strings.errorMessages.forCheckboxes) : "";
        case "checkboxes:minvalue":
          if (0 === $("input[type=checkbox]", r).length) return "";
          var a = r.data("valuesmin") && parseInt(r.data("valuesmin"), 10);
          if (!a) return !1;
          var s = $('input[type="checkbox"]:checked', r).length;
          return s > 0 && s < a ? (o.toggleInputError(r, !1), o.strings.errorMessages.forMinimumValues.replace("%valuesmin", a)) : ""
      }
    }

    function u() {
      return $selectors = ['.seven.columns.omega form[action$="/cart/add"] .ajax-submit.action_button.add_to_cart', '.seven.columns.omega form[action$="/cart/add"] .action_button.add_to_cart', 'form[action$="/cart/add"] .atc-btn-container .add_to_cart', ".shopify-product-form .add_to_cart", '.product-form-container form[action$="/cart/add"] .button.ajax-submit.action_button', '.seven.columns.omega form[action$="/cart/add"] .action_button.add_to_cart', '.six.columns.omega form[action$="/cart/add"] .action_button.add_to_cart', 'form[action$="/cart/add"] .btn-addtocart', ".product-form form .product-form__submit", 'form[action$="/cart/add"] .product-form--add-to-cart', 'form[action$="/cart/add"] .btn--subtle-hover', 'form[action$="/cart/add"] .btn.btn--secondary', 'form[action$="/cart/add"] #product-add-to-cart', 'product-form form[action$="/cart/add"] .product-form__submit', 'form[action$="/cart/add"] #AddToCart', 'form[action$="/cart/add"] .button--large', 'form[action$="/cart/add"] .AddtoCart', 'form[action$="/cart/add"] .pf-io-atc-btn', 'form[action$="/cart/add"] .btn[name="add"]', 'form[action$="/cart/add"] .buy-buttons .button', 'form[action$="/cart/add"] .product-buy-buttons--cta'], spLog($selectors, "retrieved " + $selectors.length + " cart submit button alternate selectors", !0), $selectors.join()
    }

    function f(e) {
      for (var t = e.clone(), n = e.find("textarea").add(e.filter("textarea")), i = t.find("textarea").add(t.filter("textarea")), o = e.find("select").add(e.filter("select")), r = t.find("select").add(t.filter("select")), a = e.find("[type=radio]").add(e.filter("[type=radio]")), s = t.find("[type=radio]").add(t.filter("[type=radio]")), p = 0, c = n.length; p < c; ++p) $(i[p]).val($(n[p]).val());
      for (var p = 0, c = o.length; p < c; ++p)
        for (var d = 0, l = o[p].options.length; d < l; ++d) o[p].options[d].selected === !0 && (r[p].options[d].selected = !0);
      for (var p = 0, c = a.length; p < c; ++p) $(s[p]).attr("name", $(a[p]).attr("name") + "_dynamic_checkout").val($(a[p]).val());
      return t
    }

    function h() {
      var e = window.Shoppad.apps.infiniteoptions.jQueryKey || "jQuery",
        n = window[e] && window[e].fn && (window[e]._data || window[e].data) ? window[e] : $,
        i = n(window.Shoppad.apps.infiniteoptions.addToCartButton);
      if (0 === i.length) {
        spLog(!0, "cart submit button does not exist, trying with alternate selectors", !0);
        var o = u();
        if (i = n(o), 0 === i.length) return spLog(!0, "unable to find cart submit button with alternate selectors", !0), void(adminPreview.isPreviewActive() && adminPreview.insert("addToCartButtonNotFound"));
        window.Shoppad.apps.infiniteoptions.addToCartButton = o, spLog(!0, "found cart submit button with alternate selectors", !0)
      }
      "overlay" === customizeryConfig.validate && "bound" !== window.Shoppad.apps.infiniteoptions.validateType || "overlay" === window.Shoppad.apps.infiniteoptions.validateType ? (spLog(!0, "Validating with overlay", !0), g(i, c)) : spLog(!0, "Validating with bound handler", !0), b(n, i, window.Shoppad.apps.infiniteoptions.validationEventName, {
        "shoppad-validate": !0
      }, c), i.data("io-bound", !0);
      var r = getEventData(n, i[0]);
      r && r.click && r.click.length > 1 && (spLog(r.click, "add to cart has other bound events", !0), r.click.unshift(r.click.pop())), v(c);

      function a(e, n) {
        if ("sp-dynamic-checkout-button-primary" !== e.target.className && "sp-dynamic-checkout-button-secondary" !== e.target.className) return void spLog(!0, "Click propagated to the overlay, returning early", !0);
        if (n) return spLog(!0, "dynamic checkout: button clicked + price mods selected, preventing submission", !0), window.alert(window.Shoppad.apps.infiniteoptions.strings.errorMessages.forDynamicCheckout), e.stopImmediatePropagation(), !1;
        if (window.Shoppad.apps.infiniteoptions.themeAppExtensionId) {
          $("[infinite-options-clone]").remove(), $container = t();
          var i = f($container);
          i.css("display", "none").prependTo("form#" + window.Shoppad.apps.infiniteoptions.themeAppExtensionId).attr("infinite-options-clone", !0), spLog(null, "Shopify Theme 2.0 - duplicating a set of hidden fields and inserting them in the form", !0)
        }
        var o = $(".sp-dynamic-checkout-button-" + e.data["io-dynamic-checkout-type"]);
        return o.data("uploadery-dynamic-bound") ? (spLog(!0, "dynamic checkout: form fields are valid and uploadery is present, allowing uploadery to run it's validation", !0), !0) : (s(e), !0)
      }

      function s(e) {
        if ("secondary" === e.data["io-dynamic-checkout-type"]) return spLog(!0, 'dynamic checkout: clicking "more payment options" button.', !0), $(".shopify-payment-button__more-options").click(), !0;
        if ("primary" === e.data["io-dynamic-checkout-type"]) {
          var t = $(".shopify-payment-button__button"),
            n = {
              paypal: '[role="button"]',
              amazon: "form > button",
              google: "iframe",
              shopify: ""
            };
          $.each(n, function (e, n) {
            if (!n) return spLog(!0, "dynamic checkout: clicking native shopify button.", !0), t.click(), !1;
            var i = $(t.find(n).contents());
            return "google" === e && i.length ? (spLog(!0, "dynamic checkout: clicking google pay button.", !0), i.find("button").click(), !1) : t.find(n).length ? (spLog(!0, "dynamic checkout: clicking " + e + " button.", !0), t.find(n).click(), !1) : void 0
          })
        }
      }

      function p(e) {
        if (e.data && e.data["io-dynamic-checkout-type"]) return priceMod.options.skipPriceModIfVisible = "", a(e, priceMod.getVariantSubmissions().length), !0;
        var t = priceMod.getVariantSubmissions();
        if (priceMod.updateOrderGroup(e, t), !t || !t.length) return n(window.Shoppad.apps.infiniteoptions.skipPriceModIfVisible).is(":visible") ? spLog(!0, "price variants: skip price mod if visible", !0) : spLog(!0, "price variants: no variants selected", !0), !0;
        var o = !0,
          r = getEventData(n, i[0]);
        return r && r.click && r.click.length > 1 && n.each(r.click, function (t, n) {
          n.handler != c && n.data && n.data["shoppad-validate"] && (spLog(n.handler, "price variants: calling other shoppad validation", !0), o = n.handler.call(i[0], e))
        }), o ? (spLog(safeJsonStringify(t), "price variants: submitting with variants", !0), priceMod.addToCart(e, function (t) {
          if (t) return void spLog(t, "price variants: add variant to cart error", "red");
          var o = priceMod.getVariantSubmissions();
          if (e.data["io-shoppad-overlay"]) return spLog(!0, "Shoppad product bundle completed via overlay: triggering click event on add to cart button", !0), i.trigger("click", ["spTrigger"]), void eventApi.productBundleCartSubmit({
            submittedProducts: o
          });
          var a = !0;
          r && r.click && r.click.length > 1 && n.each(r.click, function (t, n) {
            !(t > 0) || n.data && n.data["shoppad-validate"] || (spLog(n.handler, "price variants: calling non-shoppad submit event", !0), a = !1, n.handler.call(i[0], e))
          });
          var s = eventApi.productBundleCartSubmit({
            submittedProducts: o
          });
          return !s && void(a || window.Shoppad.apps.infiniteoptions.submitPriceModCartAnyways ? i.parents("form").trigger("submit") : spLog(!0, "price variants: complete but relying on other events to submit", !0))
        }, t)) : (spLog(!0, "price variants: other shoppad validation failed", !0), !1)
      }

      function c(e, t) {
        if ("spTrigger" === t) return void spLog(!0, "Validation triggered by synthentic click after product bundling resolved, skipping validation", !0);
        if (window.Shoppad && window.Shoppad.apps && window.Shoppad.apps.customizery && window.Shoppad.apps.customizery.overrideDeprecatedValidation) return spLog(!0, "theme has overrideDeprecatedValidation, conditional logic may not work as expected", !0), !0;
        if ("function" == typeof window.Shoppad.apps.infiniteoptions.validate) return spLog(!0, "theme has custom validation, conditional logic may not work as expected", !0), window.Shoppad.apps.infiniteoptions.validate(e);
        var n = "",
          i = "";
        const o = function (e) {
          var t = "",
            n = "";
          return $("input[type=text][required], textarea[required], input[type=number][required], fieldset[data-required], select[required]", e).not("[disabled]").each(function (e, i) {
            t || (n = i, t = window.Shoppad.apps.infiniteoptions.validateInput(i, "required", t))
          }), !t && $("fieldset", e).not("[disabled]").each(function (e, i) {
            t || (n = i, t = window.Shoppad.apps.infiniteoptions.validateInput(i, "minvalue", t))
          }), {
            errMsg: t,
            element: n
          }
        };
        if ($io = $("#infiniteoptions-container"), n = o($io).errMsg, i = o($io).element, $("div[data-infinite-options]").each(function () {
            var e = $(this).attr("data-infinite-options");
            $container = $("div[data-infinite-options=" + e + "]"), n = o($container)
          }), n && n.length) {
          var r = eventApi.validationFail({
            error: n,
            element: i
          });
          return r || alert(n), e.stopImmediatePropagation(), !1
        }
        return eventApi.validationSuccess({
          event: e
        }), p(e)
      }
    }

    function m(e, t) {
      return "undefined" != typeof e.shopifyPriceSynced ? t(e) : void $.ajax({
        url: "/products/" + e.handle + ".json",
        success: function (n) {
          if (n && n.product)
            for (var i = n.product.variants, o = 0; o < i.length; o++) i[o].id == e.variantId && (e.price = i[o].price, spLog(e, "Successfully fetched latest price from Shopify product", !0));
          return t(e)
        },
        error: function (n) {
          return t(e)
        }
      })
    }

    function g(e, t) {
      var n = w("sp-validate-overlay", !0);
      b($, n, window.Shoppad.apps.infiniteoptions.validationEventName, {
        "io-shoppad-validate": !0,
        "io-shoppad-overlay": !0
      }, t), n.css({
        position: "absolute",
        display: "block",
        "z-index": "100000",
        cursor: "pointer",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0"
      }), e.css({
        position: "relative"
      }).append(n), window.Shoppad.apps.infiniteoptions.addToCartOverlay = n
    }

    function v(e) {
      var t = 0;
      if (window.Shoppad.apps.infiniteoptions.hideDynamicCheckout) return spLog(!0, "hideDynamicCheckout runtime config is set, hiding dynamic checkout buttons.", !0), $(".shopify-payment-button").attr("style", "display: none !important"), !0;

      function n(n) {
        var r, a;
        switch (n) {
          case "primary":
            r = ".shopify-payment-button__button", a = i;
            break;
          case "secondary":
            r = ".shopify-payment-button__more-options", a = o
        }
        if ($(r).length) {
          spLog(!0, "dynamic checkout: " + n + " button found, preventing submission until our options pass validation.", !0), clearInterval(a), y(e, n, r);
          var s = new MutationObserver(function (t) {
            (t[0].addedNodes.length || t[0].removedNodes.length && !$(r).length) && y(e, n, r)
          });
          s.observe($(".shopify-payment-button")[0], {
            childList: !0,
            subtree: !0
          })
        }
        t >= 9 && (spLog(!1, "dynamic checkout: unable to locate " + n + " dynamic checkout button after polling for 5 seconds.", !0), clearInterval(a)), t++
      }
      var i = setInterval(function () {
          n("primary")
        }, 500),
        o = setInterval(function () {
          n("secondary")
        }, 500)
    }

    function y(e, t, n) {
      var i, o;
      if ($(".sp-dynamic-checkout-button-" + t).length) {
        if (o = $(".sp-dynamic-checkout-button-" + t), overlayEvents = getEventData($, o[0]), overlayEvents && overlayEvents.click)
          for (var r = 0; r < overlayEvents.click.length; r++)
            if (overlayEvents.click[r].data["io-shoppad-validate"]) return !0
      } else o = w("sp-dynamic-checkout-button-" + t, !0), i = !0;
      b($, o, window.Shoppad.apps.infiniteoptions.validationEventName, {
        "io-shoppad-validate": !0,
        "io-dynamic-checkout-type": t
      }, e), i && $(n).css({
        position: "relative"
      }).append(o), o.data("io-dynamic-bound", !0);
      var a = getEventData($, o[0]);
      a && a.click && a.click.length > 1 && a.click.unshift(a.click.pop())
    }

    function w(e, t) {
      if ($overlay = $('<div class="' + e + '"></div>'), t) {
        var n = {
          all: {
            position: "absolute",
            display: "block",
            "z-index": "100",
            cursor: "pointer",
            top: "0",
            right: "0",
            bottom: "0",
            left: "0"
          }
        };
        $.each(n, function (e, t) {
          $overlay.css(t)
        })
      }
      return $overlay
    }

    function b(e, t, n, i, o) {
      e.fn.on ? t.on(n, i, o) : t.bind(n, i, o)
    }

    function x() {
      setTimeout(function () {
        var e = !1;
        "function" == typeof window.$ && (e = c(window.$)), e || "undefined" == typeof window.Shoppad || "undefined" == typeof window.Shoppad.$ || (e = c(window.Shoppad.$)), e ? spLog(e, "theme has custom validation", !0) : h()
      }, 100)
    }

    function C() {
      $('#infiniteoptions-container select[required="required"]').find('option[disabled="disabled"][selected="selected"]').prop("selected", "selected")
    }
    window.Shoppad && window.Shoppad.apps && window.Shoppad.apps.customizery && (window.Shoppad.apps.infiniteoptions = window.Shoppad.apps.customizery, delete window.Shoppad.apps.customizery);

    function S(e) {
      return customizeryConfig && customizeryConfig.optionSets && customizeryConfig.optionSets.length ? void e() : void $.ajax({
        method: "GET",
        url: cdnPath + "/option-sets.json?uuid=" + UUID,
        dataType: "json"
      }).done(function (t) {
        return t ? (customizeryConfig.optionSets = t, spLog(customizeryConfig.optionSets, "CONFIG (optionSets)", !0), void e()) : ("undefined" != typeof window.Sentry && Sentry.withScope(function (e) {
          e.setExtras({
            url: cdnPath + "/option-sets.json?uuid=" + UUID,
            response: t
          }), Sentry.captureMessage("No option sets retreived")
        }), void spLog(!0, "No option sets retreived", !0))
      }).fail(function () {
        "undefined" != typeof window.Sentry && Sentry.withScope(function (e) {
          e.setExtras({
            url: cdnPath + "/option-sets.json?uuid=" + UUID
          }), Sentry.captureMessage("Failed to get option sets")
        }), spLog(!0, "Failed to get option sets", !0), window.Shoppad.apps.infiniteoptions._running = !1
      })
    }

    function k(e, t) {
      customizeryRules.checkAllRules(customizeryConfig, "optionSets", e, function (n, i) {
        n && n.length ? (window.Shoppad.apps.infiniteoptions.activeProductId = i.id, priceMod.init({
          skipPriceModIfVisible: window.Shoppad.apps.infiniteoptions.skipPriceModIfVisible
        }), t || (t = "default"), conditionalLogicInstances[t] = new conditionalLogicFactory(window.Shoppad.$), r(n, e, t), x()) : (spLog(!0, "this page does not match options", !0), window && window.Shopify && window.Shopify.designMode && window.Shopify.designMode === !0 && $("#infiniteoptions-container").text("[Your Infinite Options fields will appear here]"), "function" == typeof window.Shoppad.apps.infiniteoptions.uploaderyReady && window.Shoppad.apps.infiniteoptions.uploaderyReady.call($("#infiniteoptions-container"), [])), window.Shoppad.apps.infiniteoptions._running = !1
      })
    }

    function T(e, n) {
      return window.Shoppad.apps.infiniteoptions._running ? void spLog(!0, "initCustomizery aborted since already running", !0) : (window.Shoppad.apps.infiniteoptions._running = !0, "function" == typeof window.Shoppad.apps.infiniteoptions.beforeReadyInternal && window.Shoppad.apps.infiniteoptions.beforeReadyInternal(eventApi.subscribe), "function" == typeof window.Shoppad.apps.infiniteoptions.beforeReady && window.Shoppad.apps.infiniteoptions.beforeReady(eventApi.subscribe), loadConfig ? void S(function () {
        k(e, n)
      }) : (spLog(customizeryConfig.optionSets, "CONFIG (optionSets)", !0), customizeryConfig.initializedTheme == customizeryConfig.currentTheme || window.Shoppad.pos || (spLog(!0, "Initialized theme does not match current theme", !0), $container = t(), $container && $container.length && $.ajax({
        method: "POST",
        url: cdnPath + "/detect-installation.json?uuid=" + UUID,
        dataType: "json"
      }).done(function (e) {
        spLog(!0, "Successfully called ShopPad server to confirm installation", !0)
      }).fail(function () {
        spLog(!0, "Failed to make call to ShopPad server to confirm installation", !0)
      })), void k(e, n)))
    }
    if (!(window.Shoppad && window.Shoppad.apps && window.Shoppad.apps.infiniteoptions && window.Shoppad.apps.infiniteoptions._initialized)) return window.Shoppad = $.extend(!0, {
      apps: {
        infiniteoptions: {
          _running: !1,
          _initialized: !0,
          _fieldsReady: !1,
          validate: null,
          validateType: null,
          jQueryKey: "jQuery",
          addToCartButton: "form[action$='/cart/add']:first [type=submit]",
          quantityInput: "[name='quantity']",
          validationEventName: "click",
          insertContainerAfter: null,
          themeAppExtensionActive: !1,
          themeAppExtensionId: null,
          themeName: null,
          activeProductId: null,
          toggleInputError: d,
          validateInput: l,
          getLatestVariantPrice: m,
          submitPriceModCartAnyways: !1,
          hideDynamicCheckout: !1,
          skipPriceModIfVisible: 'form[action$="/cart/add"] [type=submit] .secondary-text',
          errorStyles: {
            "background-color": "#fef6f5",
            color: "#666",
            "border-color": "#ff5d5d"
          },
          strings: {
            charactersRemaining: "Characters remaining",
            errorMessages: {
              forTextInputs: "Please add your personalized text before adding this item to cart.",
              forNumberInputs: "Please enter a number before adding this item to cart",
              forCheckboxes: "Please select your options before adding this item to cart",
              forMinimumValues: "Please select at least %valuesmin options before adding this item to cart",
              forDropdowns: "Please select an option before adding this item to cart",
              forDynamicCheckout: "This product cannot be purchased using this checkout method. Please add the item to cart, then proceed to checkout from the cart."
            }
          },
          debug: window.Shoppad && window.Shoppad.Cookies && "undefined" != typeof window.Shoppad.Cookies("infinite_options_debug")
        }
      }
    }, window.Shoppad), window.Shoppad.apps.infiniteoptions.priceMod = priceMod, window.Shoppad.apps.infiniteoptions.init = T, window.Shoppad.apps.infiniteoptions.reInitEvents = x, window.InstantClick && window.InstantClick.on("change", function () {
      T()
    }), $(document).on("shoppad:productViewLoaded", function (e) {
      spLog(!0, "shoppad:productViewLoaded", !0);
      var t = window.location.href.match("[^/]*$")[0];
      T(t)
    }), adminPreview.isPreviewActive() ? (adminPreview.insert("default"), void adminPreview.getPreviewConfig().then(function () {
      T()
    })["catch"](function () {
      T()
    })) : void($("div[data-infinite-options]").length ? $("div[data-infinite-options]").each(function (e) {
      var t = $(this).attr("data-infinite-options"),
        n = t + "_" + e;
      $(this).attr("data-infinite-options-container-id", n), T(t, n)
    }) : T())
  });
})();